"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetPropertyValue$ = exports.AssetPropertyTimestamp$ = exports.Allowed$ = exports.AlertTarget$ = exports.AggregationType$ = exports.AddThingToThingGroupResponse$ = exports.AddThingToThingGroupRequest$ = exports.AddThingToBillingGroupResponse$ = exports.AddThingToBillingGroupRequest$ = exports.AddThingsToThingGroupParams$ = exports.ActiveViolation$ = exports.Action$ = exports.AcceptCertificateTransferRequest$ = exports.AbortCriteria$ = exports.AbortConfig$ = exports.errorTypeRegistries = exports.VersionsLimitExceededException$ = exports.VersionConflictException$ = exports.ValidationException$ = exports.UnauthorizedException$ = exports.TransferConflictException$ = exports.TransferAlreadyCompletedException$ = exports.ThrottlingException$ = exports.TaskAlreadyExistsException$ = exports.SqlParseException$ = exports.ServiceUnavailableException$ = exports.ServiceQuotaExceededException$ = exports.ResourceRegistrationFailureException$ = exports.ResourceNotFoundException$ = exports.ResourceAlreadyExistsException$ = exports.RegistrationCodeValidationException$ = exports.NotConfiguredException$ = exports.MalformedPolicyException$ = exports.LimitExceededException$ = exports.InvalidStateTransitionException$ = exports.InvalidResponseException$ = exports.InvalidRequestException$ = exports.InvalidQueryException$ = exports.InvalidAggregationException$ = exports.InternalServerException$ = exports.InternalFailureException$ = exports.InternalException$ = exports.IndexNotReadyException$ = exports.DeleteConflictException$ = exports.ConflictingResourceUpdateException$ = exports.ConflictException$ = exports.CertificateValidationException$ = exports.CertificateStateException$ = exports.CertificateConflictException$ = exports.IoTServiceException$ = void 0;
exports.CancelDetectMitigationActionsTaskResponse$ = exports.CancelDetectMitigationActionsTaskRequest$ = exports.CancelCertificateTransferRequest$ = exports.CancelAuditTaskResponse$ = exports.CancelAuditTaskRequest$ = exports.CancelAuditMitigationActionsTaskResponse$ = exports.CancelAuditMitigationActionsTaskRequest$ = exports.CACertificateDescription$ = exports.CACertificate$ = exports.BucketsAggregationType$ = exports.Bucket$ = exports.BillingGroupProperties$ = exports.BillingGroupMetadata$ = exports.BehaviorModelTrainingSummary$ = exports.BehaviorCriteria$ = exports.Behavior$ = exports.BatchConfig$ = exports.AwsJsonSubstitutionCommandPreprocessorConfig$ = exports.AwsJobTimeoutConfig$ = exports.AwsJobRateIncreaseCriteria$ = exports.AwsJobPresignedUrlConfig$ = exports.AwsJobExponentialRolloutRate$ = exports.AwsJobExecutionsRolloutConfig$ = exports.AwsJobAbortCriteria$ = exports.AwsJobAbortConfig$ = exports.AuthResult$ = exports.AuthorizerSummary$ = exports.AuthorizerDescription$ = exports.AuthorizerConfig$ = exports.AuthInfo$ = exports.AuditTaskMetadata$ = exports.AuditSuppression$ = exports.AuditNotificationTarget$ = exports.AuditMitigationActionsTaskTarget$ = exports.AuditMitigationActionsTaskMetadata$ = exports.AuditMitigationActionExecutionMetadata$ = exports.AuditFinding$ = exports.AuditCheckDetails$ = exports.AuditCheckConfiguration$ = exports.AttributePayload$ = exports.AttachThingPrincipalResponse$ = exports.AttachThingPrincipalRequest$ = exports.AttachSecurityProfileResponse$ = exports.AttachSecurityProfileRequest$ = exports.AttachPrincipalPolicyRequest$ = exports.AttachPolicyRequest$ = exports.AssociateTargetsWithJobResponse$ = exports.AssociateTargetsWithJobRequest$ = exports.AssociateSbomWithPackageVersionResponse$ = exports.AssociateSbomWithPackageVersionRequest$ = void 0;
exports.CreateDynamicThingGroupResponse$ = exports.CreateDynamicThingGroupRequest$ = exports.CreateDomainConfigurationResponse$ = exports.CreateDomainConfigurationRequest$ = exports.CreateDimensionResponse$ = exports.CreateDimensionRequest$ = exports.CreateCustomMetricResponse$ = exports.CreateCustomMetricRequest$ = exports.CreateCommandResponse$ = exports.CreateCommandRequest$ = exports.CreateCertificateProviderResponse$ = exports.CreateCertificateProviderRequest$ = exports.CreateCertificateFromCsrResponse$ = exports.CreateCertificateFromCsrRequest$ = exports.CreateBillingGroupResponse$ = exports.CreateBillingGroupRequest$ = exports.CreateAuthorizerResponse$ = exports.CreateAuthorizerRequest$ = exports.CreateAuditSuppressionResponse$ = exports.CreateAuditSuppressionRequest$ = exports.ConfirmTopicRuleDestinationResponse$ = exports.ConfirmTopicRuleDestinationRequest$ = exports.ConfigurationDetails$ = exports.Configuration$ = exports.CommandSummary$ = exports.CommandPreprocessor$ = exports.CommandPayload$ = exports.CommandParameterValueNumberRange$ = exports.CommandParameterValueCondition$ = exports.CommandParameterValueComparisonOperand$ = exports.CommandParameterValue$ = exports.CommandParameter$ = exports.CommandExecutionSummary$ = exports.CommandExecutionResult$ = exports.CodeSigningSignature$ = exports.CodeSigningCertificateChain$ = exports.CodeSigning$ = exports.CloudwatchMetricAction$ = exports.CloudwatchLogsAction$ = exports.CloudwatchAlarmAction$ = exports.ClientCertificateConfig$ = exports.ClearDefaultAuthorizerResponse$ = exports.ClearDefaultAuthorizerRequest$ = exports.CertificateValidity$ = exports.CertificateProviderSummary$ = exports.CertificateDescription$ = exports.Certificate$ = exports.CancelJobResponse$ = exports.CancelJobRequest$ = exports.CancelJobExecutionRequest$ = void 0;
exports.DeleteAuthorizerResponse$ = exports.DeleteAuthorizerRequest$ = exports.DeleteAuditSuppressionResponse$ = exports.DeleteAuditSuppressionRequest$ = exports.DeleteAccountAuditConfigurationResponse$ = exports.DeleteAccountAuditConfigurationRequest$ = exports.CustomCodeSigning$ = exports.CreateTopicRuleRequest$ = exports.CreateTopicRuleDestinationResponse$ = exports.CreateTopicRuleDestinationRequest$ = exports.CreateThingTypeResponse$ = exports.CreateThingTypeRequest$ = exports.CreateThingResponse$ = exports.CreateThingRequest$ = exports.CreateThingGroupResponse$ = exports.CreateThingGroupRequest$ = exports.CreateStreamResponse$ = exports.CreateStreamRequest$ = exports.CreateSecurityProfileResponse$ = exports.CreateSecurityProfileRequest$ = exports.CreateScheduledAuditResponse$ = exports.CreateScheduledAuditRequest$ = exports.CreateRoleAliasResponse$ = exports.CreateRoleAliasRequest$ = exports.CreateProvisioningTemplateVersionResponse$ = exports.CreateProvisioningTemplateVersionRequest$ = exports.CreateProvisioningTemplateResponse$ = exports.CreateProvisioningTemplateRequest$ = exports.CreateProvisioningClaimResponse$ = exports.CreateProvisioningClaimRequest$ = exports.CreatePolicyVersionResponse$ = exports.CreatePolicyVersionRequest$ = exports.CreatePolicyResponse$ = exports.CreatePolicyRequest$ = exports.CreatePackageVersionResponse$ = exports.CreatePackageVersionRequest$ = exports.CreatePackageResponse$ = exports.CreatePackageRequest$ = exports.CreateOTAUpdateResponse$ = exports.CreateOTAUpdateRequest$ = exports.CreateMitigationActionResponse$ = exports.CreateMitigationActionRequest$ = exports.CreateKeysAndCertificateResponse$ = exports.CreateKeysAndCertificateRequest$ = exports.CreateJobTemplateResponse$ = exports.CreateJobTemplateRequest$ = exports.CreateJobResponse$ = exports.CreateJobRequest$ = exports.CreateFleetMetricResponse$ = exports.CreateFleetMetricRequest$ = void 0;
exports.DeleteThingRequest$ = exports.DeleteThingGroupResponse$ = exports.DeleteThingGroupRequest$ = exports.DeleteStreamResponse$ = exports.DeleteStreamRequest$ = exports.DeleteSecurityProfileResponse$ = exports.DeleteSecurityProfileRequest$ = exports.DeleteScheduledAuditResponse$ = exports.DeleteScheduledAuditRequest$ = exports.DeleteRoleAliasResponse$ = exports.DeleteRoleAliasRequest$ = exports.DeleteRegistrationCodeResponse$ = exports.DeleteRegistrationCodeRequest$ = exports.DeleteProvisioningTemplateVersionResponse$ = exports.DeleteProvisioningTemplateVersionRequest$ = exports.DeleteProvisioningTemplateResponse$ = exports.DeleteProvisioningTemplateRequest$ = exports.DeletePolicyVersionRequest$ = exports.DeletePolicyRequest$ = exports.DeletePackageVersionResponse$ = exports.DeletePackageVersionRequest$ = exports.DeletePackageResponse$ = exports.DeletePackageRequest$ = exports.DeleteOTAUpdateResponse$ = exports.DeleteOTAUpdateRequest$ = exports.DeleteMitigationActionResponse$ = exports.DeleteMitigationActionRequest$ = exports.DeleteJobTemplateRequest$ = exports.DeleteJobRequest$ = exports.DeleteJobExecutionRequest$ = exports.DeleteFleetMetricRequest$ = exports.DeleteDynamicThingGroupResponse$ = exports.DeleteDynamicThingGroupRequest$ = exports.DeleteDomainConfigurationResponse$ = exports.DeleteDomainConfigurationRequest$ = exports.DeleteDimensionResponse$ = exports.DeleteDimensionRequest$ = exports.DeleteCustomMetricResponse$ = exports.DeleteCustomMetricRequest$ = exports.DeleteCommandResponse$ = exports.DeleteCommandRequest$ = exports.DeleteCommandExecutionResponse$ = exports.DeleteCommandExecutionRequest$ = exports.DeleteCertificateRequest$ = exports.DeleteCertificateProviderResponse$ = exports.DeleteCertificateProviderRequest$ = exports.DeleteCACertificateResponse$ = exports.DeleteCACertificateRequest$ = exports.DeleteBillingGroupResponse$ = exports.DeleteBillingGroupRequest$ = void 0;
exports.DescribeIndexResponse$ = exports.DescribeIndexRequest$ = exports.DescribeFleetMetricResponse$ = exports.DescribeFleetMetricRequest$ = exports.DescribeEventConfigurationsResponse$ = exports.DescribeEventConfigurationsRequest$ = exports.DescribeEndpointResponse$ = exports.DescribeEndpointRequest$ = exports.DescribeEncryptionConfigurationResponse$ = exports.DescribeEncryptionConfigurationRequest$ = exports.DescribeDomainConfigurationResponse$ = exports.DescribeDomainConfigurationRequest$ = exports.DescribeDimensionResponse$ = exports.DescribeDimensionRequest$ = exports.DescribeDetectMitigationActionsTaskResponse$ = exports.DescribeDetectMitigationActionsTaskRequest$ = exports.DescribeDefaultAuthorizerResponse$ = exports.DescribeDefaultAuthorizerRequest$ = exports.DescribeCustomMetricResponse$ = exports.DescribeCustomMetricRequest$ = exports.DescribeCertificateResponse$ = exports.DescribeCertificateRequest$ = exports.DescribeCertificateProviderResponse$ = exports.DescribeCertificateProviderRequest$ = exports.DescribeCACertificateResponse$ = exports.DescribeCACertificateRequest$ = exports.DescribeBillingGroupResponse$ = exports.DescribeBillingGroupRequest$ = exports.DescribeAuthorizerResponse$ = exports.DescribeAuthorizerRequest$ = exports.DescribeAuditTaskResponse$ = exports.DescribeAuditTaskRequest$ = exports.DescribeAuditSuppressionResponse$ = exports.DescribeAuditSuppressionRequest$ = exports.DescribeAuditMitigationActionsTaskResponse$ = exports.DescribeAuditMitigationActionsTaskRequest$ = exports.DescribeAuditFindingResponse$ = exports.DescribeAuditFindingRequest$ = exports.DescribeAccountAuditConfigurationResponse$ = exports.DescribeAccountAuditConfigurationRequest$ = exports.DeprecateThingTypeResponse$ = exports.DeprecateThingTypeRequest$ = exports.Denied$ = exports.DeleteV2LoggingLevelRequest$ = exports.DeleteTopicRuleRequest$ = exports.DeleteTopicRuleDestinationResponse$ = exports.DeleteTopicRuleDestinationRequest$ = exports.DeleteThingTypeResponse$ = exports.DeleteThingTypeRequest$ = exports.DeleteThingResponse$ = void 0;
exports.ElasticsearchAction$ = exports.EffectivePolicy$ = exports.DynamoDBv2Action$ = exports.DynamoDBAction$ = exports.DomainConfigurationSummary$ = exports.DocumentParameter$ = exports.DisassociateSbomFromPackageVersionResponse$ = exports.DisassociateSbomFromPackageVersionRequest$ = exports.DisableTopicRuleRequest$ = exports.DetectMitigationActionsTaskTarget$ = exports.DetectMitigationActionsTaskSummary$ = exports.DetectMitigationActionsTaskStatistics$ = exports.DetectMitigationActionExecution$ = exports.DetachThingPrincipalResponse$ = exports.DetachThingPrincipalRequest$ = exports.DetachSecurityProfileResponse$ = exports.DetachSecurityProfileRequest$ = exports.DetachPrincipalPolicyRequest$ = exports.DetachPolicyRequest$ = exports.Destination$ = exports.DescribeThingTypeResponse$ = exports.DescribeThingTypeRequest$ = exports.DescribeThingResponse$ = exports.DescribeThingRequest$ = exports.DescribeThingRegistrationTaskResponse$ = exports.DescribeThingRegistrationTaskRequest$ = exports.DescribeThingGroupResponse$ = exports.DescribeThingGroupRequest$ = exports.DescribeStreamResponse$ = exports.DescribeStreamRequest$ = exports.DescribeSecurityProfileResponse$ = exports.DescribeSecurityProfileRequest$ = exports.DescribeScheduledAuditResponse$ = exports.DescribeScheduledAuditRequest$ = exports.DescribeRoleAliasResponse$ = exports.DescribeRoleAliasRequest$ = exports.DescribeProvisioningTemplateVersionResponse$ = exports.DescribeProvisioningTemplateVersionRequest$ = exports.DescribeProvisioningTemplateResponse$ = exports.DescribeProvisioningTemplateRequest$ = exports.DescribeMitigationActionResponse$ = exports.DescribeMitigationActionRequest$ = exports.DescribeManagedJobTemplateResponse$ = exports.DescribeManagedJobTemplateRequest$ = exports.DescribeJobTemplateResponse$ = exports.DescribeJobTemplateRequest$ = exports.DescribeJobResponse$ = exports.DescribeJobRequest$ = exports.DescribeJobExecutionResponse$ = exports.DescribeJobExecutionRequest$ = void 0;
exports.GetTopicRuleDestinationResponse$ = exports.GetTopicRuleDestinationRequest$ = exports.GetThingConnectivityDataResponse$ = exports.GetThingConnectivityDataRequest$ = exports.GetStatisticsResponse$ = exports.GetStatisticsRequest$ = exports.GetRegistrationCodeResponse$ = exports.GetRegistrationCodeRequest$ = exports.GetPolicyVersionResponse$ = exports.GetPolicyVersionRequest$ = exports.GetPolicyResponse$ = exports.GetPolicyRequest$ = exports.GetPercentilesResponse$ = exports.GetPercentilesRequest$ = exports.GetPackageVersionResponse$ = exports.GetPackageVersionRequest$ = exports.GetPackageResponse$ = exports.GetPackageRequest$ = exports.GetPackageConfigurationResponse$ = exports.GetPackageConfigurationRequest$ = exports.GetOTAUpdateResponse$ = exports.GetOTAUpdateRequest$ = exports.GetLoggingOptionsResponse$ = exports.GetLoggingOptionsRequest$ = exports.GetJobDocumentResponse$ = exports.GetJobDocumentRequest$ = exports.GetIndexingConfigurationResponse$ = exports.GetIndexingConfigurationRequest$ = exports.GetEffectivePoliciesResponse$ = exports.GetEffectivePoliciesRequest$ = exports.GetCommandResponse$ = exports.GetCommandRequest$ = exports.GetCommandExecutionResponse$ = exports.GetCommandExecutionRequest$ = exports.GetCardinalityResponse$ = exports.GetCardinalityRequest$ = exports.GetBucketsAggregationResponse$ = exports.GetBucketsAggregationRequest$ = exports.GetBehaviorModelTrainingSummariesResponse$ = exports.GetBehaviorModelTrainingSummariesRequest$ = exports.GeoLocationTarget$ = exports.FleetMetricNameAndArn$ = exports.FirehoseAction$ = exports.FileLocation$ = exports.Field$ = exports.ExponentialRolloutRate$ = exports.ExplicitDeny$ = exports.ErrorInfo$ = exports.EnableTopicRuleRequest$ = exports.EnableIoTLoggingParams$ = void 0;
exports.ListAuthorizersResponse$ = exports.ListAuthorizersRequest$ = exports.ListAuditTasksResponse$ = exports.ListAuditTasksRequest$ = exports.ListAuditSuppressionsResponse$ = exports.ListAuditSuppressionsRequest$ = exports.ListAuditMitigationActionsTasksResponse$ = exports.ListAuditMitigationActionsTasksRequest$ = exports.ListAuditMitigationActionsExecutionsResponse$ = exports.ListAuditMitigationActionsExecutionsRequest$ = exports.ListAuditFindingsResponse$ = exports.ListAuditFindingsRequest$ = exports.ListAttachedPoliciesResponse$ = exports.ListAttachedPoliciesRequest$ = exports.ListActiveViolationsResponse$ = exports.ListActiveViolationsRequest$ = exports.LambdaAction$ = exports.KinesisAction$ = exports.KeyPair$ = exports.KafkaActionHeader$ = exports.KafkaAction$ = exports.JobTemplateSummary$ = exports.JobSummary$ = exports.JobProcessDetails$ = exports.JobExecutionSummaryForThing$ = exports.JobExecutionSummaryForJob$ = exports.JobExecutionSummary$ = exports.JobExecutionStatusDetails$ = exports.JobExecutionsRolloutConfig$ = exports.JobExecutionsRetryConfig$ = exports.JobExecution$ = exports.Job$ = exports.IssuerCertificateIdentifier$ = exports.IotSiteWiseAction$ = exports.IotEventsAction$ = exports.IotAnalyticsAction$ = exports.IndexingFilter$ = exports.ImplicitDeny$ = exports.HttpUrlDestinationSummary$ = exports.HttpUrlDestinationProperties$ = exports.HttpUrlDestinationConfiguration$ = exports.HttpContext$ = exports.HttpAuthorization$ = exports.HttpActionHeader$ = exports.HttpAction$ = exports.GroupNameAndArn$ = exports.GetV2LoggingOptionsResponse$ = exports.GetV2LoggingOptionsRequest$ = exports.GetTopicRuleResponse$ = exports.GetTopicRuleRequest$ = void 0;
exports.ListPackageVersionsResponse$ = exports.ListPackageVersionsRequest$ = exports.ListPackagesResponse$ = exports.ListPackagesRequest$ = exports.ListOutgoingCertificatesResponse$ = exports.ListOutgoingCertificatesRequest$ = exports.ListOTAUpdatesResponse$ = exports.ListOTAUpdatesRequest$ = exports.ListMitigationActionsResponse$ = exports.ListMitigationActionsRequest$ = exports.ListMetricValuesResponse$ = exports.ListMetricValuesRequest$ = exports.ListManagedJobTemplatesResponse$ = exports.ListManagedJobTemplatesRequest$ = exports.ListJobTemplatesResponse$ = exports.ListJobTemplatesRequest$ = exports.ListJobsResponse$ = exports.ListJobsRequest$ = exports.ListJobExecutionsForThingResponse$ = exports.ListJobExecutionsForThingRequest$ = exports.ListJobExecutionsForJobResponse$ = exports.ListJobExecutionsForJobRequest$ = exports.ListIndicesResponse$ = exports.ListIndicesRequest$ = exports.ListFleetMetricsResponse$ = exports.ListFleetMetricsRequest$ = exports.ListDomainConfigurationsResponse$ = exports.ListDomainConfigurationsRequest$ = exports.ListDimensionsResponse$ = exports.ListDimensionsRequest$ = exports.ListDetectMitigationActionsTasksResponse$ = exports.ListDetectMitigationActionsTasksRequest$ = exports.ListDetectMitigationActionsExecutionsResponse$ = exports.ListDetectMitigationActionsExecutionsRequest$ = exports.ListCustomMetricsResponse$ = exports.ListCustomMetricsRequest$ = exports.ListCommandsResponse$ = exports.ListCommandsRequest$ = exports.ListCommandExecutionsResponse$ = exports.ListCommandExecutionsRequest$ = exports.ListCertificatesResponse$ = exports.ListCertificatesRequest$ = exports.ListCertificatesByCAResponse$ = exports.ListCertificatesByCARequest$ = exports.ListCertificateProvidersResponse$ = exports.ListCertificateProvidersRequest$ = exports.ListCACertificatesResponse$ = exports.ListCACertificatesRequest$ = exports.ListBillingGroupsResponse$ = exports.ListBillingGroupsRequest$ = void 0;
exports.ListThingsInBillingGroupResponse$ = exports.ListThingsInBillingGroupRequest$ = exports.ListThingRegistrationTasksResponse$ = exports.ListThingRegistrationTasksRequest$ = exports.ListThingRegistrationTaskReportsResponse$ = exports.ListThingRegistrationTaskReportsRequest$ = exports.ListThingPrincipalsV2Response$ = exports.ListThingPrincipalsV2Request$ = exports.ListThingPrincipalsResponse$ = exports.ListThingPrincipalsRequest$ = exports.ListThingGroupsResponse$ = exports.ListThingGroupsRequest$ = exports.ListThingGroupsForThingResponse$ = exports.ListThingGroupsForThingRequest$ = exports.ListTargetsForSecurityProfileResponse$ = exports.ListTargetsForSecurityProfileRequest$ = exports.ListTargetsForPolicyResponse$ = exports.ListTargetsForPolicyRequest$ = exports.ListTagsForResourceResponse$ = exports.ListTagsForResourceRequest$ = exports.ListStreamsResponse$ = exports.ListStreamsRequest$ = exports.ListSecurityProfilesResponse$ = exports.ListSecurityProfilesRequest$ = exports.ListSecurityProfilesForTargetResponse$ = exports.ListSecurityProfilesForTargetRequest$ = exports.ListScheduledAuditsResponse$ = exports.ListScheduledAuditsRequest$ = exports.ListSbomValidationResultsResponse$ = exports.ListSbomValidationResultsRequest$ = exports.ListRoleAliasesResponse$ = exports.ListRoleAliasesRequest$ = exports.ListRelatedResourcesForAuditFindingResponse$ = exports.ListRelatedResourcesForAuditFindingRequest$ = exports.ListProvisioningTemplateVersionsResponse$ = exports.ListProvisioningTemplateVersionsRequest$ = exports.ListProvisioningTemplatesResponse$ = exports.ListProvisioningTemplatesRequest$ = exports.ListPrincipalThingsV2Response$ = exports.ListPrincipalThingsV2Request$ = exports.ListPrincipalThingsResponse$ = exports.ListPrincipalThingsRequest$ = exports.ListPrincipalPoliciesResponse$ = exports.ListPrincipalPoliciesRequest$ = exports.ListPolicyVersionsResponse$ = exports.ListPolicyVersionsRequest$ = exports.ListPolicyPrincipalsResponse$ = exports.ListPolicyPrincipalsRequest$ = exports.ListPoliciesResponse$ = exports.ListPoliciesRequest$ = void 0;
exports.PropagatingAttribute$ = exports.PrincipalThingObject$ = exports.PresignedUrlConfig$ = exports.PolicyVersionIdentifier$ = exports.PolicyVersion$ = exports.Policy$ = exports.PercentPair$ = exports.PackageVersionSummary$ = exports.PackageVersionArtifact$ = exports.PackageSummary$ = exports.OutgoingCertificate$ = exports.OTAUpdateSummary$ = exports.OTAUpdateInfo$ = exports.OTAUpdateFile$ = exports.OpenSearchAction$ = exports.NonCompliantResource$ = exports.MqttHeaders$ = exports.MqttContext$ = exports.Mqtt5Configuration$ = exports.MitigationActionParams$ = exports.MitigationActionIdentifier$ = exports.MitigationAction$ = exports.MetricValue$ = exports.MetricToRetain$ = exports.MetricsExportConfig$ = exports.MetricDimension$ = exports.MetricDatum$ = exports.ManagedJobTemplateSummary$ = exports.MaintenanceWindow$ = exports.MachineLearningDetectionConfig$ = exports.LogTargetConfiguration$ = exports.LogTarget$ = exports.LoggingOptionsPayload$ = exports.LogEventConfiguration$ = exports.LocationTimestamp$ = exports.LocationAction$ = exports.ListViolationEventsResponse$ = exports.ListViolationEventsRequest$ = exports.ListV2LoggingLevelsResponse$ = exports.ListV2LoggingLevelsRequest$ = exports.ListTopicRulesResponse$ = exports.ListTopicRulesRequest$ = exports.ListTopicRuleDestinationsResponse$ = exports.ListTopicRuleDestinationsRequest$ = exports.ListThingTypesResponse$ = exports.ListThingTypesRequest$ = exports.ListThingsResponse$ = exports.ListThingsRequest$ = exports.ListThingsInThingGroupResponse$ = exports.ListThingsInThingGroupRequest$ = void 0;
exports.SetLoggingOptionsRequest$ = exports.SetDefaultPolicyVersionRequest$ = exports.SetDefaultAuthorizerResponse$ = exports.SetDefaultAuthorizerRequest$ = exports.ServerCertificateSummary$ = exports.ServerCertificateConfig$ = exports.SecurityProfileTargetMapping$ = exports.SecurityProfileTarget$ = exports.SecurityProfileIdentifier$ = exports.SearchIndexResponse$ = exports.SearchIndexRequest$ = exports.SchedulingConfig$ = exports.ScheduledJobRollout$ = exports.ScheduledAuditMetadata$ = exports.SbomValidationResultSummary$ = exports.Sbom$ = exports.SalesforceAction$ = exports.S3Location$ = exports.S3Destination$ = exports.S3Action$ = exports.RoleAliasDescription$ = exports.RetryCriteria$ = exports.ResourceIdentifier$ = exports.RepublishAction$ = exports.ReplaceTopicRuleRequest$ = exports.ReplaceDefaultPolicyVersionParams$ = exports.RemoveThingFromThingGroupResponse$ = exports.RemoveThingFromThingGroupRequest$ = exports.RemoveThingFromBillingGroupResponse$ = exports.RemoveThingFromBillingGroupRequest$ = exports.RelatedResource$ = exports.RejectCertificateTransferRequest$ = exports.RegistrationConfig$ = exports.RegisterThingResponse$ = exports.RegisterThingRequest$ = exports.RegisterCertificateWithoutCAResponse$ = exports.RegisterCertificateWithoutCARequest$ = exports.RegisterCertificateResponse$ = exports.RegisterCertificateRequest$ = exports.RegisterCACertificateResponse$ = exports.RegisterCACertificateRequest$ = exports.RateIncreaseCriteria$ = exports.PutVerificationStateOnViolationResponse$ = exports.PutVerificationStateOnViolationRequest$ = exports.PutItemInput$ = exports.PutAssetPropertyValueEntry$ = exports.PublishFindingToSnsParams$ = exports.ProvisioningTemplateVersionSummary$ = exports.ProvisioningTemplateSummary$ = exports.ProvisioningHook$ = void 0;
exports.TimestreamAction$ = exports.TimeoutConfig$ = exports.TimeFilter$ = exports.ThingTypeProperties$ = exports.ThingTypeMetadata$ = exports.ThingTypeDefinition$ = exports.ThingPrincipalObject$ = exports.ThingIndexingConfiguration$ = exports.ThingGroupProperties$ = exports.ThingGroupMetadata$ = exports.ThingGroupIndexingConfiguration$ = exports.ThingGroupDocument$ = exports.ThingDocument$ = exports.ThingConnectivity$ = exports.ThingAttribute$ = exports.TestInvokeAuthorizerResponse$ = exports.TestInvokeAuthorizerRequest$ = exports.TestAuthorizationResponse$ = exports.TestAuthorizationRequest$ = exports.TermsAggregation$ = exports.TaskStatisticsForAuditCheck$ = exports.TaskStatistics$ = exports.TagResourceResponse$ = exports.TagResourceRequest$ = exports.Tag$ = exports.StreamSummary$ = exports.StreamInfo$ = exports.StreamFile$ = exports._Stream$ = exports.StopThingRegistrationTaskResponse$ = exports.StopThingRegistrationTaskRequest$ = exports.StepFunctionsAction$ = exports.StatusReason$ = exports.Statistics$ = exports.StatisticalThreshold$ = exports.StartThingRegistrationTaskResponse$ = exports.StartThingRegistrationTaskRequest$ = exports.StartSigningJobParameter$ = exports.StartOnDemandAuditTaskResponse$ = exports.StartOnDemandAuditTaskRequest$ = exports.StartDetectMitigationActionsTaskResponse$ = exports.StartDetectMitigationActionsTaskRequest$ = exports.StartAuditMitigationActionsTaskResponse$ = exports.StartAuditMitigationActionsTaskRequest$ = exports.SqsAction$ = exports.SnsAction$ = exports.SigV4Authorization$ = exports.SigningProfileParameter$ = exports.SetV2LoggingOptionsRequest$ = exports.SetV2LoggingLevelRequest$ = void 0;
exports.UpdatePackageConfigurationRequest$ = exports.UpdateMitigationActionResponse$ = exports.UpdateMitigationActionRequest$ = exports.UpdateJobRequest$ = exports.UpdateIndexingConfigurationResponse$ = exports.UpdateIndexingConfigurationRequest$ = exports.UpdateFleetMetricRequest$ = exports.UpdateEventConfigurationsResponse$ = exports.UpdateEventConfigurationsRequest$ = exports.UpdateEncryptionConfigurationResponse$ = exports.UpdateEncryptionConfigurationRequest$ = exports.UpdateDynamicThingGroupResponse$ = exports.UpdateDynamicThingGroupRequest$ = exports.UpdateDomainConfigurationResponse$ = exports.UpdateDomainConfigurationRequest$ = exports.UpdateDimensionResponse$ = exports.UpdateDimensionRequest$ = exports.UpdateDeviceCertificateParams$ = exports.UpdateCustomMetricResponse$ = exports.UpdateCustomMetricRequest$ = exports.UpdateCommandResponse$ = exports.UpdateCommandRequest$ = exports.UpdateCertificateRequest$ = exports.UpdateCertificateProviderResponse$ = exports.UpdateCertificateProviderRequest$ = exports.UpdateCACertificateRequest$ = exports.UpdateCACertificateParams$ = exports.UpdateBillingGroupResponse$ = exports.UpdateBillingGroupRequest$ = exports.UpdateAuthorizerResponse$ = exports.UpdateAuthorizerRequest$ = exports.UpdateAuditSuppressionResponse$ = exports.UpdateAuditSuppressionRequest$ = exports.UpdateAccountAuditConfigurationResponse$ = exports.UpdateAccountAuditConfigurationRequest$ = exports.UntagResourceResponse$ = exports.UntagResourceRequest$ = exports.TransferData$ = exports.TransferCertificateResponse$ = exports.TransferCertificateRequest$ = exports.TopicRulePayload$ = exports.TopicRuleListItem$ = exports.TopicRuleDestinationSummary$ = exports.TopicRuleDestinationConfiguration$ = exports.TopicRuleDestination$ = exports.TopicRule$ = exports.TlsContext$ = exports.TlsConfig$ = exports.TimestreamTimestamp$ = exports.TimestreamDimension$ = void 0;
exports.CancelDetectMitigationActionsTask$ = exports.CancelCertificateTransfer$ = exports.CancelAuditTask$ = exports.CancelAuditMitigationActionsTask$ = exports.AttachThingPrincipal$ = exports.AttachSecurityProfile$ = exports.AttachPrincipalPolicy$ = exports.AttachPolicy$ = exports.AssociateTargetsWithJob$ = exports.AssociateSbomWithPackageVersion$ = exports.AddThingToThingGroup$ = exports.AddThingToBillingGroup$ = exports.AcceptCertificateTransfer$ = exports.AssetPropertyVariant$ = exports.VpcDestinationSummary$ = exports.VpcDestinationProperties$ = exports.VpcDestinationConfiguration$ = exports.ViolationEventOccurrenceRange$ = exports.ViolationEventAdditionalInfo$ = exports.ViolationEvent$ = exports.VersionUpdateByJobsConfig$ = exports.ValidationError$ = exports.ValidateSecurityProfileBehaviorsResponse$ = exports.ValidateSecurityProfileBehaviorsRequest$ = exports.UserProperty$ = exports.UpdateTopicRuleDestinationResponse$ = exports.UpdateTopicRuleDestinationRequest$ = exports.UpdateThingTypeResponse$ = exports.UpdateThingTypeRequest$ = exports.UpdateThingResponse$ = exports.UpdateThingRequest$ = exports.UpdateThingGroupsForThingResponse$ = exports.UpdateThingGroupsForThingRequest$ = exports.UpdateThingGroupResponse$ = exports.UpdateThingGroupRequest$ = exports.UpdateStreamResponse$ = exports.UpdateStreamRequest$ = exports.UpdateSecurityProfileResponse$ = exports.UpdateSecurityProfileRequest$ = exports.UpdateScheduledAuditResponse$ = exports.UpdateScheduledAuditRequest$ = exports.UpdateRoleAliasResponse$ = exports.UpdateRoleAliasRequest$ = exports.UpdateProvisioningTemplateResponse$ = exports.UpdateProvisioningTemplateRequest$ = exports.UpdatePackageVersionResponse$ = exports.UpdatePackageVersionRequest$ = exports.UpdatePackageResponse$ = exports.UpdatePackageRequest$ = exports.UpdatePackageConfigurationResponse$ = void 0;
exports.DeleteFleetMetric$ = exports.DeleteDynamicThingGroup$ = exports.DeleteDomainConfiguration$ = exports.DeleteDimension$ = exports.DeleteCustomMetric$ = exports.DeleteCommandExecution$ = exports.DeleteCommand$ = exports.DeleteCertificateProvider$ = exports.DeleteCertificate$ = exports.DeleteCACertificate$ = exports.DeleteBillingGroup$ = exports.DeleteAuthorizer$ = exports.DeleteAuditSuppression$ = exports.DeleteAccountAuditConfiguration$ = exports.CreateTopicRuleDestination$ = exports.CreateTopicRule$ = exports.CreateThingType$ = exports.CreateThingGroup$ = exports.CreateThing$ = exports.CreateStream$ = exports.CreateSecurityProfile$ = exports.CreateScheduledAudit$ = exports.CreateRoleAlias$ = exports.CreateProvisioningTemplateVersion$ = exports.CreateProvisioningTemplate$ = exports.CreateProvisioningClaim$ = exports.CreatePolicyVersion$ = exports.CreatePolicy$ = exports.CreatePackageVersion$ = exports.CreatePackage$ = exports.CreateOTAUpdate$ = exports.CreateMitigationAction$ = exports.CreateKeysAndCertificate$ = exports.CreateJobTemplate$ = exports.CreateJob$ = exports.CreateFleetMetric$ = exports.CreateDynamicThingGroup$ = exports.CreateDomainConfiguration$ = exports.CreateDimension$ = exports.CreateCustomMetric$ = exports.CreateCommand$ = exports.CreateCertificateProvider$ = exports.CreateCertificateFromCsr$ = exports.CreateBillingGroup$ = exports.CreateAuthorizer$ = exports.CreateAuditSuppression$ = exports.ConfirmTopicRuleDestination$ = exports.ClearDefaultAuthorizer$ = exports.CancelJobExecution$ = exports.CancelJob$ = void 0;
exports.DescribeProvisioningTemplateVersion$ = exports.DescribeProvisioningTemplate$ = exports.DescribeMitigationAction$ = exports.DescribeManagedJobTemplate$ = exports.DescribeJobTemplate$ = exports.DescribeJobExecution$ = exports.DescribeJob$ = exports.DescribeIndex$ = exports.DescribeFleetMetric$ = exports.DescribeEventConfigurations$ = exports.DescribeEndpoint$ = exports.DescribeEncryptionConfiguration$ = exports.DescribeDomainConfiguration$ = exports.DescribeDimension$ = exports.DescribeDetectMitigationActionsTask$ = exports.DescribeDefaultAuthorizer$ = exports.DescribeCustomMetric$ = exports.DescribeCertificateProvider$ = exports.DescribeCertificate$ = exports.DescribeCACertificate$ = exports.DescribeBillingGroup$ = exports.DescribeAuthorizer$ = exports.DescribeAuditTask$ = exports.DescribeAuditSuppression$ = exports.DescribeAuditMitigationActionsTask$ = exports.DescribeAuditFinding$ = exports.DescribeAccountAuditConfiguration$ = exports.DeprecateThingType$ = exports.DeleteV2LoggingLevel$ = exports.DeleteTopicRuleDestination$ = exports.DeleteTopicRule$ = exports.DeleteThingType$ = exports.DeleteThingGroup$ = exports.DeleteThing$ = exports.DeleteStream$ = exports.DeleteSecurityProfile$ = exports.DeleteScheduledAudit$ = exports.DeleteRoleAlias$ = exports.DeleteRegistrationCode$ = exports.DeleteProvisioningTemplateVersion$ = exports.DeleteProvisioningTemplate$ = exports.DeletePolicyVersion$ = exports.DeletePolicy$ = exports.DeletePackageVersion$ = exports.DeletePackage$ = exports.DeleteOTAUpdate$ = exports.DeleteMitigationAction$ = exports.DeleteJobTemplate$ = exports.DeleteJobExecution$ = exports.DeleteJob$ = void 0;
exports.ListCertificatesByCA$ = exports.ListCertificates$ = exports.ListCertificateProviders$ = exports.ListCACertificates$ = exports.ListBillingGroups$ = exports.ListAuthorizers$ = exports.ListAuditTasks$ = exports.ListAuditSuppressions$ = exports.ListAuditMitigationActionsTasks$ = exports.ListAuditMitigationActionsExecutions$ = exports.ListAuditFindings$ = exports.ListAttachedPolicies$ = exports.ListActiveViolations$ = exports.GetV2LoggingOptions$ = exports.GetTopicRuleDestination$ = exports.GetTopicRule$ = exports.GetThingConnectivityData$ = exports.GetStatistics$ = exports.GetRegistrationCode$ = exports.GetPolicyVersion$ = exports.GetPolicy$ = exports.GetPercentiles$ = exports.GetPackageVersion$ = exports.GetPackageConfiguration$ = exports.GetPackage$ = exports.GetOTAUpdate$ = exports.GetLoggingOptions$ = exports.GetJobDocument$ = exports.GetIndexingConfiguration$ = exports.GetEffectivePolicies$ = exports.GetCommandExecution$ = exports.GetCommand$ = exports.GetCardinality$ = exports.GetBucketsAggregation$ = exports.GetBehaviorModelTrainingSummaries$ = exports.EnableTopicRule$ = exports.DisassociateSbomFromPackageVersion$ = exports.DisableTopicRule$ = exports.DetachThingPrincipal$ = exports.DetachSecurityProfile$ = exports.DetachPrincipalPolicy$ = exports.DetachPolicy$ = exports.DescribeThingType$ = exports.DescribeThingRegistrationTask$ = exports.DescribeThingGroup$ = exports.DescribeThing$ = exports.DescribeStream$ = exports.DescribeSecurityProfile$ = exports.DescribeScheduledAudit$ = exports.DescribeRoleAlias$ = void 0;
exports.ListTopicRules$ = exports.ListTopicRuleDestinations$ = exports.ListThingTypes$ = exports.ListThingsInThingGroup$ = exports.ListThingsInBillingGroup$ = exports.ListThings$ = exports.ListThingRegistrationTasks$ = exports.ListThingRegistrationTaskReports$ = exports.ListThingPrincipalsV2$ = exports.ListThingPrincipals$ = exports.ListThingGroupsForThing$ = exports.ListThingGroups$ = exports.ListTargetsForSecurityProfile$ = exports.ListTargetsForPolicy$ = exports.ListTagsForResource$ = exports.ListStreams$ = exports.ListSecurityProfilesForTarget$ = exports.ListSecurityProfiles$ = exports.ListScheduledAudits$ = exports.ListSbomValidationResults$ = exports.ListRoleAliases$ = exports.ListRelatedResourcesForAuditFinding$ = exports.ListProvisioningTemplateVersions$ = exports.ListProvisioningTemplates$ = exports.ListPrincipalThingsV2$ = exports.ListPrincipalThings$ = exports.ListPrincipalPolicies$ = exports.ListPolicyVersions$ = exports.ListPolicyPrincipals$ = exports.ListPolicies$ = exports.ListPackageVersions$ = exports.ListPackages$ = exports.ListOutgoingCertificates$ = exports.ListOTAUpdates$ = exports.ListMitigationActions$ = exports.ListMetricValues$ = exports.ListManagedJobTemplates$ = exports.ListJobTemplates$ = exports.ListJobs$ = exports.ListJobExecutionsForThing$ = exports.ListJobExecutionsForJob$ = exports.ListIndices$ = exports.ListFleetMetrics$ = exports.ListDomainConfigurations$ = exports.ListDimensions$ = exports.ListDetectMitigationActionsTasks$ = exports.ListDetectMitigationActionsExecutions$ = exports.ListCustomMetrics$ = exports.ListCommands$ = exports.ListCommandExecutions$ = void 0;
exports.UpdateRoleAlias$ = exports.UpdateProvisioningTemplate$ = exports.UpdatePackageVersion$ = exports.UpdatePackageConfiguration$ = exports.UpdatePackage$ = exports.UpdateMitigationAction$ = exports.UpdateJob$ = exports.UpdateIndexingConfiguration$ = exports.UpdateFleetMetric$ = exports.UpdateEventConfigurations$ = exports.UpdateEncryptionConfiguration$ = exports.UpdateDynamicThingGroup$ = exports.UpdateDomainConfiguration$ = exports.UpdateDimension$ = exports.UpdateCustomMetric$ = exports.UpdateCommand$ = exports.UpdateCertificateProvider$ = exports.UpdateCertificate$ = exports.UpdateCACertificate$ = exports.UpdateBillingGroup$ = exports.UpdateAuthorizer$ = exports.UpdateAuditSuppression$ = exports.UpdateAccountAuditConfiguration$ = exports.UntagResource$ = exports.TransferCertificate$ = exports.TestInvokeAuthorizer$ = exports.TestAuthorization$ = exports.TagResource$ = exports.StopThingRegistrationTask$ = exports.StartThingRegistrationTask$ = exports.StartOnDemandAuditTask$ = exports.StartDetectMitigationActionsTask$ = exports.StartAuditMitigationActionsTask$ = exports.SetV2LoggingOptions$ = exports.SetV2LoggingLevel$ = exports.SetLoggingOptions$ = exports.SetDefaultPolicyVersion$ = exports.SetDefaultAuthorizer$ = exports.SearchIndex$ = exports.ReplaceTopicRule$ = exports.RemoveThingFromThingGroup$ = exports.RemoveThingFromBillingGroup$ = exports.RejectCertificateTransfer$ = exports.RegisterThing$ = exports.RegisterCertificateWithoutCA$ = exports.RegisterCertificate$ = exports.RegisterCACertificate$ = exports.PutVerificationStateOnViolation$ = exports.ListViolationEvents$ = exports.ListV2LoggingLevels$ = void 0;
exports.ValidateSecurityProfileBehaviors$ = exports.UpdateTopicRuleDestination$ = exports.UpdateThingType$ = exports.UpdateThingGroupsForThing$ = exports.UpdateThingGroup$ = exports.UpdateThing$ = exports.UpdateStream$ = exports.UpdateSecurityProfile$ = exports.UpdateScheduledAudit$ = void 0;
const _A = "Action";
const _AC = "AbortConfig";
const _ACC = "AuditCheckConfiguration";
const _ACCu = "AuditCheckConfigurations";
const _ACD = "AuditCheckDetails";
const _ACL = "AbortCriteriaList";
const _ACT = "AcceptCertificateTransfer";
const _ACTAM = "AuditCheckToActionsMapping";
const _ACTR = "AcceptCertificateTransferRequest";
const _ACTRCF = "AuditCheckToReasonCodeFilter";
const _ACb = "AbortCriteria";
const _ACu = "AuthorizerConfig";
const _AD = "AuthorizerDescription";
const _ADu = "AuditDetails";
const _AF = "AuditFinding";
const _AFu = "AuditFindings";
const _AI = "AuthInfo";
const _AIu = "AuthInfos";
const _AJAC = "AwsJobAbortConfig";
const _AJACL = "AwsJobAbortCriteriaList";
const _AJACw = "AwsJobAbortCriteria";
const _AJERC = "AwsJobExecutionsRolloutConfig";
const _AJERR = "AwsJobExponentialRolloutRate";
const _AJPUC = "AwsJobPresignedUrlConfig";
const _AJRIC = "AwsJobRateIncreaseCriteria";
const _AJSCPC = "AwsJsonSubstitutionCommandPreprocessorConfig";
const _AJTC = "AwsJobTimeoutConfig";
const _AL = "ActionList";
const _AMAEM = "AuditMitigationActionExecutionMetadata";
const _AMAEML = "AuditMitigationActionExecutionMetadataList";
const _AMATM = "AuditMitigationActionsTaskMetadata";
const _AMATML = "AuditMitigationActionsTaskMetadataList";
const _AMATS = "AuditMitigationActionsTaskStatistics";
const _AMATT = "AuditMitigationActionsTaskTarget";
const _AMTRVL = "AdditionalMetricsToRetainV2List";
const _ANT = "AuditNotificationTarget";
const _ANTC = "AuditNotificationTargetConfigurations";
const _AP = "AttributePayload";
const _APP = "AttachPrincipalPolicy";
const _APPR = "AttachPrincipalPolicyRequest";
const _APR = "AttachPolicyRequest";
const _APT = "AssetPropertyTimestamp";
const _APV = "AssetPropertyValue";
const _APVL = "AssetPropertyValueList";
const _APVs = "AssetPropertyVariant";
const _APt = "AttachPolicy";
const _AR = "AuthResult";
const _ARu = "AuthResults";
const _AS = "AuditSuppression";
const _ASL = "AuditSuppressionList";
const _ASP = "AttachSecurityProfile";
const _ASPR = "AttachSecurityProfileRequest";
const _ASPRt = "AttachSecurityProfileResponse";
const _ASWPV = "AssociateSbomWithPackageVersion";
const _ASWPVR = "AssociateSbomWithPackageVersionRequest";
const _ASWPVRs = "AssociateSbomWithPackageVersionResponse";
const _ASu = "AuthorizerSummary";
const _AT = "AggregationType";
const _ATM = "AuditTaskMetadata";
const _ATML = "AuditTaskMetadataList";
const _ATP = "AttachThingPrincipal";
const _ATPR = "AttachThingPrincipalRequest";
const _ATPRt = "AttachThingPrincipalResponse";
const _ATTBG = "AddThingToBillingGroup";
const _ATTBGR = "AddThingToBillingGroupRequest";
const _ATTBGRd = "AddThingToBillingGroupResponse";
const _ATTTG = "AddThingToThingGroup";
const _ATTTGP = "AddThingsToThingGroupParams";
const _ATTTGR = "AddThingToThingGroupRequest";
const _ATTTGRd = "AddThingToThingGroupResponse";
const _ATWJ = "AssociateTargetsWithJob";
const _ATWJR = "AssociateTargetsWithJobRequest";
const _ATWJRs = "AssociateTargetsWithJobResponse";
const _ATl = "AlertTarget";
const _ATle = "AlertTargets";
const _AV = "ActiveViolation";
const _AVc = "ActiveViolations";
const _Al = "Allowed";
const _Au = "Authorizers";
const _B = "Behavior";
const _BAT = "BucketsAggregationType";
const _BC = "BatchConfig";
const _BCe = "BehaviorCriteria";
const _BGM = "BillingGroupMetadata";
const _BGNAAL = "BillingGroupNameAndArnList";
const _BGP = "BillingGroupProperties";
const _BIN = "BIN";
const _BMTS = "BehaviorModelTrainingSummary";
const _BMTSe = "BehaviorModelTrainingSummaries";
const _B_ = "B";
const _Be = "Behaviors";
const _Bu = "Bucket";
const _Buc = "Buckets";
const _C = "Certificate";
const _CA = "CreateAuthorizer";
const _CAA = "CloudwatchAlarmAction";
const _CAC = "CACertificate";
const _CACD = "CACertificateDescription";
const _CACe = "CACertificates";
const _CAMAT = "CancelAuditMitigationActionsTask";
const _CAMATR = "CancelAuditMitigationActionsTaskRequest";
const _CAMATRa = "CancelAuditMitigationActionsTaskResponse";
const _CAR = "CreateAuthorizerRequest";
const _CARr = "CreateAuthorizerResponse";
const _CAS = "CreateAuditSuppression";
const _CASR = "CreateAuditSuppressionRequest";
const _CASRr = "CreateAuditSuppressionResponse";
const _CAT = "CancelAuditTask";
const _CATN = "ConnectivityApiThingName";
const _CATR = "CancelAuditTaskRequest";
const _CATRa = "CancelAuditTaskResponse";
const _CBG = "CreateBillingGroup";
const _CBGR = "CreateBillingGroupRequest";
const _CBGRr = "CreateBillingGroupResponse";
const _CC = "CreateCommand";
const _CCC = "ClientCertificateConfig";
const _CCE = "CertificateConflictException";
const _CCFC = "CreateCertificateFromCsr";
const _CCFCR = "CreateCertificateFromCsrRequest";
const _CCFCRr = "CreateCertificateFromCsrResponse";
const _CCM = "CreateCustomMetric";
const _CCMR = "CreateCustomMetricRequest";
const _CCMRr = "CreateCustomMetricResponse";
const _CCP = "CreateCertificateProvider";
const _CCPR = "CreateCertificateProviderRequest";
const _CCPRr = "CreateCertificateProviderResponse";
const _CCR = "CreateCommandRequest";
const _CCRr = "CreateCommandResponse";
const _CCS = "CustomCodeSigning";
const _CCT = "CancelCertificateTransfer";
const _CCTR = "CancelCertificateTransferRequest";
const _CD = "CertificateDescription";
const _CDA = "ClearDefaultAuthorizer";
const _CDAR = "ClearDefaultAuthorizerRequest";
const _CDARl = "ClearDefaultAuthorizerResponse";
const _CDC = "CreateDomainConfiguration";
const _CDCR = "CreateDomainConfigurationRequest";
const _CDCRr = "CreateDomainConfigurationResponse";
const _CDMAT = "CancelDetectMitigationActionsTask";
const _CDMATR = "CancelDetectMitigationActionsTaskRequest";
const _CDMATRa = "CancelDetectMitigationActionsTaskResponse";
const _CDR = "CreateDimensionRequest";
const _CDRr = "CreateDimensionResponse";
const _CDTG = "CreateDynamicThingGroup";
const _CDTGR = "CreateDynamicThingGroupRequest";
const _CDTGRr = "CreateDynamicThingGroupResponse";
const _CDo = "ConfigurationDetails";
const _CDr = "CreateDimension";
const _CE = "ConflictException";
const _CEPM = "CommandExecutionParameterMap";
const _CER = "CommandExecutionResult";
const _CERM = "CommandExecutionResultMap";
const _CES = "CommandExecutionSummary";
const _CESL = "CommandExecutionSummaryList";
const _CFM = "CreateFleetMetric";
const _CFMR = "CreateFleetMetricRequest";
const _CFMRr = "CreateFleetMetricResponse";
const _CJ = "CancelJob";
const _CJE = "CancelJobExecution";
const _CJER = "CancelJobExecutionRequest";
const _CJR = "CancelJobRequest";
const _CJRa = "CancelJobResponse";
const _CJRr = "CreateJobRequest";
const _CJRre = "CreateJobResponse";
const _CJT = "CreateJobTemplate";
const _CJTR = "CreateJobTemplateRequest";
const _CJTRr = "CreateJobTemplateResponse";
const _CJr = "CreateJob";
const _CKAC = "CreateKeysAndCertificate";
const _CKACR = "CreateKeysAndCertificateRequest";
const _CKACRr = "CreateKeysAndCertificateResponse";
const _CLA = "CloudwatchLogsAction";
const _CMA = "CloudwatchMetricAction";
const _CMAR = "CreateMitigationActionRequest";
const _CMARr = "CreateMitigationActionResponse";
const _CMAr = "CreateMitigationAction";
const _COTAU = "CreateOTAUpdate";
const _COTAUR = "CreateOTAUpdateRequest";
const _COTAURr = "CreateOTAUpdateResponse";
const _CP = "CommandParameter";
const _CPC = "CreateProvisioningClaim";
const _CPCR = "CreateProvisioningClaimRequest";
const _CPCRr = "CreateProvisioningClaimResponse";
const _CPL = "CommandParameterList";
const _CPR = "CreatePackageRequest";
const _CPRr = "CreatePackageResponse";
const _CPRre = "CreatePolicyRequest";
const _CPRrea = "CreatePolicyResponse";
const _CPS = "CertificateProviderSummary";
const _CPT = "CreateProvisioningTemplate";
const _CPTR = "CreateProvisioningTemplateRequest";
const _CPTRr = "CreateProvisioningTemplateResponse";
const _CPTV = "CreateProvisioningTemplateVersion";
const _CPTVR = "CreateProvisioningTemplateVersionRequest";
const _CPTVRr = "CreateProvisioningTemplateVersionResponse";
const _CPV = "CommandParameterValue";
const _CPVC = "CommandParameterValueCondition";
const _CPVCL = "CommandParameterValueConditionList";
const _CPVCO = "CommandParameterValueComparisonOperand";
const _CPVNR = "CommandParameterValueNumberRange";
const _CPVR = "CreatePackageVersionRequest";
const _CPVRr = "CreatePackageVersionResponse";
const _CPVRre = "CreatePolicyVersionRequest";
const _CPVRrea = "CreatePolicyVersionResponse";
const _CPVr = "CreatePackageVersion";
const _CPVre = "CreatePolicyVersion";
const _CPe = "CertificateProviders";
const _CPo = "CommandPayload";
const _CPom = "CommandPreprocessor";
const _CPr = "CreatePackage";
const _CPre = "CreatePolicy";
const _CRA = "CreateRoleAlias";
const _CRAR = "CreateRoleAliasRequest";
const _CRARr = "CreateRoleAliasResponse";
const _CRUE = "ConflictingResourceUpdateException";
const _CS = "CodeSigning";
const _CSA = "CreateScheduledAudit";
const _CSAR = "CreateScheduledAuditRequest";
const _CSARr = "CreateScheduledAuditResponse";
const _CSCC = "CodeSigningCertificateChain";
const _CSE = "CertificateStateException";
const _CSL = "CommandSummaryList";
const _CSP = "CreateSecurityProfile";
const _CSPR = "CreateSecurityProfileRequest";
const _CSPRr = "CreateSecurityProfileResponse";
const _CSR = "CreateStreamRequest";
const _CSRr = "CreateStreamResponse";
const _CSS = "CodeSigningSignature";
const _CSo = "CommandSummary";
const _CSr = "CreateStream";
const _CT = "CreateThing";
const _CTG = "CreateThingGroup";
const _CTGR = "CreateThingGroupRequest";
const _CTGRr = "CreateThingGroupResponse";
const _CTR = "CreateThingRequest";
const _CTRD = "ConfirmTopicRuleDestination";
const _CTRDR = "ConfirmTopicRuleDestinationRequest";
const _CTRDRo = "ConfirmTopicRuleDestinationResponse";
const _CTRDRr = "CreateTopicRuleDestinationRequest";
const _CTRDRre = "CreateTopicRuleDestinationResponse";
const _CTRDr = "CreateTopicRuleDestination";
const _CTRR = "CreateTopicRuleRequest";
const _CTRr = "CreateThingResponse";
const _CTRre = "CreateTopicRule";
const _CTT = "CreateThingType";
const _CTTR = "CreateThingTypeRequest";
const _CTTRr = "CreateThingTypeResponse";
const _CV = "CertificateValidity";
const _CVE = "CertificateValidationException";
const _Ce = "Certificates";
const _Co = "Configuration";
const _D = "D";
const _DA = "DeleteAuthorizer";
const _DAAC = "DeleteAccountAuditConfiguration";
const _DAACR = "DeleteAccountAuditConfigurationRequest";
const _DAACRe = "DeleteAccountAuditConfigurationResponse";
const _DAACRes = "DescribeAccountAuditConfigurationRequest";
const _DAACResc = "DescribeAccountAuditConfigurationResponse";
const _DAACe = "DescribeAccountAuditConfiguration";
const _DAF = "DescribeAuditFinding";
const _DAFR = "DescribeAuditFindingRequest";
const _DAFRe = "DescribeAuditFindingResponse";
const _DAMAT = "DescribeAuditMitigationActionsTask";
const _DAMATR = "DescribeAuditMitigationActionsTaskRequest";
const _DAMATRe = "DescribeAuditMitigationActionsTaskResponse";
const _DAR = "DeleteAuthorizerRequest";
const _DARe = "DeleteAuthorizerResponse";
const _DARes = "DescribeAuthorizerRequest";
const _DAResc = "DescribeAuthorizerResponse";
const _DAS = "DeleteAuditSuppression";
const _DASR = "DeleteAuditSuppressionRequest";
const _DASRe = "DeleteAuditSuppressionResponse";
const _DASRes = "DescribeAuditSuppressionRequest";
const _DASResc = "DescribeAuditSuppressionResponse";
const _DASe = "DescribeAuditSuppression";
const _DAT = "DescribeAuditTask";
const _DATR = "DescribeAuditTaskRequest";
const _DATRe = "DescribeAuditTaskResponse";
const _DAe = "DescribeAuthorizer";
const _DBG = "DeleteBillingGroup";
const _DBGR = "DeleteBillingGroupRequest";
const _DBGRe = "DeleteBillingGroupResponse";
const _DBGRes = "DescribeBillingGroupRequest";
const _DBGResc = "DescribeBillingGroupResponse";
const _DBGe = "DescribeBillingGroup";
const _DC = "DomainConfigurations";
const _DCAC = "DeleteCACertificate";
const _DCACR = "DeleteCACertificateRequest";
const _DCACRe = "DeleteCACertificateResponse";
const _DCACRes = "DescribeCACertificateRequest";
const _DCACResc = "DescribeCACertificateResponse";
const _DCACe = "DescribeCACertificate";
const _DCE = "DeleteConflictException";
const _DCER = "DeleteCommandExecutionRequest";
const _DCERe = "DeleteCommandExecutionResponse";
const _DCEe = "DeleteCommandExecution";
const _DCM = "DeleteCustomMetric";
const _DCMR = "DeleteCustomMetricRequest";
const _DCMRe = "DeleteCustomMetricResponse";
const _DCMRes = "DescribeCustomMetricRequest";
const _DCMResc = "DescribeCustomMetricResponse";
const _DCMe = "DescribeCustomMetric";
const _DCP = "DeleteCertificateProvider";
const _DCPR = "DeleteCertificateProviderRequest";
const _DCPRe = "DeleteCertificateProviderResponse";
const _DCPRes = "DescribeCertificateProviderRequest";
const _DCPResc = "DescribeCertificateProviderResponse";
const _DCPe = "DescribeCertificateProvider";
const _DCR = "DeleteCertificateRequest";
const _DCRe = "DeleteCommandRequest";
const _DCRel = "DeleteCommandResponse";
const _DCRes = "DescribeCertificateRequest";
const _DCResc = "DescribeCertificateResponse";
const _DCS = "DomainConfigurationSummary";
const _DCe = "DeleteCertificate";
const _DCel = "DeleteCommand";
const _DCes = "DescribeCertificate";
const _DD = "DeleteDimension";
const _DDA = "DescribeDefaultAuthorizer";
const _DDAR = "DescribeDefaultAuthorizerRequest";
const _DDARe = "DescribeDefaultAuthorizerResponse";
const _DDBA = "DynamoDBAction";
const _DDBAy = "DynamoDBv2Action";
const _DDC = "DeleteDomainConfiguration";
const _DDCR = "DeleteDomainConfigurationRequest";
const _DDCRe = "DeleteDomainConfigurationResponse";
const _DDCRes = "DescribeDomainConfigurationRequest";
const _DDCResc = "DescribeDomainConfigurationResponse";
const _DDCe = "DescribeDomainConfiguration";
const _DDMAT = "DescribeDetectMitigationActionsTask";
const _DDMATR = "DescribeDetectMitigationActionsTaskRequest";
const _DDMATRe = "DescribeDetectMitigationActionsTaskResponse";
const _DDR = "DeleteDimensionRequest";
const _DDRe = "DeleteDimensionResponse";
const _DDRes = "DescribeDimensionRequest";
const _DDResc = "DescribeDimensionResponse";
const _DDTG = "DeleteDynamicThingGroup";
const _DDTGR = "DeleteDynamicThingGroupRequest";
const _DDTGRe = "DeleteDynamicThingGroupResponse";
const _DDe = "DescribeDimension";
const _DE = "DescribeEndpoint";
const _DEC = "DescribeEncryptionConfiguration";
const _DECR = "DescribeEncryptionConfigurationRequest";
const _DECRe = "DescribeEncryptionConfigurationResponse";
const _DECRes = "DescribeEventConfigurationsRequest";
const _DECResc = "DescribeEventConfigurationsResponse";
const _DECe = "DescribeEventConfigurations";
const _DER = "DescribeEndpointRequest";
const _DERe = "DescribeEndpointResponse";
const _DFM = "DeleteFleetMetric";
const _DFMR = "DeleteFleetMetricRequest";
const _DFMRe = "DescribeFleetMetricRequest";
const _DFMRes = "DescribeFleetMetricResponse";
const _DFMe = "DescribeFleetMetric";
const _DI = "DescribeIndex";
const _DIR = "DescribeIndexRequest";
const _DIRe = "DescribeIndexResponse";
const _DJ = "DeleteJob";
const _DJE = "DeleteJobExecution";
const _DJER = "DeleteJobExecutionRequest";
const _DJERe = "DescribeJobExecutionRequest";
const _DJERes = "DescribeJobExecutionResponse";
const _DJEe = "DescribeJobExecution";
const _DJR = "DeleteJobRequest";
const _DJRe = "DescribeJobRequest";
const _DJRes = "DescribeJobResponse";
const _DJT = "DeleteJobTemplate";
const _DJTR = "DeleteJobTemplateRequest";
const _DJTRe = "DescribeJobTemplateRequest";
const _DJTRes = "DescribeJobTemplateResponse";
const _DJTe = "DescribeJobTemplate";
const _DJe = "DescribeJob";
const _DMA = "DeleteMitigationAction";
const _DMAE = "DetectMitigationActionExecution";
const _DMAEL = "DetectMitigationActionExecutionList";
const _DMAR = "DeleteMitigationActionRequest";
const _DMARe = "DeleteMitigationActionResponse";
const _DMARes = "DescribeMitigationActionRequest";
const _DMAResc = "DescribeMitigationActionResponse";
const _DMATS = "DetectMitigationActionsTaskStatistics";
const _DMATSL = "DetectMitigationActionsTaskSummaryList";
const _DMATSe = "DetectMitigationActionsTaskSummary";
const _DMATT = "DetectMitigationActionsTaskTarget";
const _DMAe = "DescribeMitigationAction";
const _DMJT = "DescribeManagedJobTemplate";
const _DMJTR = "DescribeManagedJobTemplateRequest";
const _DMJTRe = "DescribeManagedJobTemplateResponse";
const _DOTAU = "DeleteOTAUpdate";
const _DOTAUR = "DeleteOTAUpdateRequest";
const _DOTAURe = "DeleteOTAUpdateResponse";
const _DP = "DocumentParameter";
const _DPP = "DetachPrincipalPolicy";
const _DPPR = "DetachPrincipalPolicyRequest";
const _DPR = "DeletePackageRequest";
const _DPRe = "DeletePackageResponse";
const _DPRel = "DeletePolicyRequest";
const _DPRet = "DetachPolicyRequest";
const _DPT = "DeleteProvisioningTemplate";
const _DPTR = "DeleteProvisioningTemplateRequest";
const _DPTRe = "DeleteProvisioningTemplateResponse";
const _DPTRes = "DescribeProvisioningTemplateRequest";
const _DPTResc = "DescribeProvisioningTemplateResponse";
const _DPTV = "DeleteProvisioningTemplateVersion";
const _DPTVR = "DeleteProvisioningTemplateVersionRequest";
const _DPTVRe = "DeleteProvisioningTemplateVersionResponse";
const _DPTVRes = "DescribeProvisioningTemplateVersionRequest";
const _DPTVResc = "DescribeProvisioningTemplateVersionResponse";
const _DPTVe = "DescribeProvisioningTemplateVersion";
const _DPTe = "DescribeProvisioningTemplate";
const _DPV = "DeletePackageVersion";
const _DPVR = "DeletePackageVersionRequest";
const _DPVRe = "DeletePackageVersionResponse";
const _DPVRel = "DeletePolicyVersionRequest";
const _DPVe = "DeletePolicyVersion";
const _DPe = "DeletePackage";
const _DPel = "DeletePolicy";
const _DPet = "DetachPolicy";
const _DPo = "DocumentParameters";
const _DRA = "DeleteRoleAlias";
const _DRAR = "DeleteRoleAliasRequest";
const _DRARe = "DeleteRoleAliasResponse";
const _DRARes = "DescribeRoleAliasRequest";
const _DRAResc = "DescribeRoleAliasResponse";
const _DRAe = "DescribeRoleAlias";
const _DRC = "DeleteRegistrationCode";
const _DRCR = "DeleteRegistrationCodeRequest";
const _DRCRe = "DeleteRegistrationCodeResponse";
const _DS = "DeleteStream";
const _DSA = "DeleteScheduledAudit";
const _DSAR = "DeleteScheduledAuditRequest";
const _DSARe = "DeleteScheduledAuditResponse";
const _DSARes = "DescribeScheduledAuditRequest";
const _DSAResc = "DescribeScheduledAuditResponse";
const _DSAe = "DescribeScheduledAudit";
const _DSFPV = "DisassociateSbomFromPackageVersion";
const _DSFPVR = "DisassociateSbomFromPackageVersionRequest";
const _DSFPVRi = "DisassociateSbomFromPackageVersionResponse";
const _DSP = "DeleteSecurityProfile";
const _DSPR = "DeleteSecurityProfileRequest";
const _DSPRe = "DeleteSecurityProfileResponse";
const _DSPRes = "DescribeSecurityProfileRequest";
const _DSPResc = "DescribeSecurityProfileResponse";
const _DSPRet = "DetachSecurityProfileRequest";
const _DSPReta = "DetachSecurityProfileResponse";
const _DSPe = "DescribeSecurityProfile";
const _DSPet = "DetachSecurityProfile";
const _DSR = "DeleteStreamRequest";
const _DSRe = "DeleteStreamResponse";
const _DSRes = "DescribeStreamRequest";
const _DSResc = "DescribeStreamResponse";
const _DSe = "DescribeStream";
const _DT = "DeleteThing";
const _DTG = "DeleteThingGroup";
const _DTGR = "DeleteThingGroupRequest";
const _DTGRe = "DeleteThingGroupResponse";
const _DTGRes = "DescribeThingGroupRequest";
const _DTGResc = "DescribeThingGroupResponse";
const _DTGe = "DescribeThingGroup";
const _DTP = "DetachThingPrincipal";
const _DTPR = "DetachThingPrincipalRequest";
const _DTPRe = "DetachThingPrincipalResponse";
const _DTR = "DeleteThingRequest";
const _DTRD = "DeleteTopicRuleDestination";
const _DTRDR = "DeleteTopicRuleDestinationRequest";
const _DTRDRe = "DeleteTopicRuleDestinationResponse";
const _DTRR = "DeleteTopicRuleRequest";
const _DTRRi = "DisableTopicRuleRequest";
const _DTRT = "DescribeThingRegistrationTask";
const _DTRTR = "DescribeThingRegistrationTaskRequest";
const _DTRTRe = "DescribeThingRegistrationTaskResponse";
const _DTRe = "DeleteThingResponse";
const _DTRel = "DeleteTopicRule";
const _DTRes = "DescribeThingRequest";
const _DTResc = "DescribeThingResponse";
const _DTRi = "DisableTopicRule";
const _DTT = "DeleteThingType";
const _DTTR = "DeleteThingTypeRequest";
const _DTTRe = "DeleteThingTypeResponse";
const _DTTRep = "DeprecateThingTypeRequest";
const _DTTRepr = "DeprecateThingTypeResponse";
const _DTTRes = "DescribeThingTypeRequest";
const _DTTResc = "DescribeThingTypeResponse";
const _DTTe = "DeprecateThingType";
const _DTTes = "DescribeThingType";
const _DTe = "DescribeThing";
const _DVLL = "DeleteV2LoggingLevel";
const _DVLLR = "DeleteV2LoggingLevelRequest";
const _De = "Denied";
const _Des = "Destination";
const _E = "Enabled";
const _EA = "ElasticsearchAction";
const _EC = "EventConfigurations";
const _ED = "ExplicitDeny";
const _EI = "ErrorInfo";
const _EITLP = "EnableIoTLoggingParams";
const _EP = "EffectivePolicy";
const _EPf = "EffectivePolicies";
const _ERR = "ExponentialRolloutRate";
const _ETR = "EnableTopicRule";
const _ETRR = "EnableTopicRuleRequest";
const _F = "Field";
const _FA = "FirehoseAction";
const _FL = "FileLocation";
const _FMNAA = "FleetMetricNameAndArn";
const _FMNAAL = "FleetMetricNameAndArnList";
const _Fi = "Fields";
const _GBA = "GetBucketsAggregation";
const _GBAR = "GetBucketsAggregationRequest";
const _GBARe = "GetBucketsAggregationResponse";
const _GBMTS = "GetBehaviorModelTrainingSummaries";
const _GBMTSR = "GetBehaviorModelTrainingSummariesRequest";
const _GBMTSRe = "GetBehaviorModelTrainingSummariesResponse";
const _GC = "GetCardinality";
const _GCE = "GetCommandExecution";
const _GCER = "GetCommandExecutionRequest";
const _GCERe = "GetCommandExecutionResponse";
const _GCR = "GetCardinalityRequest";
const _GCRe = "GetCardinalityResponse";
const _GCRet = "GetCommandRequest";
const _GCReto = "GetCommandResponse";
const _GCe = "GetCommand";
const _GEP = "GetEffectivePolicies";
const _GEPR = "GetEffectivePoliciesRequest";
const _GEPRe = "GetEffectivePoliciesResponse";
const _GIC = "GetIndexingConfiguration";
const _GICR = "GetIndexingConfigurationRequest";
const _GICRe = "GetIndexingConfigurationResponse";
const _GJD = "GetJobDocument";
const _GJDR = "GetJobDocumentRequest";
const _GJDRe = "GetJobDocumentResponse";
const _GLF = "GeoLocationsFilter";
const _GLO = "GetLoggingOptions";
const _GLOR = "GetLoggingOptionsRequest";
const _GLORe = "GetLoggingOptionsResponse";
const _GLT = "GeoLocationTarget";
const _GNAA = "GroupNameAndArn";
const _GOTAU = "GetOTAUpdate";
const _GOTAUR = "GetOTAUpdateRequest";
const _GOTAURe = "GetOTAUpdateResponse";
const _GP = "GetPackage";
const _GPC = "GetPackageConfiguration";
const _GPCR = "GetPackageConfigurationRequest";
const _GPCRe = "GetPackageConfigurationResponse";
const _GPR = "GetPackageRequest";
const _GPRe = "GetPackageResponse";
const _GPRet = "GetPercentilesRequest";
const _GPRete = "GetPercentilesResponse";
const _GPReto = "GetPolicyRequest";
const _GPRetol = "GetPolicyResponse";
const _GPV = "GetPackageVersion";
const _GPVR = "GetPackageVersionRequest";
const _GPVRe = "GetPackageVersionResponse";
const _GPVRet = "GetPolicyVersionRequest";
const _GPVReto = "GetPolicyVersionResponse";
const _GPVe = "GetPolicyVersion";
const _GPe = "GetPercentiles";
const _GPet = "GetPolicy";
const _GRC = "GetRegistrationCode";
const _GRCR = "GetRegistrationCodeRequest";
const _GRCRe = "GetRegistrationCodeResponse";
const _GS = "GetStatistics";
const _GSR = "GetStatisticsRequest";
const _GSRe = "GetStatisticsResponse";
const _GTCD = "GetThingConnectivityData";
const _GTCDR = "GetThingConnectivityDataRequest";
const _GTCDRe = "GetThingConnectivityDataResponse";
const _GTR = "GetTopicRule";
const _GTRD = "GetTopicRuleDestination";
const _GTRDR = "GetTopicRuleDestinationRequest";
const _GTRDRe = "GetTopicRuleDestinationResponse";
const _GTRR = "GetTopicRuleRequest";
const _GTRRe = "GetTopicRuleResponse";
const _GVLO = "GetV2LoggingOptions";
const _GVLOR = "GetV2LoggingOptionsRequest";
const _GVLORe = "GetV2LoggingOptionsResponse";
const _HA = "HttpAction";
const _HAH = "HttpActionHeader";
const _HAt = "HttpAuthorization";
const _HC = "HttpContext";
const _HL = "HeaderList";
const _HUDC = "HttpUrlDestinationConfiguration";
const _HUDP = "HttpUrlDestinationProperties";
const _HUDS = "HttpUrlDestinationSummary";
const _I = "I";
const _IAA = "IotAnalyticsAction";
const _IAE = "InvalidAggregationException";
const _ICI = "IssuerCertificateIdentifier";
const _ID = "ImplicitDeny";
const _IE = "InternalException";
const _IEA = "IotEventsAction";
const _IF = "IndexingFilter";
const _IFE = "InternalFailureException";
const _INRE = "IndexNotReadyException";
const _IQE = "InvalidQueryException";
const _IRE = "InvalidRequestException";
const _IREn = "InvalidResponseException";
const _ISE = "InternalServerException";
const _ISTE = "InvalidStateTransitionException";
const _ISWA = "IotSiteWiseAction";
const _J = "Job";
const _JE = "JobExecution";
const _JERC = "JobExecutionsRetryConfig";
const _JERCo = "JobExecutionsRolloutConfig";
const _JES = "JobExecutionSummary";
const _JESD = "JobExecutionStatusDetails";
const _JESFJ = "JobExecutionSummaryForJob";
const _JESFJL = "JobExecutionSummaryForJobList";
const _JESFT = "JobExecutionSummaryForThing";
const _JESFTL = "JobExecutionSummaryForThingList";
const _JPD = "JobProcessDetails";
const _JS = "JobSummary";
const _JSL = "JobSummaryList";
const _JTS = "JobTemplateSummary";
const _JTSL = "JobTemplateSummaryList";
const _K = "Key";
const _KA = "KafkaAction";
const _KAH = "KafkaActionHeader";
const _KAi = "KinesisAction";
const _KH = "KafkaHeaders";
const _KP = "KeyPair";
const _L = "L";
const _LA = "LambdaAction";
const _LAF = "ListAuditFindings";
const _LAFR = "ListAuditFindingsRequest";
const _LAFRi = "ListAuditFindingsResponse";
const _LAMAE = "ListAuditMitigationActionsExecutions";
const _LAMAER = "ListAuditMitigationActionsExecutionsRequest";
const _LAMAERi = "ListAuditMitigationActionsExecutionsResponse";
const _LAMAT = "ListAuditMitigationActionsTasks";
const _LAMATR = "ListAuditMitigationActionsTasksRequest";
const _LAMATRi = "ListAuditMitigationActionsTasksResponse";
const _LAP = "ListAttachedPolicies";
const _LAPR = "ListAttachedPoliciesRequest";
const _LAPRi = "ListAttachedPoliciesResponse";
const _LAR = "ListAuthorizersRequest";
const _LARi = "ListAuthorizersResponse";
const _LAS = "ListAuditSuppressions";
const _LASR = "ListAuditSuppressionsRequest";
const _LASRi = "ListAuditSuppressionsResponse";
const _LAT = "ListAuditTasks";
const _LATR = "ListAuditTasksRequest";
const _LATRi = "ListAuditTasksResponse";
const _LAV = "ListActiveViolations";
const _LAVR = "ListActiveViolationsRequest";
const _LAVRi = "ListActiveViolationsResponse";
const _LAi = "ListAuthorizers";
const _LAo = "LocationAction";
const _LBG = "ListBillingGroups";
const _LBGR = "ListBillingGroupsRequest";
const _LBGRi = "ListBillingGroupsResponse";
const _LC = "ListCertificates";
const _LCAC = "ListCACertificates";
const _LCACR = "ListCACertificatesRequest";
const _LCACRi = "ListCACertificatesResponse";
const _LCBCA = "ListCertificatesByCA";
const _LCBCAR = "ListCertificatesByCARequest";
const _LCBCARi = "ListCertificatesByCAResponse";
const _LCE = "ListCommandExecutions";
const _LCER = "ListCommandExecutionsRequest";
const _LCERi = "ListCommandExecutionsResponse";
const _LCM = "ListCustomMetrics";
const _LCMR = "ListCustomMetricsRequest";
const _LCMRi = "ListCustomMetricsResponse";
const _LCP = "ListCertificateProviders";
const _LCPR = "ListCertificateProvidersRequest";
const _LCPRi = "ListCertificateProvidersResponse";
const _LCR = "ListCertificatesRequest";
const _LCRi = "ListCertificatesResponse";
const _LCRis = "ListCommandsRequest";
const _LCRist = "ListCommandsResponse";
const _LCi = "ListCommands";
const _LD = "ListDimensions";
const _LDC = "ListDomainConfigurations";
const _LDCR = "ListDomainConfigurationsRequest";
const _LDCRi = "ListDomainConfigurationsResponse";
const _LDMAE = "ListDetectMitigationActionsExecutions";
const _LDMAER = "ListDetectMitigationActionsExecutionsRequest";
const _LDMAERi = "ListDetectMitigationActionsExecutionsResponse";
const _LDMAT = "ListDetectMitigationActionsTasks";
const _LDMATR = "ListDetectMitigationActionsTasksRequest";
const _LDMATRi = "ListDetectMitigationActionsTasksResponse";
const _LDR = "ListDimensionsRequest";
const _LDRi = "ListDimensionsResponse";
const _LEC = "LogEventConfiguration";
const _LECo = "LogEventConfigurations";
const _LEE = "LimitExceededException";
const _LFM = "ListFleetMetrics";
const _LFMR = "ListFleetMetricsRequest";
const _LFMRi = "ListFleetMetricsResponse";
const _LI = "ListIndices";
const _LIR = "ListIndicesRequest";
const _LIRi = "ListIndicesResponse";
const _LJ = "ListJobs";
const _LJEFJ = "ListJobExecutionsForJob";
const _LJEFJR = "ListJobExecutionsForJobRequest";
const _LJEFJRi = "ListJobExecutionsForJobResponse";
const _LJEFT = "ListJobExecutionsForThing";
const _LJEFTR = "ListJobExecutionsForThingRequest";
const _LJEFTRi = "ListJobExecutionsForThingResponse";
const _LJR = "ListJobsRequest";
const _LJRi = "ListJobsResponse";
const _LJT = "ListJobTemplates";
const _LJTR = "ListJobTemplatesRequest";
const _LJTRi = "ListJobTemplatesResponse";
const _LMA = "ListMitigationActions";
const _LMAR = "ListMitigationActionsRequest";
const _LMARi = "ListMitigationActionsResponse";
const _LMJT = "ListManagedJobTemplates";
const _LMJTR = "ListManagedJobTemplatesRequest";
const _LMJTRi = "ListManagedJobTemplatesResponse";
const _LMV = "ListMetricValues";
const _LMVR = "ListMetricValuesRequest";
const _LMVRi = "ListMetricValuesResponse";
const _LOC = "ListOutgoingCertificates";
const _LOCR = "ListOutgoingCertificatesRequest";
const _LOCRi = "ListOutgoingCertificatesResponse";
const _LOP = "LoggingOptionsPayload";
const _LOTAU = "ListOTAUpdates";
const _LOTAUR = "ListOTAUpdatesRequest";
const _LOTAURi = "ListOTAUpdatesResponse";
const _LP = "ListPackages";
const _LPP = "ListPolicyPrincipals";
const _LPPR = "ListPolicyPrincipalsRequest";
const _LPPRi = "ListPolicyPrincipalsResponse";
const _LPPRis = "ListPrincipalPoliciesRequest";
const _LPPRist = "ListPrincipalPoliciesResponse";
const _LPPi = "ListPrincipalPolicies";
const _LPR = "ListPackagesRequest";
const _LPRi = "ListPackagesResponse";
const _LPRis = "ListPoliciesRequest";
const _LPRist = "ListPoliciesResponse";
const _LPT = "ListPrincipalThings";
const _LPTR = "ListPrincipalThingsRequest";
const _LPTRi = "ListPrincipalThingsResponse";
const _LPTRis = "ListProvisioningTemplatesRequest";
const _LPTRist = "ListProvisioningTemplatesResponse";
const _LPTV = "ListPrincipalThingsV2";
const _LPTVR = "ListPrincipalThingsV2Request";
const _LPTVRi = "ListPrincipalThingsV2Response";
const _LPTVRis = "ListProvisioningTemplateVersionsRequest";
const _LPTVRist = "ListProvisioningTemplateVersionsResponse";
const _LPTVi = "ListProvisioningTemplateVersions";
const _LPTi = "ListProvisioningTemplates";
const _LPV = "ListPackageVersions";
const _LPVR = "ListPackageVersionsRequest";
const _LPVRi = "ListPackageVersionsResponse";
const _LPVRis = "ListPolicyVersionsRequest";
const _LPVRist = "ListPolicyVersionsResponse";
const _LPVi = "ListPolicyVersions";
const _LPi = "ListPolicies";
const _LRA = "ListRoleAliases";
const _LRAR = "ListRoleAliasesRequest";
const _LRARi = "ListRoleAliasesResponse";
const _LRRFAF = "ListRelatedResourcesForAuditFinding";
const _LRRFAFR = "ListRelatedResourcesForAuditFindingRequest";
const _LRRFAFRi = "ListRelatedResourcesForAuditFindingResponse";
const _LS = "ListStreams";
const _LSA = "ListScheduledAudits";
const _LSAR = "ListScheduledAuditsRequest";
const _LSARi = "ListScheduledAuditsResponse";
const _LSP = "ListSecurityProfiles";
const _LSPFT = "ListSecurityProfilesForTarget";
const _LSPFTR = "ListSecurityProfilesForTargetRequest";
const _LSPFTRi = "ListSecurityProfilesForTargetResponse";
const _LSPR = "ListSecurityProfilesRequest";
const _LSPRi = "ListSecurityProfilesResponse";
const _LSR = "ListStreamsRequest";
const _LSRi = "ListStreamsResponse";
const _LSVR = "ListSbomValidationResults";
const _LSVRR = "ListSbomValidationResultsRequest";
const _LSVRRi = "ListSbomValidationResultsResponse";
const _LT = "LocationTimestamp";
const _LTC = "LogTargetConfiguration";
const _LTCo = "LogTargetConfigurations";
const _LTFP = "ListTargetsForPolicy";
const _LTFPR = "ListTargetsForPolicyRequest";
const _LTFPRi = "ListTargetsForPolicyResponse";
const _LTFR = "ListTagsForResource";
const _LTFRR = "ListTagsForResourceRequest";
const _LTFRRi = "ListTagsForResourceResponse";
const _LTFSP = "ListTargetsForSecurityProfile";
const _LTFSPR = "ListTargetsForSecurityProfileRequest";
const _LTFSPRi = "ListTargetsForSecurityProfileResponse";
const _LTG = "ListThingGroups";
const _LTGFT = "ListThingGroupsForThing";
const _LTGFTR = "ListThingGroupsForThingRequest";
const _LTGFTRi = "ListThingGroupsForThingResponse";
const _LTGR = "ListThingGroupsRequest";
const _LTGRi = "ListThingGroupsResponse";
const _LTIBG = "ListThingsInBillingGroup";
const _LTIBGR = "ListThingsInBillingGroupRequest";
const _LTIBGRi = "ListThingsInBillingGroupResponse";
const _LTITG = "ListThingsInThingGroup";
const _LTITGR = "ListThingsInThingGroupRequest";
const _LTITGRi = "ListThingsInThingGroupResponse";
const _LTP = "ListThingPrincipals";
const _LTPR = "ListThingPrincipalsRequest";
const _LTPRi = "ListThingPrincipalsResponse";
const _LTPV = "ListThingPrincipalsV2";
const _LTPVR = "ListThingPrincipalsV2Request";
const _LTPVRi = "ListThingPrincipalsV2Response";
const _LTR = "ListThingsRequest";
const _LTRD = "ListTopicRuleDestinations";
const _LTRDR = "ListTopicRuleDestinationsRequest";
const _LTRDRi = "ListTopicRuleDestinationsResponse";
const _LTRR = "ListTopicRulesRequest";
const _LTRRi = "ListTopicRulesResponse";
const _LTRT = "ListThingRegistrationTasks";
const _LTRTR = "ListThingRegistrationTasksRequest";
const _LTRTRR = "ListThingRegistrationTaskReportsRequest";
const _LTRTRRi = "ListThingRegistrationTaskReportsResponse";
const _LTRTRi = "ListThingRegistrationTasksResponse";
const _LTRTRis = "ListThingRegistrationTaskReports";
const _LTRi = "ListThingsResponse";
const _LTRis = "ListTopicRules";
const _LTT = "ListThingTypes";
const _LTTR = "ListThingTypesRequest";
const _LTTRi = "ListThingTypesResponse";
const _LTi = "ListThings";
const _LTo = "LogTarget";
const _LVE = "ListViolationEvents";
const _LVER = "ListViolationEventsRequest";
const _LVERi = "ListViolationEventsResponse";
const _LVLL = "ListV2LoggingLevels";
const _LVLLR = "ListV2LoggingLevelsRequest";
const _LVLLRi = "ListV2LoggingLevelsResponse";
const _MA = "MitigationAction";
const _MAI = "MitigationActionIdentifier";
const _MAIL = "MitigationActionIdentifierList";
const _MAL = "MitigationActionList";
const _MAP = "MitigationActionParams";
const _MC = "Mqtt5Configuration";
const _MCq = "MqttContext";
const _MD = "MetricDatum";
const _MDL = "MetricDatumList";
const _MDe = "MetricDimension";
const _MEC = "MetricsExportConfig";
const _MH = "MqttHeaders";
const _MJTS = "ManagedJobTemplateSummary";
const _MJTSL = "ManagedJobTemplatesSummaryList";
const _MLDC = "MachineLearningDetectionConfig";
const _MPE = "MalformedPolicyException";
const _MTR = "MetricToRetain";
const _MV = "MetricValue";
const _MW = "MaintenanceWindow";
const _MWa = "MaintenanceWindows";
const _NCE = "NotConfiguredException";
const _NCR = "NonCompliantResource";
const _OC = "OutgoingCertificate";
const _OCu = "OutgoingCertificates";
const _OSA = "OpenSearchAction";
const _OTAUF = "OTAUpdateFile";
const _OTAUFp = "OTAUpdateFiles";
const _OTAUI = "OTAUpdateInfo";
const _OTAUS = "OTAUpdateSummary";
const _OTAUSp = "OTAUpdatesSummary";
const _P = "Policy";
const _PA = "PropagatingAttribute";
const _PAL = "PropagatingAttributeList";
const _PAPVE = "PutAssetPropertyValueEntry";
const _PAPVEL = "PutAssetPropertyValueEntryList";
const _PFTSP = "PublishFindingToSnsParams";
const _PH = "ProvisioningHook";
const _PII = "PutItemInput";
const _PK = "PrivateKey";
const _PKu = "PublicKey";
const _PP = "PercentPair";
const _PS = "PackageSummary";
const _PSL = "PackageSummaryList";
const _PTL = "ProvisioningTemplateListing";
const _PTO = "PrincipalThingObject";
const _PTOr = "PrincipalThingObjects";
const _PTS = "ProvisioningTemplateSummary";
const _PTVL = "ProvisioningTemplateVersionListing";
const _PTVS = "ProvisioningTemplateVersionSummary";
const _PUC = "PresignedUrlConfig";
const _PV = "PolicyVersion";
const _PVA = "PackageVersionArtifact";
const _PVI = "PolicyVersionIdentifier";
const _PVR = "PackageVersionRecipe";
const _PVS = "PackageVersionSummary";
const _PVSL = "PackageVersionSummaryList";
const _PVSOV = "PutVerificationStateOnViolation";
const _PVSOVR = "PutVerificationStateOnViolationRequest";
const _PVSOVRu = "PutVerificationStateOnViolationResponse";
const _PVo = "PolicyVersions";
const _Pe = "Percentiles";
const _Po = "Policies";
const _RA = "RepublishAction";
const _RAD = "RoleAliasDescription";
const _RAEE = "ResourceAlreadyExistsException";
const _RAe = "ResourceAttributes";
const _RC = "RegistrationConfig";
const _RCAC = "RegisterCACertificate";
const _RCACR = "RegisterCACertificateRequest";
const _RCACRe = "RegisterCACertificateResponse";
const _RCL = "RetryCriteriaList";
const _RCR = "RegisterCertificateRequest";
const _RCRe = "RegisterCertificateResponse";
const _RCT = "RejectCertificateTransfer";
const _RCTR = "RejectCertificateTransferRequest";
const _RCVE = "RegistrationCodeValidationException";
const _RCWCA = "RegisterCertificateWithoutCA";
const _RCWCAR = "RegisterCertificateWithoutCARequest";
const _RCWCARe = "RegisterCertificateWithoutCAResponse";
const _RCe = "RetryCriteria";
const _RCeg = "RegisterCertificate";
const _RD = "ResourceDescription";
const _RDPVP = "ReplaceDefaultPolicyVersionParams";
const _RI = "ResourceIdentifier";
const _RIC = "RateIncreaseCriteria";
const _RNFE = "ResourceNotFoundException";
const _RR = "RelatedResource";
const _RRFE = "ResourceRegistrationFailureException";
const _RRe = "RelatedResources";
const _RT = "RegisterThing";
const _RTFBG = "RemoveThingFromBillingGroup";
const _RTFBGR = "RemoveThingFromBillingGroupRequest";
const _RTFBGRe = "RemoveThingFromBillingGroupResponse";
const _RTFTG = "RemoveThingFromThingGroup";
const _RTFTGR = "RemoveThingFromThingGroupRequest";
const _RTFTGRe = "RemoveThingFromThingGroupResponse";
const _RTR = "RegisterThingRequest";
const _RTRR = "ReplaceTopicRuleRequest";
const _RTRe = "RegisterThingResponse";
const _RTRep = "ReplaceTopicRule";
const _S = "S";
const _SA = "S3Action";
const _SAM = "ScheduledAuditMetadata";
const _SAMAT = "StartAuditMitigationActionsTask";
const _SAMATR = "StartAuditMitigationActionsTaskRequest";
const _SAMATRt = "StartAuditMitigationActionsTaskResponse";
const _SAML = "ScheduledAuditMetadataList";
const _SAa = "SalesforceAction";
const _SAn = "SnsAction";
const _SAq = "SqsAction";
const _SC = "SchedulingConfig";
const _SCC = "ServerCertificateConfig";
const _SCS = "ServerCertificateSummary";
const _SCe = "ServerCertificates";
const _SD = "S3Destination";
const _SDA = "SetDefaultAuthorizer";
const _SDAR = "SetDefaultAuthorizerRequest";
const _SDARe = "SetDefaultAuthorizerResponse";
const _SDMAT = "StartDetectMitigationActionsTask";
const _SDMATR = "StartDetectMitigationActionsTaskRequest";
const _SDMATRt = "StartDetectMitigationActionsTaskResponse";
const _SDPV = "SetDefaultPolicyVersion";
const _SDPVR = "SetDefaultPolicyVersionRequest";
const _SF = "StreamFile";
const _SFA = "StepFunctionsAction";
const _SFt = "StreamFiles";
const _SI = "StreamInfo";
const _SIR = "SearchIndexRequest";
const _SIRe = "SearchIndexResponse";
const _SIe = "SearchIndex";
const _SJR = "ScheduledJobRollout";
const _SJRL = "ScheduledJobRolloutList";
const _SL = "S3Location";
const _SLO = "SetLoggingOptions";
const _SLOR = "SetLoggingOptionsRequest";
const _SODAT = "StartOnDemandAuditTask";
const _SODATR = "StartOnDemandAuditTaskRequest";
const _SODATRt = "StartOnDemandAuditTaskResponse";
const _SPE = "SqlParseException";
const _SPI = "SecurityProfileIdentifier";
const _SPIe = "SecurityProfileIdentifiers";
const _SPP = "SigningProfileParameter";
const _SPT = "SecurityProfileTarget";
const _SPTM = "SecurityProfileTargetMapping";
const _SPTMe = "SecurityProfileTargetMappings";
const _SPTe = "SecurityProfileTargets";
const _SQEE = "ServiceQuotaExceededException";
const _SR = "StatusReason";
const _SS = "StreamSummary";
const _SSJP = "StartSigningJobParameter";
const _SSt = "StreamsSummary";
const _ST = "StatisticalThreshold";
const _STRT = "StartThingRegistrationTask";
const _STRTR = "StartThingRegistrationTaskRequest";
const _STRTRt = "StartThingRegistrationTaskResponse";
const _STRTRto = "StopThingRegistrationTaskRequest";
const _STRTRtop = "StopThingRegistrationTaskResponse";
const _STRTt = "StopThingRegistrationTask";
const _SUE = "ServiceUnavailableException";
const _SVA = "SigV4Authorization";
const _SVLL = "SetV2LoggingLevel";
const _SVLLR = "SetV2LoggingLevelRequest";
const _SVLO = "SetV2LoggingOptions";
const _SVLOR = "SetV2LoggingOptionsRequest";
const _SVRS = "SbomValidationResultSummary";
const _SVRSL = "SbomValidationResultSummaryList";
const _Sb = "Sbom";
const _St = "Statistics";
const _Str = "Stream";
const _T = "Tag";
const _TA = "TermsAggregation";
const _TACE = "TransferAlreadyCompletedException";
const _TAEE = "TaskAlreadyExistsException";
const _TAL = "ThingAttributeList";
const _TAR = "TestAuthorizationRequest";
const _TARe = "TestAuthorizationResponse";
const _TAe = "TestAuthorization";
const _TAh = "ThingAttribute";
const _TAi = "TimestreamAction";
const _TC = "ThingConnectivity";
const _TCE = "TransferConflictException";
const _TCR = "TransferCertificateRequest";
const _TCRr = "TransferCertificateResponse";
const _TCi = "TimeoutConfig";
const _TCl = "TlsConfig";
const _TCls = "TlsContext";
const _TCr = "TransferCertificate";
const _TD = "ThingDocument";
const _TDL = "ThingDocumentList";
const _TDLi = "TimestreamDimensionList";
const _TDi = "TimestreamDimension";
const _TDr = "TransferData";
const _TE = "ThrottlingException";
const _TF = "TimeFilter";
const _TGD = "ThingGroupDocument";
const _TGDL = "ThingGroupDocumentList";
const _TGIC = "ThingGroupIndexingConfiguration";
const _TGM = "ThingGroupMetadata";
const _TGNAAL = "ThingGroupNameAndArnList";
const _TGP = "ThingGroupProperties";
const _TIA = "TestInvokeAuthorizer";
const _TIAR = "TestInvokeAuthorizerRequest";
const _TIARe = "TestInvokeAuthorizerResponse";
const _TIC = "ThingIndexingConfiguration";
const _TL = "TagList";
const _TPO = "ThingPrincipalObject";
const _TPOh = "ThingPrincipalObjects";
const _TR = "TopicRule";
const _TRD = "TopicRuleDestination";
const _TRDC = "TopicRuleDestinationConfiguration";
const _TRDS = "TopicRuleDestinationSummary";
const _TRDSo = "TopicRuleDestinationSummaries";
const _TRL = "TopicRuleList";
const _TRLI = "TopicRuleListItem";
const _TRP = "TopicRulePayload";
const _TRR = "TagResourceRequest";
const _TRRa = "TagResourceResponse";
const _TRa = "TagResource";
const _TS = "TaskStatistics";
const _TSFAC = "TaskStatisticsForAuditCheck";
const _TT = "TimestreamTimestamp";
const _TTD = "ThingTypeDefinition";
const _TTL = "ThingTypeList";
const _TTM = "ThingTypeMetadata";
const _TTP = "ThingTypeProperties";
const _UA = "UpdateAuthorizer";
const _UAAC = "UpdateAccountAuditConfiguration";
const _UAACR = "UpdateAccountAuditConfigurationRequest";
const _UAACRp = "UpdateAccountAuditConfigurationResponse";
const _UAR = "UpdateAuthorizerRequest";
const _UARp = "UpdateAuthorizerResponse";
const _UAS = "UpdateAuditSuppression";
const _UASR = "UpdateAuditSuppressionRequest";
const _UASRp = "UpdateAuditSuppressionResponse";
const _UBG = "UpdateBillingGroup";
const _UBGR = "UpdateBillingGroupRequest";
const _UBGRp = "UpdateBillingGroupResponse";
const _UC = "UpdateCertificate";
const _UCAC = "UpdateCACertificate";
const _UCACP = "UpdateCACertificateParams";
const _UCACR = "UpdateCACertificateRequest";
const _UCM = "UpdateCustomMetric";
const _UCMR = "UpdateCustomMetricRequest";
const _UCMRp = "UpdateCustomMetricResponse";
const _UCP = "UpdateCertificateProvider";
const _UCPR = "UpdateCertificateProviderRequest";
const _UCPRp = "UpdateCertificateProviderResponse";
const _UCR = "UpdateCertificateRequest";
const _UCRp = "UpdateCommandRequest";
const _UCRpd = "UpdateCommandResponse";
const _UCp = "UpdateCommand";
const _UD = "UpdateDimension";
const _UDC = "UpdateDomainConfiguration";
const _UDCP = "UpdateDeviceCertificateParams";
const _UDCR = "UpdateDomainConfigurationRequest";
const _UDCRp = "UpdateDomainConfigurationResponse";
const _UDR = "UpdateDimensionRequest";
const _UDRp = "UpdateDimensionResponse";
const _UDTG = "UpdateDynamicThingGroup";
const _UDTGR = "UpdateDynamicThingGroupRequest";
const _UDTGRp = "UpdateDynamicThingGroupResponse";
const _UE = "UnauthorizedException";
const _UEC = "UpdateEncryptionConfiguration";
const _UECR = "UpdateEncryptionConfigurationRequest";
const _UECRp = "UpdateEncryptionConfigurationResponse";
const _UECRpd = "UpdateEventConfigurationsRequest";
const _UECRpda = "UpdateEventConfigurationsResponse";
const _UECp = "UpdateEventConfigurations";
const _UFM = "UpdateFleetMetric";
const _UFMR = "UpdateFleetMetricRequest";
const _UIC = "UpdateIndexingConfiguration";
const _UICR = "UpdateIndexingConfigurationRequest";
const _UICRp = "UpdateIndexingConfigurationResponse";
const _UJ = "UpdateJob";
const _UJR = "UpdateJobRequest";
const _UL = "UL";
const _UMA = "UpdateMitigationAction";
const _UMAR = "UpdateMitigationActionRequest";
const _UMARp = "UpdateMitigationActionResponse";
const _UP = "UserProperty";
const _UPC = "UpdatePackageConfiguration";
const _UPCR = "UpdatePackageConfigurationRequest";
const _UPCRp = "UpdatePackageConfigurationResponse";
const _UPR = "UpdatePackageRequest";
const _UPRp = "UpdatePackageResponse";
const _UPT = "UpdateProvisioningTemplate";
const _UPTR = "UpdateProvisioningTemplateRequest";
const _UPTRp = "UpdateProvisioningTemplateResponse";
const _UPV = "UpdatePackageVersion";
const _UPVR = "UpdatePackageVersionRequest";
const _UPVRp = "UpdatePackageVersionResponse";
const _UPp = "UpdatePackage";
const _UPs = "UserProperties";
const _UR = "UntagResource";
const _URA = "UpdateRoleAlias";
const _URAR = "UpdateRoleAliasRequest";
const _URARp = "UpdateRoleAliasResponse";
const _URR = "UntagResourceRequest";
const _URRn = "UntagResourceResponse";
const _US = "UpdateStream";
const _USA = "UpdateScheduledAudit";
const _USAR = "UpdateScheduledAuditRequest";
const _USARp = "UpdateScheduledAuditResponse";
const _USP = "UpdateSecurityProfile";
const _USPR = "UpdateSecurityProfileRequest";
const _USPRp = "UpdateSecurityProfileResponse";
const _USR = "UpdateStreamRequest";
const _USRp = "UpdateStreamResponse";
const _UT = "UpdateThing";
const _UTG = "UpdateThingGroup";
const _UTGFT = "UpdateThingGroupsForThing";
const _UTGFTR = "UpdateThingGroupsForThingRequest";
const _UTGFTRp = "UpdateThingGroupsForThingResponse";
const _UTGR = "UpdateThingGroupRequest";
const _UTGRp = "UpdateThingGroupResponse";
const _UTR = "UpdateThingRequest";
const _UTRD = "UpdateTopicRuleDestination";
const _UTRDR = "UpdateTopicRuleDestinationRequest";
const _UTRDRp = "UpdateTopicRuleDestinationResponse";
const _UTRp = "UpdateThingResponse";
const _UTT = "UpdateThingType";
const _UTTR = "UpdateThingTypeRequest";
const _UTTRp = "UpdateThingTypeResponse";
const _V = "Value";
const _VCE = "VersionConflictException";
const _VDC = "VpcDestinationConfiguration";
const _VDP = "VpcDestinationProperties";
const _VDS = "VpcDestinationSummary";
const _VE = "ValidationException";
const _VEAI = "ViolationEventAdditionalInfo";
const _VEOR = "ViolationEventOccurrenceRange";
const _VEa = "ValidationError";
const _VEal = "ValidationErrors";
const _VEi = "ViolationEvent";
const _VEio = "ViolationEvents";
const _VLEE = "VersionsLimitExceededException";
const _VSPB = "ValidateSecurityProfileBehaviors";
const _VSPBR = "ValidateSecurityProfileBehaviorsRequest";
const _VSPBRa = "ValidateSecurityProfileBehaviorsResponse";
const _VUBJC = "VersionUpdateByJobsConfig";
const _a = "action";
const _aA = "authorizerArn";
const _aAO = "allowAuthorizerOverride";
const _aAR = "allowAutoRegistration";
const _aAc = "actionArn";
const _aC = "authorizerConfig";
const _aCC = "auditCheckConfigurations";
const _aCL = "abortCriteriaList";
const _aCTAM = "auditCheckToActionsMapping";
const _aCTRCF = "auditCheckToReasonCodeFilter";
const _aCb = "abortConfig";
const _aD = "authDecision";
const _aDFO = "accountDefaultForOperations";
const _aDc = "actionsDefinition";
const _aDcc = "acceptDate";
const _aDu = "auditDetails";
const _aDut = "authorizerDescription";
const _aE = "actionsExecuted";
const _aEc = "actionsExecutions";
const _aF = "aggregationField";
const _aFA = "authorizerFunctionArn";
const _aFc = "actionsFailed";
const _aI = "actionId";
const _aIJA = "awsIotJobArn";
const _aIJI = "awsIotJobId";
const _aISV = "awsIotSqlVersion";
const _aIc = "actionIdentifiers";
const _aId = "additionalInfo";
const _aIs = "assetId";
const _aIu = "authInfo";
const _aIut = "authInfos";
const _aJAC = "awsJobAbortConfig";
const _aJERC = "awsJobExecutionsRolloutConfig";
const _aJPUC = "awsJobPresignedUrlConfig";
const _aJS = "awsJsonSubstitution";
const _aJTC = "awsJobTimeoutConfig";
const _aMTR = "additionalMetricsToRetain";
const _aMTRV = "additionalMetricsToRetainV2";
const _aN = "actionName";
const _aNTC = "auditNotificationTargetConfigurations";
const _aNl = "alarmName";
const _aNt = "attributeName";
const _aNu = "authorizerName";
const _aO = "ascendingOrder";
const _aP = "applicationProtocol";
const _aPc = "actionParams";
const _aPd = "additionalParameters";
const _aPt = "attributePayload";
const _aR = "authResults";
const _aRS = "autoRegistrationStatus";
const _aS = "actionsSkipped";
const _aSBTO = "approximateSecondsBeforeTimedOut";
const _aSJI = "awsSignerJobId";
const _aSc = "actionStatus";
const _aT = "actionType";
const _aTA = "alertTargetArn";
const _aTI = "auditTaskId";
const _aTTTGP = "addThingsToThingGroupParams";
const _aTg = "aggregationType";
const _aTl = "alertTargets";
const _aTu = "authenticationType";
const _aV = "activeViolations";
const _aVt = "attributeValue";
const _ac = "account";
const _act = "actions";
const _af = "after";
const _al = "allowed";
const _ar = "arn";
const _art = "artifact";
const _at = "attributes";
const _au = "auth";
const _aut = "authorizers";
const _av = "average";
const _b = "behavior";
const _bAT = "bucketsAggregationType";
const _bC = "batchConfig";
const _bCT = "behaviorCriteriaType";
const _bG = "billingGroups";
const _bGA = "billingGroupArn";
const _bGD = "billingGroupDescription";
const _bGI = "billingGroupId";
const _bGM = "billingGroupMetadata";
const _bGN = "billingGroupName";
const _bGP = "billingGroupProperties";
const _bM = "batchMode";
const _bN = "behaviorName";
const _bNu = "bucketName";
const _bRPM = "baseRatePerMinute";
const _bS = "beforeSubstitution";
const _bV = "booleanValue";
const _be = "behaviors";
const _bef = "before";
const _bu = "buckets";
const _buc = "bucket";
const _c = "client";
const _cA = "cloudwatchAlarm";
const _cAa = "cannedAcl";
const _cAe = "certificateArn";
const _cAh = "channelArn";
const _cAo = "commandArn";
const _cAom = "completedAt";
const _cAon = "connectionAttribute";
const _cAr = "createdAt";
const _cC = "checkCompliant";
const _cCC = "clientCertificateConfig";
const _cCCA = "clientCertificateCallbackArn";
const _cCI = "caCertificateId";
const _cCP = "caCertificatePem";
const _cCS = "customCodeSigning";
const _cCa = "caCertificate";
const _cCan = "canceledChecks";
const _cCe = "certificateChain";
const _cCo = "compliantChecks";
const _cD = "creationDate";
const _cDS = "credentialDurationSeconds";
const _cDTA = "consecutiveDatapointsToAlarm";
const _cDTC = "consecutiveDatapointsToClear";
const _cDe = "certificateDescription";
const _cDo = "configurationDetails";
const _cDor = "correlationData";
const _cDr = "createDate";
const _cE = "commandExecutions";
const _cF = "customFields";
const _cFC = "canceledFindingsCount";
const _cI = "certificateId";
const _cIPI = "cognitoIdentityPoolId";
const _cIl = "clientId";
const _cIo = "commandId";
const _cL = "criteriaList";
const _cLl = "cloudwatchLogs";
const _cLo = "confidenceLevel";
const _cM = "cloudwatchMetric";
const _cMe = "certificateMode";
const _cN = "checkName";
const _cNe = "certificateName";
const _cNh = "channelName";
const _cO = "comparisonOperator";
const _cP = "certificatePem";
const _cPA = "certificateProviderArn";
const _cPN = "certificateProviderName";
const _cPNo = "commandParameterName";
const _cPOD = "certificatePathOnDevice";
const _cPe = "certificateProviders";
const _cPl = "clientProperties";
const _cRS = "checkRunStatus";
const _cRT = "clientRequestToken";
const _cS = "configurationStatus";
const _cSR = "certificateSigningRequest";
const _cSo = "codeSigning";
const _cT = "clientToken";
const _cTF = "completedTimeFilter";
const _cTo = "contentType";
const _cTon = "confirmationToken";
const _cU = "confirmationUrl";
const _cV = "customerVersion";
const _ca = "cardinality";
const _ce = "certificates";
const _ci = "cidrs";
const _co = "comment";
const _cod = "code";
const _com = "commands";
const _con = "configuration";
const _conn = "connected";
const _conne = "connectivity";
const _cont = "content";
const _cou = "count";
const _cr = "criteria";
const _d = "description";
const _dA = "destinationArn";
const _dAIS = "disconnectAfterInSeconds";
const _dAL = "disableAllLogs";
const _dAMTR = "deleteAdditionalMetricsToRetain";
const _dAN = "defaultAuthorizerName";
const _dAT = "deleteAlertTargets";
const _dB = "deleteBehaviors";
const _dC = "destinationConfiguration";
const _dCA = "domainConfigurationArn";
const _dCAe = "deviceCertificateArn";
const _dCI = "defaultClientId";
const _dCIe = "deviceCertificateId";
const _dCN = "domainConfigurationName";
const _dCP = "datapointsCollectionPercentage";
const _dCS = "domainConfigurationStatus";
const _dCo = "domainConfigurations";
const _dD = "deviceDefender";
const _dDB = "dynamoDB";
const _dDBy = "dynamoDBv2";
const _dDIM = "deviceDefenderIndexingMode";
const _dDe = "deprecationDate";
const _dI = "deviceId";
const _dIM = "durationInMinutes";
const _dLL = "defaultLogLevel";
const _dM = "detailsMap";
const _dMEC = "deleteMetricsExportConfig";
const _dN = "displayName";
const _dNa = "databaseName";
const _dNi = "dimensionNames";
const _dNim = "dimensionName";
const _dNo = "domainName";
const _dOM = "dayOfMonth";
const _dOW = "dayOfWeek";
const _dP = "documentParameters";
const _dPV = "destinationPackageVersions";
const _dR = "disconnectReason";
const _dS = "durationSeconds";
const _dSA = "deleteScheduledAudits";
const _dSN = "deliveryStreamName";
const _dSe = "deleteStream";
const _dSes = "destinationSummaries";
const _dSo = "documentSource";
const _dT = "domainType";
const _dV = "defaultValue";
const _dVI = "defaultVersionId";
const _dVN = "defaultVersionName";
const _dVO = "dimensionValueOperator";
const _dVo = "doubleValue";
const _de = "denied";
const _dep = "deprecated";
const _des = "destination";
const _di = "dimensions";
const _do = "document";
const _e = "error";
const _eA = "endpointAddress";
const _eAr = "errorAction";
const _eB = "enableBatching";
const _eBn = "endBehavior";
const _eC = "errorCode";
const _eCFH = "enableCachingForHttp";
const _eCv = "eventConfigurations";
const _eD = "expirationDate";
const _eDx = "explicitDeny";
const _eED = "executionEndDate";
const _eI = "executionId";
const _eIS = "expiresInSec";
const _eITLP = "enableIoTLoggingParams";
const _eIn = "entryId";
const _eIr = "errorInfo";
const _eM = "exportMetric";
const _eMr = "errorMessage";
const _eN = "executionNumber";
const _eNP = "executionNamePrefix";
const _eOCSPC = "enableOCSPCheck";
const _eP = "effectivePolicies";
const _eR = "exponentialRate";
const _eRr = "errorReason";
const _eS = "executionSummaries";
const _eSD = "executionStartDate";
const _eT = "endTime";
const _eTS = "executionTimeoutSeconds";
const _eTn = "encryptionType";
const _eTnd = "endpointType";
const _eTv = "eventType";
const _eV = "expectedVersion";
const _el = "elasticsearch";
const _en = "enabled";
const _end = "endpoint";
const _env = "environments";
const _ex = "expiration";
const _exa = "example";
const _exe = "execution";
const _f = "firehose";
const _fA = "functionArn";
const _fC = "failureCount";
const _fCa = "failedChecks";
const _fCo = "forceCanceled";
const _fD = "forceDelete";
const _fDAWSJ = "forceDeleteAWSJob";
const _fFC = "failedFindingsCount";
const _fI = "findingId";
const _fIi = "findingIds";
const _fIil = "fileId";
const _fL = "fileLocation";
const _fM = "fleetMetrics";
const _fN = "fileName";
const _fT = "failureType";
const _fTi = "findingTime";
const _fTil = "fileType";
const _fV = "fileVersion";
const _fi = "files";
const _fil = "filter";
const _fin = "finding";
const _find = "findings";
const _fo = "force";
const _fr = "frequency";
const _gA = "groupArn";
const _gI = "generationId";
const _gL = "geoLocations";
const _gN = "groupName";
const _h = "http";
const _hA = "hashAlgorithm";
const _hC = "httpContext";
const _hE = "httpError";
const _hH = "httpHeader";
const _hKF = "hashKeyField";
const _hKT = "hashKeyType";
const _hKV = "hashKeyValue";
const _hQ = "httpQuery";
const _hUC = "httpUrlConfiguration";
const _hUP = "httpUrlProperties";
const _hUS = "httpUrlSummary";
const _he = "headers";
const _i = "index";
const _iA = "iotAnalytics";
const _iAO = "isAscendingOrder";
const _iAs = "isAuthenticated";
const _iC = "isConcurrent";
const _iCI = "issuerCertificateIdentifier";
const _iCS = "issuerCertificateSubject";
const _iCSN = "issuerCertificateSerialNumber";
const _iD = "inlineDocument";
const _iDV = "isDefaultVersion";
const _iDm = "implicitDeny";
const _iE = "iotEvents";
const _iF = "incrementFactor";
const _iFB = "inputFileBucket";
const _iFK = "inputFileKey";
const _iI = "issuerId";
const _iN = "indexName";
const _iNn = "inputName";
const _iNnd = "indexNames";
const _iOAV = "includeOnlyActiveViolations";
const _iPC = "inProgressChecks";
const _iPTIM = "inProgressTimeoutInMinutes";
const _iR = "includeResult";
const _iRA = "iamRoleArn";
const _iS = "isSuppressed";
const _iSA = "includeSuppressedAlerts";
const _iSW = "iotSiteWise";
const _iSn = "indexStatus";
const _iT = "idempotencyToken";
const _iV = "integerValue";
const _id = "id";
const _j = "job";
const _jA = "jobArn";
const _jERC = "jobExecutionsRolloutConfig";
const _jERCo = "jobExecutionsRetryConfig";
const _jES = "jobExecutionSummary";
const _jI = "jobId";
const _jPD = "jobProcessDetails";
const _jT = "jobTemplates";
const _jTA = "jobTemplateArn";
const _jTI = "jobTemplateId";
const _jo = "jobs";
const _k = "kinesis";
const _kARA = "kmsAccessRoleArn";
const _kKA = "kmsKeyArn";
const _kP = "keyPair";
const _kV = "keyValue";
const _ka = "kafka";
const _ke = "key";
const _l = "lambda";
const _lD = "logDestination";
const _lFA = "lambdaFunctionArn";
const _lGN = "logGroupName";
const _lL = "logLevel";
const _lMD = "lastModifiedDate";
const _lMRD = "lastModelRefreshDate";
const _lOP = "loggingOptionsPayload";
const _lSA = "listSuppressedAlerts";
const _lSCD = "lastStatusChangeDate";
const _lSF = "listSuppressedFindings";
const _lT = "logTarget";
const _lTC = "logTargetConfigurations";
const _lUA = "lastUpdatedAt";
const _lVT = "lastViolationTime";
const _lVV = "lastViolationValue";
const _la = "latitude";
const _lo = "location";
const _lon = "longitude";
const _m = "message";
const _mA = "metricArn";
const _mB = "maxBuckets";
const _mBOM = "maxBatchOpenMs";
const _mBS = "maxBatchSize";
const _mBSB = "maxBatchSizeBytes";
const _mC = "mqttContext";
const _mCV = "missingContextValues";
const _mCq = "mqtt5Configuration";
const _mD = "metricDimension";
const _mDC = "mlDetectionConfig";
const _mDL = "metricDatumList";
const _mE = "messageExpiry";
const _mEC = "metricsExportConfig";
const _mF = "messageFormat";
const _mFa = "managedFields";
const _mI = "messageId";
const _mJT = "managedJobTemplates";
const _mN = "metricNamespace";
const _mNOET = "minNumberOfExecutedThings";
const _mNe = "metricName";
const _mNet = "metricNames";
const _mP = "mandatoryParameters";
const _mPM = "maximumPerMinute";
const _mR = "maxResults";
const _mS = "modelStatus";
const _mT = "metricTimestamp";
const _mTe = "metricType";
const _mTq = "mqttTopic";
const _mU = "metricUnit";
const _mV = "metricValue";
const _mW = "maintenanceWindows";
const _ma = "max";
const _mar = "marker";
const _max = "maximum";
const _me = "merge";
const _met = "metric";
const _mi = "min";
const _min = "minimum";
const _n = "name";
const _nA = "notAfter";
const _nARS = "newAutoRegistrationStatus";
const _nB = "notBefore";
const _nCC = "nonCompliantChecks";
const _nCR = "nonCompliantResource";
const _nCRC = "nonCompliantResourcesCount";
const _nI = "namespaceId";
const _nM = "nextMarker";
const _nOCT = "numberOfCanceledThings";
const _nOFT = "numberOfFailedThings";
const _nOIPT = "numberOfInProgressThings";
const _nONT = "numberOfNotifiedThings";
const _nOQT = "numberOfQueuedThings";
const _nOR = "numberOfRetries";
const _nORT = "numberOfRejectedThings";
const _nORTu = "numberOfRemovedThings";
const _nOST = "numberOfSucceededThings";
const _nOTOT = "numberOfTimedOutThings";
const _nPF = "namePrefixFilter";
const _nR = "numberRange";
const _nS = "newStatus";
const _nSIM = "namedShadowIndexingMode";
const _nSN = "namedShadowNames";
const _nT = "nextToken";
const _na = "namespace";
const _nu = "number";
const _num = "numbers";
const _o = "operand";
const _oARA = "ocspAuthorizedResponderArn";
const _oAVI = "onlyActiveViolationsIncluded";
const _oB = "ownedBy";
const _oC = "outgoingCertificates";
const _oDG = "overrideDynamicGroups";
const _oF = "outputFormat";
const _oIN = "offsetInNanos";
const _oLA = "ocspLambdaArn";
const _oS = "openSearch";
const _oU = "otaUpdates";
const _oUA = "otaUpdateArn";
const _oUF = "otaUpdateFiles";
const _oUI = "otaUpdateId";
const _oUIt = "otaUpdateInfo";
const _oUS = "otaUpdateStatus";
const _op = "optional";
const _ope = "operation";
const _oper = "operator";
const _or = "order";
const _ow = "owner";
const _p = "policies";
const _pA = "packageArn";
const _pAPVE = "putAssetPropertyValueEntries";
const _pAo = "policyArn";
const _pAr = "propagatingAttributes";
const _pAro = "propertyAlias";
const _pD = "pendingDeletion";
const _pDo = "policyDocument";
const _pDol = "policyDocuments";
const _pF = "payloadField";
const _pFI = "payloadFormatIndicator";
const _pFTSP = "publishFindingToSnsParams";
const _pG = "parentGroup";
const _pGN = "parentGroupName";
const _pGNa = "parentGroupNames";
const _pI = "putItem";
const _pIr = "propertyId";
const _pIri = "principalId";
const _pK = "partitionKey";
const _pN = "packageName";
const _pNTA = "policyNamesToAdd";
const _pNTS = "policyNamesToSkip";
const _pNo = "policyName";
const _pOB = "previousOwnedBy";
const _pP = "percentageProgress";
const _pPH = "preProvisioningHook";
const _pRA = "provisioningRoleArn";
const _pS = "pageSize";
const _pSa = "packageSummaries";
const _pT = "payloadTemplate";
const _pTO = "principalThingObjects";
const _pTr = "processingTargets";
const _pUC = "presignedUrlConfig";
const _pV = "policyVersions";
const _pVA = "packageVersionArn";
const _pVI = "policyVersionId";
const _pVIo = "policyVersionIdentifier";
const _pVS = "packageVersionSummaries";
const _pVa = "payloadVersion";
const _pVr = "propertyValues";
const _pa = "payload";
const _par = "parameters";
const _part = "partition";
const _pas = "password";
const _pe = "period";
const _per = "percents";
const _perc = "percentiles";
const _perce = "percent";
const _pl = "platform";
const _po = "ports";
const _pr = "principal";
const _pre = "preprocessor";
const _pref = "prefix";
const _pri = "principals";
const _pro = "protocols";
const _q = "quality";
const _qA = "queuedAt";
const _qS = "queryString";
const _qU = "queueUrl";
const _qV = "queryVersion";
const _qo = "qos";
const _r = "republish";
const _rA = "resourceArn";
const _rAA = "roleAliasArn";
const _rAC = "removeAuthorizerConfig";
const _rAD = "roleAliasDescription";
const _rAFL = "roleArnForLogging";
const _rAIS = "refreshAfterInSeconds";
const _rAR = "removeAutoRegistration";
const _rAe = "retryAttempt";
const _rAes = "resourceArns";
const _rAo = "roleArn";
const _rAol = "roleAlias";
const _rAole = "roleAliases";
const _rAu = "ruleArn";
const _rC = "reasonCode";
const _rCe = "registrationConfig";
const _rCeg = "registrationCode";
const _rD = "ruleDisabled";
const _rDPVP = "replaceDefaultPolicyVersionParams";
const _rDe = "reasonDescription";
const _rDej = "rejectDate";
const _rFNC = "reasonForNonCompliance";
const _rFNCC = "reasonForNonComplianceCode";
const _rI = "resourceId";
const _rIC = "rateIncreaseCriteria";
const _rIe = "resourceIdentifier";
const _rKF = "rangeKeyField";
const _rKT = "rangeKeyType";
const _rKV = "rangeKeyValue";
const _rL = "resourceLinks";
const _rN = "ruleName";
const _rPPH = "removePreProvisioningHook";
const _rR = "relatedResources";
const _rRe = "rejectReason";
const _rT = "reportType";
const _rTPTG = "rootToParentThingGroups";
const _rTT = "removeThingType";
const _rTe = "responseTopic";
const _rTes = "resourceType";
const _re = "resources";
const _rec = "recipe";
const _recu = "recursive";
const _reg = "regex";
const _res = "result";
const _ru = "rule";
const _rul = "rules";
const _s = "smithy.ts.sdk.synthetic.com.amazonaws.iot";
const _sA = "suppressAlerts";
const _sAA = "setAsActive";
const _sAAc = "scheduledAuditArn";
const _sAD = "setAsDefault";
const _sAI = "suppressedAlertsIncluded";
const _sAN = "scheduledAuditName";
const _sAc = "scheduledAudits";
const _sAe = "searchableAttributes";
const _sAi = "signatureAlgorithm";
const _sAt = "startedAt";
const _sAtr = "streamArn";
const _sC = "schedulingConfig";
const _sCA = "serverCertificateArns";
const _sCAe = "serverCertificateArn";
const _sCC = "serverCertificateConfig";
const _sCS = "serverCertificateStatus";
const _sCSD = "serverCertificateStatusDetail";
const _sCe = "serverCertificates";
const _sCt = "statusCode";
const _sCu = "successCount";
const _sD = "signingDisabled";
const _sDe = "s3Destination";
const _sDt = "statusDetails";
const _sDtd = "stdDeviation";
const _sF = "stepFunctions";
const _sFC = "succeededFindingsCount";
const _sFCk = "skippedFindingsCount";
const _sG = "securityGroups";
const _sI = "suppressIndefinitely";
const _sIt = "streamId";
const _sItr = "streamInfo";
const _sIu = "subnetIds";
const _sJR = "scheduledJobRollouts";
const _sL = "s3Location";
const _sMN = "stateMachineName";
const _sN = "streamName";
const _sNCRC = "suppressedNonCompliantResourcesCount";
const _sNe = "serviceName";
const _sNer = "serverName";
const _sO = "sortOrder";
const _sOS = "sumOfSquares";
const _sP = "securityPolicy";
const _sPA = "securityProfileArn";
const _sPD = "securityProfileDescription";
const _sPI = "securityProfileIdentifiers";
const _sPIe = "securityProfileIdentifier";
const _sPN = "securityProfileName";
const _sPNi = "signingProfileName";
const _sPP = "signingProfileParameter";
const _sPT = "securityProfileTargets";
const _sPTA = "securityProfileTargetArn";
const _sPTM = "securityProfileTargetMappings";
const _sR = "stateReason";
const _sRi = "signingRegion";
const _sRt = "statusReason";
const _sSJP = "startSigningJobParameter";
const _sT = "startTime";
const _sTF = "startedTimeFilter";
const _sTe = "serviceType";
const _sTt = "statisticalThreshold";
const _sV = "stateValue";
const _sVS = "sbomValidationStatus";
const _sVt = "stringValues";
const _sVtr = "streamVersion";
const _sVtri = "stringValue";
const _s_ = "s3";
const _sa = "salesforce";
const _sb = "sbom";
const _sc = "schema";
const _se = "server";
const _sep = "separator";
const _sev = "severity";
const _sh = "shadow";
const _si = "signature";
const _sig = "sigv4";
const _sn = "sns";
const _sq = "sqs";
const _sql = "sql";
const _st = "status";
const _sta = "statistics";
const _stat = "statistic";
const _str = "string";
const _stre = "stream";
const _strea = "streams";
const _stri = "strings";
const _su = "summaries";
const _sum = "sum";
const _sup = "suppressions";
const _t = "timestream";
const _tA = "thingArn";
const _tAA = "targetAwsAccount";
const _tAa = "targetArn";
const _tAe = "termsAggregation";
const _tAem = "templateArn";
const _tAh = "thingAttribute";
const _tAo = "topicArn";
const _tB = "templateBody";
const _tC = "tlsConfig";
const _tCA = "transferredCertificateArn";
const _tCIM = "thingConnectivityIndexingMode";
const _tCN = "targetCheckNames";
const _tCi = "timeoutConfig";
const _tCl = "tlsContext";
const _tCo = "totalCount";
const _tCot = "totalChecks";
const _tD = "transferData";
const _tDCSD = "trainingDataCollectionStartDate";
const _tDr = "transferDate";
const _tET = "taskEndTime";
const _tFC = "totalFindingsCount";
const _tG = "thingGroups";
const _tGA = "thingGroupArn";
const _tGD = "thingGroupDescription";
const _tGI = "thingGroupId";
const _tGIC = "thingGroupIndexingConfiguration";
const _tGIM = "thingGroupIndexingMode";
const _tGM = "thingGroupMetadata";
const _tGN = "thingGroupNames";
const _tGNh = "thingGroupName";
const _tGP = "thingGroupProperties";
const _tGTA = "thingGroupsToAdd";
const _tGTR = "thingGroupsToRemove";
const _tI = "taskId";
const _tIC = "thingIndexingConfiguration";
const _tIM = "thingIndexingMode";
const _tIS = "timeInSeconds";
const _tIa = "taskIds";
const _tIh = "thingId";
const _tK = "tagKeys";
const _tKN = "tokenKeyName";
const _tM = "transferMessage";
const _tN = "thingName";
const _tNa = "targetName";
const _tNab = "tableName";
const _tNe = "templateName";
const _tNr = "trackerName";
const _tP = "thresholdPercentage";
const _tPO = "thingPrincipalObjects";
const _tPT = "thingPrincipalType";
const _tPo = "topicPattern";
const _tRC = "totalResourcesCount";
const _tRD = "topicRuleDestination";
const _tRP = "topicRulePayload";
const _tS = "taskStatus";
const _tSPK = "tokenSigningPublicKeys";
const _tST = "taskStartTime";
const _tSa = "targetSelection";
const _tSas = "taskStatistics";
const _tSask = "taskSummary";
const _tSo = "tokenSignature";
const _tT = "taskType";
const _tTA = "thingTypeArn";
const _tTD = "thingTypeDescription";
const _tTI = "thingTypeId";
const _tTL = "timeToLive";
const _tTM = "thingTypeMetadata";
const _tTN = "thingTypeName";
const _tTP = "thingTypeProperties";
const _tTa = "targetType";
const _tTh = "thingTypes";
const _tTr = "transferredTo";
const _tV = "templateVersion";
const _ta = "targets";
const _tag = "tags";
const _tar = "target";
const _tas = "tasks";
const _te = "templates";
const _th = "things";
const _ti = "timestamp";
const _to = "topic";
const _tok = "token";
const _ty = "type";
const _u = "unit";
const _uB = "useBase64";
const _uCACP = "updateCACertificateParams";
const _uD = "undoDeprecate";
const _uDCP = "updateDeviceCertificateParams";
const _uDV = "unsetDefaultVersion";
const _uP = "userProperties";
const _uPAV = "usePrefixAttributeValue";
const _uPK = "userPropertyKey";
const _ur = "url";
const _us = "username";
const _v = "values";
const _vC = "valueConditions";
const _vCA = "validationCertificateArn";
const _vCe = "verificationCertificate";
const _vCp = "vpcConfiguration";
const _vDS = "vpcDestinationSummary";
const _vE = "violationEvents";
const _vEAI = "violationEventAdditionalInfo";
const _vEOR = "violationEventOccurrenceRange";
const _vET = "violationEventType";
const _vETi = "violationEventTime";
const _vEa = "validationErrors";
const _vI = "violationId";
const _vIe = "versionId";
const _vIi = "violationIds";
const _vIp = "vpcId";
const _vN = "versionName";
const _vNe = "versionNumber";
const _vP = "vpcProperties";
const _vR = "validationResult";
const _vRS = "validationResultSummaries";
const _vS = "verificationState";
const _vSD = "verificationStateDescription";
const _vST = "violationStartTime";
const _vUBJC = "versionUpdateByJobsConfig";
const _va = "value";
const _val = "validity";
const _vali = "valid";
const _var = "variance";
const _ve = "version";
const _ver = "verbose";
const _vers = "versions";
const _wFDCC = "waitingForDataCollectionChecks";
const _xaip = "x-amzn-iot-principal";
const _xaip_ = "x-amzn-iot-policy";
const _xap = "x-amzn-principal";
const _xat = "x-amz-tagging";
const n0 = "com.amazonaws.iot";
const schema_1 = require("@smithy/core/schema");
const errors_1 = require("../models/errors");
const IoTServiceException_1 = require("../models/IoTServiceException");
const _s_registry = schema_1.TypeRegistry.for(_s);
exports.IoTServiceException$ = [-3, _s, "IoTServiceException", 0, [], []];
_s_registry.registerError(exports.IoTServiceException$, IoTServiceException_1.IoTServiceException);
const n0_registry = schema_1.TypeRegistry.for(n0);
exports.CertificateConflictException$ = [-3, n0, _CCE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.CertificateConflictException$, errors_1.CertificateConflictException);
exports.CertificateStateException$ = [-3, n0, _CSE,
    { [_e]: _c, [_hE]: 406 },
    [_m],
    [0]
];
n0_registry.registerError(exports.CertificateStateException$, errors_1.CertificateStateException);
exports.CertificateValidationException$ = [-3, n0, _CVE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.CertificateValidationException$, errors_1.CertificateValidationException);
exports.ConflictException$ = [-3, n0, _CE,
    { [_e]: _c, [_hE]: 409 },
    [_m, _rI],
    [0, 0]
];
n0_registry.registerError(exports.ConflictException$, errors_1.ConflictException);
exports.ConflictingResourceUpdateException$ = [-3, n0, _CRUE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ConflictingResourceUpdateException$, errors_1.ConflictingResourceUpdateException);
exports.DeleteConflictException$ = [-3, n0, _DCE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.DeleteConflictException$, errors_1.DeleteConflictException);
exports.IndexNotReadyException$ = [-3, n0, _INRE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.IndexNotReadyException$, errors_1.IndexNotReadyException);
exports.InternalException$ = [-3, n0, _IE,
    { [_e]: _se, [_hE]: 500 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InternalException$, errors_1.InternalException);
exports.InternalFailureException$ = [-3, n0, _IFE,
    { [_e]: _se, [_hE]: 500 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InternalFailureException$, errors_1.InternalFailureException);
exports.InternalServerException$ = [-3, n0, _ISE,
    { [_e]: _se, [_hE]: 500 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InternalServerException$, errors_1.InternalServerException);
exports.InvalidAggregationException$ = [-3, n0, _IAE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidAggregationException$, errors_1.InvalidAggregationException);
exports.InvalidQueryException$ = [-3, n0, _IQE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidQueryException$, errors_1.InvalidQueryException);
exports.InvalidRequestException$ = [-3, n0, _IRE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidRequestException$, errors_1.InvalidRequestException);
exports.InvalidResponseException$ = [-3, n0, _IREn,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidResponseException$, errors_1.InvalidResponseException);
exports.InvalidStateTransitionException$ = [-3, n0, _ISTE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.InvalidStateTransitionException$, errors_1.InvalidStateTransitionException);
exports.LimitExceededException$ = [-3, n0, _LEE,
    { [_e]: _c, [_hE]: 410 },
    [_m],
    [0]
];
n0_registry.registerError(exports.LimitExceededException$, errors_1.LimitExceededException);
exports.MalformedPolicyException$ = [-3, n0, _MPE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.MalformedPolicyException$, errors_1.MalformedPolicyException);
exports.NotConfiguredException$ = [-3, n0, _NCE,
    { [_e]: _c, [_hE]: 404 },
    [_m],
    [0]
];
n0_registry.registerError(exports.NotConfiguredException$, errors_1.NotConfiguredException);
exports.RegistrationCodeValidationException$ = [-3, n0, _RCVE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.RegistrationCodeValidationException$, errors_1.RegistrationCodeValidationException);
exports.ResourceAlreadyExistsException$ = [-3, n0, _RAEE,
    { [_e]: _c, [_hE]: 409 },
    [_m, _rI, _rA],
    [0, 0, 0]
];
n0_registry.registerError(exports.ResourceAlreadyExistsException$, errors_1.ResourceAlreadyExistsException);
exports.ResourceNotFoundException$ = [-3, n0, _RNFE,
    { [_e]: _c, [_hE]: 404 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ResourceNotFoundException$, errors_1.ResourceNotFoundException);
exports.ResourceRegistrationFailureException$ = [-3, n0, _RRFE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ResourceRegistrationFailureException$, errors_1.ResourceRegistrationFailureException);
exports.ServiceQuotaExceededException$ = [-3, n0, _SQEE,
    { [_e]: _c, [_hE]: 402 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ServiceQuotaExceededException$, errors_1.ServiceQuotaExceededException);
exports.ServiceUnavailableException$ = [-3, n0, _SUE,
    { [_e]: _se, [_hE]: 503 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ServiceUnavailableException$, errors_1.ServiceUnavailableException);
exports.SqlParseException$ = [-3, n0, _SPE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.SqlParseException$, errors_1.SqlParseException);
exports.TaskAlreadyExistsException$ = [-3, n0, _TAEE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.TaskAlreadyExistsException$, errors_1.TaskAlreadyExistsException);
exports.ThrottlingException$ = [-3, n0, _TE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ThrottlingException$, errors_1.ThrottlingException);
exports.TransferAlreadyCompletedException$ = [-3, n0, _TACE,
    { [_e]: _c, [_hE]: 410 },
    [_m],
    [0]
];
n0_registry.registerError(exports.TransferAlreadyCompletedException$, errors_1.TransferAlreadyCompletedException);
exports.TransferConflictException$ = [-3, n0, _TCE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.TransferConflictException$, errors_1.TransferConflictException);
exports.UnauthorizedException$ = [-3, n0, _UE,
    { [_e]: _c, [_hE]: 401 },
    [_m],
    [0]
];
n0_registry.registerError(exports.UnauthorizedException$, errors_1.UnauthorizedException);
exports.ValidationException$ = [-3, n0, _VE,
    { [_e]: _c, [_hE]: 400 },
    [_m],
    [0]
];
n0_registry.registerError(exports.ValidationException$, errors_1.ValidationException);
exports.VersionConflictException$ = [-3, n0, _VCE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.VersionConflictException$, errors_1.VersionConflictException);
exports.VersionsLimitExceededException$ = [-3, n0, _VLEE,
    { [_e]: _c, [_hE]: 409 },
    [_m],
    [0]
];
n0_registry.registerError(exports.VersionsLimitExceededException$, errors_1.VersionsLimitExceededException);
exports.errorTypeRegistries = [
    _s_registry,
    n0_registry,
];
var ConnectivityApiThingName = [0, n0, _CATN, 8, 0];
var PackageVersionRecipe = [0, n0, _PVR, 8, 0];
var PrivateKey = [0, n0, _PK, 8, 0];
var ResourceDescription = [0, n0, _RD, 8, 0];
exports.AbortConfig$ = [3, n0, _AC,
    0,
    [_cL],
    [() => AbortCriteriaList], 1
];
exports.AbortCriteria$ = [3, n0, _ACb,
    0,
    [_fT, _a, _tP, _mNOET],
    [0, 0, 1, 1], 4
];
exports.AcceptCertificateTransferRequest$ = [3, n0, _ACTR,
    0,
    [_cI, _sAA],
    [[0, 1], [2, { [_hQ]: _sAA }]], 1
];
exports.Action$ = [3, n0, _A,
    0,
    [_dDB, _dDBy, _l, _sn, _sq, _k, _r, _s_, _f, _cM, _cA, _cLl, _el, _sa, _iA, _iE, _iSW, _sF, _t, _h, _ka, _oS, _lo],
    [() => exports.DynamoDBAction$, () => exports.DynamoDBv2Action$, () => exports.LambdaAction$, () => exports.SnsAction$, () => exports.SqsAction$, () => exports.KinesisAction$, () => exports.RepublishAction$, () => exports.S3Action$, () => exports.FirehoseAction$, () => exports.CloudwatchMetricAction$, () => exports.CloudwatchAlarmAction$, () => exports.CloudwatchLogsAction$, () => exports.ElasticsearchAction$, () => exports.SalesforceAction$, () => exports.IotAnalyticsAction$, () => exports.IotEventsAction$, () => exports.IotSiteWiseAction$, () => exports.StepFunctionsAction$, () => exports.TimestreamAction$, () => exports.HttpAction$, () => exports.KafkaAction$, () => exports.OpenSearchAction$, () => exports.LocationAction$]
];
exports.ActiveViolation$ = [3, n0, _AV,
    0,
    [_vI, _tN, _sPN, _b, _lVV, _vEAI, _vS, _vSD, _lVT, _vST],
    [0, 0, 0, () => exports.Behavior$, () => exports.MetricValue$, () => exports.ViolationEventAdditionalInfo$, 0, 0, 4, 4]
];
exports.AddThingsToThingGroupParams$ = [3, n0, _ATTTGP,
    0,
    [_tGN, _oDG],
    [64 | 0, 2], 1
];
exports.AddThingToBillingGroupRequest$ = [3, n0, _ATTBGR,
    0,
    [_bGN, _bGA, _tN, _tA],
    [0, 0, 0, 0]
];
exports.AddThingToBillingGroupResponse$ = [3, n0, _ATTBGRd,
    0,
    [],
    []
];
exports.AddThingToThingGroupRequest$ = [3, n0, _ATTTGR,
    0,
    [_tGNh, _tGA, _tN, _tA, _oDG],
    [0, 0, 0, 0, 2]
];
exports.AddThingToThingGroupResponse$ = [3, n0, _ATTTGRd,
    0,
    [],
    []
];
exports.AggregationType$ = [3, n0, _AT,
    0,
    [_n, _v],
    [0, 64 | 0], 1
];
exports.AlertTarget$ = [3, n0, _ATl,
    0,
    [_aTA, _rAo],
    [0, 0], 2
];
exports.Allowed$ = [3, n0, _Al,
    0,
    [_p],
    [() => Policies]
];
exports.AssetPropertyTimestamp$ = [3, n0, _APT,
    0,
    [_tIS, _oIN],
    [0, 0], 1
];
exports.AssetPropertyValue$ = [3, n0, _APV,
    0,
    [_va, _ti, _q],
    [() => exports.AssetPropertyVariant$, () => exports.AssetPropertyTimestamp$, 0], 2
];
exports.AssociateSbomWithPackageVersionRequest$ = [3, n0, _ASWPVR,
    0,
    [_pN, _vN, _sb, _cT],
    [[0, 1], [0, 1], () => exports.Sbom$, [0, { [_hQ]: _cT, [_iT]: 1 }]], 3
];
exports.AssociateSbomWithPackageVersionResponse$ = [3, n0, _ASWPVRs,
    0,
    [_pN, _vN, _sb, _sVS],
    [0, 0, () => exports.Sbom$, 0]
];
exports.AssociateTargetsWithJobRequest$ = [3, n0, _ATWJR,
    0,
    [_ta, _jI, _co, _nI],
    [64 | 0, [0, 1], 0, [0, { [_hQ]: _nI }]], 2
];
exports.AssociateTargetsWithJobResponse$ = [3, n0, _ATWJRs,
    0,
    [_jA, _jI, _d],
    [0, 0, 0]
];
exports.AttachPolicyRequest$ = [3, n0, _APR,
    0,
    [_pNo, _tar],
    [[0, 1], 0], 2
];
exports.AttachPrincipalPolicyRequest$ = [3, n0, _APPR,
    0,
    [_pNo, _pr],
    [[0, 1], [0, { [_hH]: _xaip }]], 2
];
exports.AttachSecurityProfileRequest$ = [3, n0, _ASPR,
    0,
    [_sPN, _sPTA],
    [[0, 1], [0, { [_hQ]: _sPTA }]], 2
];
exports.AttachSecurityProfileResponse$ = [3, n0, _ASPRt,
    0,
    [],
    []
];
exports.AttachThingPrincipalRequest$ = [3, n0, _ATPR,
    0,
    [_tN, _pr, _tPT],
    [[0, 1], [0, { [_hH]: _xap }], [0, { [_hQ]: _tPT }]], 2
];
exports.AttachThingPrincipalResponse$ = [3, n0, _ATPRt,
    0,
    [],
    []
];
exports.AttributePayload$ = [3, n0, _AP,
    0,
    [_at, _me],
    [128 | 0, 2]
];
exports.AuditCheckConfiguration$ = [3, n0, _ACC,
    0,
    [_en, _con],
    [2, 128 | 0]
];
exports.AuditCheckDetails$ = [3, n0, _ACD,
    0,
    [_cRS, _cC, _tRC, _nCRC, _sNCRC, _eC, _m],
    [0, 2, 1, 1, 1, 0, 0]
];
exports.AuditFinding$ = [3, n0, _AF,
    0,
    [_fI, _tI, _cN, _tST, _fTi, _sev, _nCR, _rR, _rFNC, _rFNCC, _iS],
    [0, 0, 0, 4, 4, 0, () => exports.NonCompliantResource$, () => RelatedResources, 0, 0, 2]
];
exports.AuditMitigationActionExecutionMetadata$ = [3, n0, _AMAEM,
    0,
    [_tI, _fI, _aN, _aI, _st, _sT, _eT, _eC, _m],
    [0, 0, 0, 0, 0, 4, 4, 0, 0]
];
exports.AuditMitigationActionsTaskMetadata$ = [3, n0, _AMATM,
    0,
    [_tI, _sT, _tS],
    [0, 4, 0]
];
exports.AuditMitigationActionsTaskTarget$ = [3, n0, _AMATT,
    0,
    [_aTI, _fIi, _aCTRCF],
    [0, 64 | 0, [2, n0, _ACTRCF, 0, 0, 64 | 0]]
];
exports.AuditNotificationTarget$ = [3, n0, _ANT,
    0,
    [_tAa, _rAo, _en],
    [0, 0, 2]
];
exports.AuditSuppression$ = [3, n0, _AS,
    0,
    [_cN, _rIe, _eD, _sI, _d],
    [0, () => exports.ResourceIdentifier$, 4, 2, 0], 2
];
exports.AuditTaskMetadata$ = [3, n0, _ATM,
    0,
    [_tI, _tS, _tT],
    [0, 0, 0]
];
exports.AuthInfo$ = [3, n0, _AI,
    0,
    [_re, _aT],
    [64 | 0, 0], 1
];
exports.AuthorizerConfig$ = [3, n0, _ACu,
    0,
    [_dAN, _aAO],
    [0, 2]
];
exports.AuthorizerDescription$ = [3, n0, _AD,
    0,
    [_aNu, _aA, _aFA, _tKN, _tSPK, _st, _cD, _lMD, _sD, _eCFH],
    [0, 0, 0, 0, 128 | 0, 0, 4, 4, 2, 2]
];
exports.AuthorizerSummary$ = [3, n0, _ASu,
    0,
    [_aNu, _aA],
    [0, 0]
];
exports.AuthResult$ = [3, n0, _AR,
    0,
    [_aIu, _al, _de, _aD, _mCV],
    [() => exports.AuthInfo$, () => exports.Allowed$, () => exports.Denied$, 0, 64 | 0]
];
exports.AwsJobAbortConfig$ = [3, n0, _AJAC,
    0,
    [_aCL],
    [() => AwsJobAbortCriteriaList], 1
];
exports.AwsJobAbortCriteria$ = [3, n0, _AJACw,
    0,
    [_fT, _a, _tP, _mNOET],
    [0, 0, 1, 1], 4
];
exports.AwsJobExecutionsRolloutConfig$ = [3, n0, _AJERC,
    0,
    [_mPM, _eR],
    [1, () => exports.AwsJobExponentialRolloutRate$]
];
exports.AwsJobExponentialRolloutRate$ = [3, n0, _AJERR,
    0,
    [_bRPM, _iF, _rIC],
    [1, 1, () => exports.AwsJobRateIncreaseCriteria$], 3
];
exports.AwsJobPresignedUrlConfig$ = [3, n0, _AJPUC,
    0,
    [_eIS],
    [1]
];
exports.AwsJobRateIncreaseCriteria$ = [3, n0, _AJRIC,
    0,
    [_nONT, _nOST],
    [1, 1]
];
exports.AwsJobTimeoutConfig$ = [3, n0, _AJTC,
    0,
    [_iPTIM],
    [1]
];
exports.AwsJsonSubstitutionCommandPreprocessorConfig$ = [3, n0, _AJSCPC,
    0,
    [_oF],
    [0], 1
];
exports.BatchConfig$ = [3, n0, _BC,
    0,
    [_mBOM, _mBS, _mBSB],
    [1, 1, 1]
];
exports.Behavior$ = [3, n0, _B,
    0,
    [_n, _met, _mD, _cr, _sA, _eM],
    [0, 0, () => exports.MetricDimension$, () => exports.BehaviorCriteria$, 2, 2], 1
];
exports.BehaviorCriteria$ = [3, n0, _BCe,
    0,
    [_cO, _va, _dS, _cDTA, _cDTC, _sTt, _mDC],
    [0, () => exports.MetricValue$, 1, 1, 1, () => exports.StatisticalThreshold$, () => exports.MachineLearningDetectionConfig$]
];
exports.BehaviorModelTrainingSummary$ = [3, n0, _BMTS,
    0,
    [_sPN, _bN, _tDCSD, _mS, _dCP, _lMRD],
    [0, 0, 4, 0, 1, 4]
];
exports.BillingGroupMetadata$ = [3, n0, _BGM,
    0,
    [_cD],
    [4]
];
exports.BillingGroupProperties$ = [3, n0, _BGP,
    0,
    [_bGD],
    [0]
];
exports.Bucket$ = [3, n0, _Bu,
    0,
    [_kV, _cou],
    [0, 1]
];
exports.BucketsAggregationType$ = [3, n0, _BAT,
    0,
    [_tAe],
    [() => exports.TermsAggregation$]
];
exports.CACertificate$ = [3, n0, _CAC,
    0,
    [_cAe, _cI, _st, _cD],
    [0, 0, 0, 4]
];
exports.CACertificateDescription$ = [3, n0, _CACD,
    0,
    [_cAe, _cI, _st, _cP, _oB, _cD, _aRS, _lMD, _cV, _gI, _val, _cMe],
    [0, 0, 0, 0, 0, 4, 0, 4, 1, 0, () => exports.CertificateValidity$, 0]
];
exports.CancelAuditMitigationActionsTaskRequest$ = [3, n0, _CAMATR,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.CancelAuditMitigationActionsTaskResponse$ = [3, n0, _CAMATRa,
    0,
    [],
    []
];
exports.CancelAuditTaskRequest$ = [3, n0, _CATR,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.CancelAuditTaskResponse$ = [3, n0, _CATRa,
    0,
    [],
    []
];
exports.CancelCertificateTransferRequest$ = [3, n0, _CCTR,
    0,
    [_cI],
    [[0, 1]], 1
];
exports.CancelDetectMitigationActionsTaskRequest$ = [3, n0, _CDMATR,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.CancelDetectMitigationActionsTaskResponse$ = [3, n0, _CDMATRa,
    0,
    [],
    []
];
exports.CancelJobExecutionRequest$ = [3, n0, _CJER,
    0,
    [_jI, _tN, _fo, _eV, _sDt],
    [[0, 1], [0, 1], [2, { [_hQ]: _fo }], 1, 128 | 0], 2
];
exports.CancelJobRequest$ = [3, n0, _CJR,
    0,
    [_jI, _rC, _co, _fo],
    [[0, 1], 0, 0, [2, { [_hQ]: _fo }]], 1
];
exports.CancelJobResponse$ = [3, n0, _CJRa,
    0,
    [_jA, _jI, _d],
    [0, 0, 0]
];
exports.Certificate$ = [3, n0, _C,
    0,
    [_cAe, _cI, _st, _cMe, _cD],
    [0, 0, 0, 0, 4]
];
exports.CertificateDescription$ = [3, n0, _CD,
    0,
    [_cAe, _cI, _cCI, _st, _cP, _oB, _pOB, _cD, _lMD, _cV, _tD, _gI, _val, _cMe],
    [0, 0, 0, 0, 0, 0, 0, 4, 4, 1, () => exports.TransferData$, 0, () => exports.CertificateValidity$, 0]
];
exports.CertificateProviderSummary$ = [3, n0, _CPS,
    0,
    [_cPN, _cPA],
    [0, 0]
];
exports.CertificateValidity$ = [3, n0, _CV,
    0,
    [_nB, _nA],
    [4, 4]
];
exports.ClearDefaultAuthorizerRequest$ = [3, n0, _CDAR,
    0,
    [],
    []
];
exports.ClearDefaultAuthorizerResponse$ = [3, n0, _CDARl,
    0,
    [],
    []
];
exports.ClientCertificateConfig$ = [3, n0, _CCC,
    0,
    [_cCCA],
    [0]
];
exports.CloudwatchAlarmAction$ = [3, n0, _CAA,
    0,
    [_rAo, _aNl, _sR, _sV],
    [0, 0, 0, 0], 4
];
exports.CloudwatchLogsAction$ = [3, n0, _CLA,
    0,
    [_rAo, _lGN, _bM],
    [0, 0, 2], 2
];
exports.CloudwatchMetricAction$ = [3, n0, _CMA,
    0,
    [_rAo, _mN, _mNe, _mV, _mU, _mT],
    [0, 0, 0, 0, 0, 0], 5
];
exports.CodeSigning$ = [3, n0, _CS,
    0,
    [_aSJI, _sSJP, _cCS],
    [0, () => exports.StartSigningJobParameter$, () => exports.CustomCodeSigning$]
];
exports.CodeSigningCertificateChain$ = [3, n0, _CSCC,
    0,
    [_cNe, _iD],
    [0, 0]
];
exports.CodeSigningSignature$ = [3, n0, _CSS,
    0,
    [_iD],
    [21]
];
exports.CommandExecutionResult$ = [3, n0, _CER,
    0,
    [_S, _B_, _BIN],
    [0, 2, 21]
];
exports.CommandExecutionSummary$ = [3, n0, _CES,
    0,
    [_cAo, _eI, _tAa, _st, _cAr, _sAt, _cAom],
    [0, 0, 0, 0, 4, 4, 4]
];
exports.CommandParameter$ = [3, n0, _CP,
    0,
    [_n, _ty, _va, _dV, _vC, _d],
    [0, 0, () => exports.CommandParameterValue$, () => exports.CommandParameterValue$, () => CommandParameterValueConditionList, 0], 1
];
exports.CommandParameterValue$ = [3, n0, _CPV,
    0,
    [_S, _B_, _I, _L, _D, _BIN, _UL],
    [0, 2, 1, 1, 1, 21, 0]
];
exports.CommandParameterValueComparisonOperand$ = [3, n0, _CPVCO,
    0,
    [_nu, _num, _str, _stri, _nR],
    [0, 64 | 0, 0, 64 | 0, () => exports.CommandParameterValueNumberRange$]
];
exports.CommandParameterValueCondition$ = [3, n0, _CPVC,
    0,
    [_cO, _o],
    [0, () => exports.CommandParameterValueComparisonOperand$], 2
];
exports.CommandParameterValueNumberRange$ = [3, n0, _CPVNR,
    0,
    [_mi, _ma],
    [0, 0], 2
];
exports.CommandPayload$ = [3, n0, _CPo,
    0,
    [_cont, _cTo],
    [21, 0]
];
exports.CommandPreprocessor$ = [3, n0, _CPom,
    0,
    [_aJS],
    [() => exports.AwsJsonSubstitutionCommandPreprocessorConfig$]
];
exports.CommandSummary$ = [3, n0, _CSo,
    0,
    [_cAo, _cIo, _dN, _dep, _cAr, _lUA, _pD],
    [0, 0, 0, 2, 4, 4, 2]
];
exports.Configuration$ = [3, n0, _Co,
    0,
    [_E],
    [2]
];
exports.ConfigurationDetails$ = [3, n0, _CDo,
    0,
    [_cS, _eC, _eMr],
    [0, 0, 0]
];
exports.ConfirmTopicRuleDestinationRequest$ = [3, n0, _CTRDR,
    0,
    [_cTon],
    [[0, 1]], 1
];
exports.ConfirmTopicRuleDestinationResponse$ = [3, n0, _CTRDRo,
    0,
    [],
    []
];
exports.CreateAuditSuppressionRequest$ = [3, n0, _CASR,
    0,
    [_cN, _rIe, _eD, _sI, _d, _cRT],
    [0, () => exports.ResourceIdentifier$, 4, 2, 0, [0, 4]], 2
];
exports.CreateAuditSuppressionResponse$ = [3, n0, _CASRr,
    0,
    [],
    []
];
exports.CreateAuthorizerRequest$ = [3, n0, _CAR,
    0,
    [_aNu, _aFA, _tKN, _tSPK, _st, _tag, _sD, _eCFH],
    [[0, 1], 0, 0, 128 | 0, 0, () => TagList, 2, 2], 2
];
exports.CreateAuthorizerResponse$ = [3, n0, _CARr,
    0,
    [_aNu, _aA],
    [0, 0]
];
exports.CreateBillingGroupRequest$ = [3, n0, _CBGR,
    0,
    [_bGN, _bGP, _tag],
    [[0, 1], () => exports.BillingGroupProperties$, () => TagList], 1
];
exports.CreateBillingGroupResponse$ = [3, n0, _CBGRr,
    0,
    [_bGN, _bGA, _bGI],
    [0, 0, 0]
];
exports.CreateCertificateFromCsrRequest$ = [3, n0, _CCFCR,
    0,
    [_cSR, _sAA],
    [0, [2, { [_hQ]: _sAA }]], 1
];
exports.CreateCertificateFromCsrResponse$ = [3, n0, _CCFCRr,
    0,
    [_cAe, _cI, _cP],
    [0, 0, 0]
];
exports.CreateCertificateProviderRequest$ = [3, n0, _CCPR,
    0,
    [_cPN, _lFA, _aDFO, _cT, _tag],
    [[0, 1], 0, 64 | 0, [0, 4], () => TagList], 3
];
exports.CreateCertificateProviderResponse$ = [3, n0, _CCPRr,
    0,
    [_cPN, _cPA],
    [0, 0]
];
exports.CreateCommandRequest$ = [3, n0, _CCR,
    0,
    [_cIo, _na, _dN, _d, _pa, _pT, _pre, _mP, _rAo, _tag],
    [[0, 1], 0, 0, 0, () => exports.CommandPayload$, 0, () => exports.CommandPreprocessor$, () => CommandParameterList, 0, () => TagList], 1
];
exports.CreateCommandResponse$ = [3, n0, _CCRr,
    0,
    [_cIo, _cAo],
    [0, 0]
];
exports.CreateCustomMetricRequest$ = [3, n0, _CCMR,
    0,
    [_mNe, _mTe, _dN, _tag, _cRT],
    [[0, 1], 0, 0, () => TagList, [0, 4]], 2
];
exports.CreateCustomMetricResponse$ = [3, n0, _CCMRr,
    0,
    [_mNe, _mA],
    [0, 0]
];
exports.CreateDimensionRequest$ = [3, n0, _CDR,
    0,
    [_n, _ty, _sVt, _tag, _cRT],
    [[0, 1], 0, 64 | 0, () => TagList, [0, 4]], 3
];
exports.CreateDimensionResponse$ = [3, n0, _CDRr,
    0,
    [_n, _ar],
    [0, 0]
];
exports.CreateDomainConfigurationRequest$ = [3, n0, _CDCR,
    0,
    [_dCN, _dNo, _sCA, _vCA, _aC, _sTe, _tag, _tC, _sCC, _aTu, _aP, _cCC],
    [[0, 1], 0, 64 | 0, 0, () => exports.AuthorizerConfig$, 0, () => TagList, () => exports.TlsConfig$, () => exports.ServerCertificateConfig$, 0, 0, () => exports.ClientCertificateConfig$], 1
];
exports.CreateDomainConfigurationResponse$ = [3, n0, _CDCRr,
    0,
    [_dCN, _dCA],
    [0, 0]
];
exports.CreateDynamicThingGroupRequest$ = [3, n0, _CDTGR,
    0,
    [_tGNh, _qS, _tGP, _iN, _qV, _tag],
    [[0, 1], 0, () => exports.ThingGroupProperties$, 0, 0, () => TagList], 2
];
exports.CreateDynamicThingGroupResponse$ = [3, n0, _CDTGRr,
    0,
    [_tGNh, _tGA, _tGI, _iN, _qS, _qV],
    [0, 0, 0, 0, 0, 0]
];
exports.CreateFleetMetricRequest$ = [3, n0, _CFMR,
    0,
    [_mNe, _qS, _aTg, _pe, _aF, _d, _qV, _iN, _u, _tag],
    [[0, 1], 0, () => exports.AggregationType$, 1, 0, 0, 0, 0, 0, () => TagList], 5
];
exports.CreateFleetMetricResponse$ = [3, n0, _CFMRr,
    0,
    [_mNe, _mA],
    [0, 0]
];
exports.CreateJobRequest$ = [3, n0, _CJRr,
    0,
    [_jI, _ta, _dSo, _do, _d, _pUC, _tSa, _jERC, _aCb, _tCi, _tag, _nI, _jTA, _jERCo, _dP, _sC, _dPV],
    [[0, 1], 64 | 0, 0, 0, 0, () => exports.PresignedUrlConfig$, 0, () => exports.JobExecutionsRolloutConfig$, () => exports.AbortConfig$, () => exports.TimeoutConfig$, () => TagList, 0, 0, () => exports.JobExecutionsRetryConfig$, 128 | 0, () => exports.SchedulingConfig$, 64 | 0], 2
];
exports.CreateJobResponse$ = [3, n0, _CJRre,
    0,
    [_jA, _jI, _d],
    [0, 0, 0]
];
exports.CreateJobTemplateRequest$ = [3, n0, _CJTR,
    0,
    [_jTI, _d, _jA, _dSo, _do, _pUC, _jERC, _aCb, _tCi, _tag, _jERCo, _mW, _dPV],
    [[0, 1], 0, 0, 0, 0, () => exports.PresignedUrlConfig$, () => exports.JobExecutionsRolloutConfig$, () => exports.AbortConfig$, () => exports.TimeoutConfig$, () => TagList, () => exports.JobExecutionsRetryConfig$, () => MaintenanceWindows, 64 | 0], 2
];
exports.CreateJobTemplateResponse$ = [3, n0, _CJTRr,
    0,
    [_jTA, _jTI],
    [0, 0]
];
exports.CreateKeysAndCertificateRequest$ = [3, n0, _CKACR,
    0,
    [_sAA],
    [[2, { [_hQ]: _sAA }]]
];
exports.CreateKeysAndCertificateResponse$ = [3, n0, _CKACRr,
    0,
    [_cAe, _cI, _cP, _kP],
    [0, 0, 0, [() => exports.KeyPair$, 0]]
];
exports.CreateMitigationActionRequest$ = [3, n0, _CMAR,
    0,
    [_aN, _rAo, _aPc, _tag],
    [[0, 1], 0, () => exports.MitigationActionParams$, () => TagList], 3
];
exports.CreateMitigationActionResponse$ = [3, n0, _CMARr,
    0,
    [_aAc, _aI],
    [0, 0]
];
exports.CreateOTAUpdateRequest$ = [3, n0, _COTAUR,
    0,
    [_oUI, _ta, _fi, _rAo, _d, _pro, _tSa, _aJERC, _aJPUC, _aJAC, _aJTC, _aPd, _tag],
    [[0, 1], 64 | 0, () => OTAUpdateFiles, 0, 0, 64 | 0, 0, () => exports.AwsJobExecutionsRolloutConfig$, () => exports.AwsJobPresignedUrlConfig$, () => exports.AwsJobAbortConfig$, () => exports.AwsJobTimeoutConfig$, 128 | 0, () => TagList], 4
];
exports.CreateOTAUpdateResponse$ = [3, n0, _COTAURr,
    0,
    [_oUI, _aIJI, _oUA, _aIJA, _oUS],
    [0, 0, 0, 0, 0]
];
exports.CreatePackageRequest$ = [3, n0, _CPR,
    0,
    [_pN, _d, _tag, _cT],
    [[0, 1], [() => ResourceDescription, 0], 128 | 0, [0, { [_hQ]: _cT, [_iT]: 1 }]], 1
];
exports.CreatePackageResponse$ = [3, n0, _CPRr,
    0,
    [_pN, _pA, _d],
    [0, 0, [() => ResourceDescription, 0]]
];
exports.CreatePackageVersionRequest$ = [3, n0, _CPVR,
    0,
    [_pN, _vN, _d, _at, _art, _rec, _tag, _cT],
    [[0, 1], [0, 1], [() => ResourceDescription, 0], [() => ResourceAttributes, 0], () => exports.PackageVersionArtifact$, [() => PackageVersionRecipe, 0], 128 | 0, [0, { [_hQ]: _cT, [_iT]: 1 }]], 2
];
exports.CreatePackageVersionResponse$ = [3, n0, _CPVRr,
    0,
    [_pVA, _pN, _vN, _d, _at, _st, _eRr],
    [0, 0, 0, [() => ResourceDescription, 0], [() => ResourceAttributes, 0], 0, 0]
];
exports.CreatePolicyRequest$ = [3, n0, _CPRre,
    0,
    [_pNo, _pDo, _tag],
    [[0, 1], 0, () => TagList], 2
];
exports.CreatePolicyResponse$ = [3, n0, _CPRrea,
    0,
    [_pNo, _pAo, _pDo, _pVI],
    [0, 0, 0, 0]
];
exports.CreatePolicyVersionRequest$ = [3, n0, _CPVRre,
    0,
    [_pNo, _pDo, _sAD],
    [[0, 1], 0, [2, { [_hQ]: _sAD }]], 2
];
exports.CreatePolicyVersionResponse$ = [3, n0, _CPVRrea,
    0,
    [_pAo, _pDo, _pVI, _iDV],
    [0, 0, 0, 2]
];
exports.CreateProvisioningClaimRequest$ = [3, n0, _CPCR,
    0,
    [_tNe],
    [[0, 1]], 1
];
exports.CreateProvisioningClaimResponse$ = [3, n0, _CPCRr,
    0,
    [_cI, _cP, _kP, _ex],
    [0, 0, [() => exports.KeyPair$, 0], 4]
];
exports.CreateProvisioningTemplateRequest$ = [3, n0, _CPTR,
    0,
    [_tNe, _tB, _pRA, _d, _en, _pPH, _tag, _ty],
    [0, 0, 0, 0, 2, () => exports.ProvisioningHook$, () => TagList, 0], 3
];
exports.CreateProvisioningTemplateResponse$ = [3, n0, _CPTRr,
    0,
    [_tAem, _tNe, _dVI],
    [0, 0, 1]
];
exports.CreateProvisioningTemplateVersionRequest$ = [3, n0, _CPTVR,
    0,
    [_tNe, _tB, _sAD],
    [[0, 1], 0, [2, { [_hQ]: _sAD }]], 2
];
exports.CreateProvisioningTemplateVersionResponse$ = [3, n0, _CPTVRr,
    0,
    [_tAem, _tNe, _vIe, _iDV],
    [0, 0, 1, 2]
];
exports.CreateRoleAliasRequest$ = [3, n0, _CRAR,
    0,
    [_rAol, _rAo, _cDS, _tag],
    [[0, 1], 0, 1, () => TagList], 2
];
exports.CreateRoleAliasResponse$ = [3, n0, _CRARr,
    0,
    [_rAol, _rAA],
    [0, 0]
];
exports.CreateScheduledAuditRequest$ = [3, n0, _CSAR,
    0,
    [_fr, _tCN, _sAN, _dOM, _dOW, _tag],
    [0, 64 | 0, [0, 1], 0, 0, () => TagList], 3
];
exports.CreateScheduledAuditResponse$ = [3, n0, _CSARr,
    0,
    [_sAAc],
    [0]
];
exports.CreateSecurityProfileRequest$ = [3, n0, _CSPR,
    0,
    [_sPN, _sPD, _be, _aTl, _aMTR, _aMTRV, _tag, _mEC],
    [[0, 1], 0, () => Behaviors, () => AlertTargets, 64 | 0, () => AdditionalMetricsToRetainV2List, () => TagList, () => exports.MetricsExportConfig$], 1
];
exports.CreateSecurityProfileResponse$ = [3, n0, _CSPRr,
    0,
    [_sPN, _sPA],
    [0, 0]
];
exports.CreateStreamRequest$ = [3, n0, _CSR,
    0,
    [_sIt, _fi, _rAo, _d, _tag],
    [[0, 1], () => StreamFiles, 0, 0, () => TagList], 3
];
exports.CreateStreamResponse$ = [3, n0, _CSRr,
    0,
    [_sIt, _sAtr, _d, _sVtr],
    [0, 0, 0, 1]
];
exports.CreateThingGroupRequest$ = [3, n0, _CTGR,
    0,
    [_tGNh, _pGN, _tGP, _tag],
    [[0, 1], 0, () => exports.ThingGroupProperties$, () => TagList], 1
];
exports.CreateThingGroupResponse$ = [3, n0, _CTGRr,
    0,
    [_tGNh, _tGA, _tGI],
    [0, 0, 0]
];
exports.CreateThingRequest$ = [3, n0, _CTR,
    0,
    [_tN, _tTN, _aPt, _bGN],
    [[0, 1], 0, () => exports.AttributePayload$, 0], 1
];
exports.CreateThingResponse$ = [3, n0, _CTRr,
    0,
    [_tN, _tA, _tIh],
    [0, 0, 0]
];
exports.CreateThingTypeRequest$ = [3, n0, _CTTR,
    0,
    [_tTN, _tTP, _tag],
    [[0, 1], () => exports.ThingTypeProperties$, () => TagList], 1
];
exports.CreateThingTypeResponse$ = [3, n0, _CTTRr,
    0,
    [_tTN, _tTA, _tTI],
    [0, 0, 0]
];
exports.CreateTopicRuleDestinationRequest$ = [3, n0, _CTRDRr,
    0,
    [_dC],
    [() => exports.TopicRuleDestinationConfiguration$], 1
];
exports.CreateTopicRuleDestinationResponse$ = [3, n0, _CTRDRre,
    0,
    [_tRD],
    [() => exports.TopicRuleDestination$]
];
exports.CreateTopicRuleRequest$ = [3, n0, _CTRR,
    0,
    [_rN, _tRP, _tag],
    [[0, 1], [() => exports.TopicRulePayload$, 16], [0, { [_hH]: _xat }]], 2
];
exports.CustomCodeSigning$ = [3, n0, _CCS,
    0,
    [_si, _cCe, _hA, _sAi],
    [() => exports.CodeSigningSignature$, () => exports.CodeSigningCertificateChain$, 0, 0]
];
exports.DeleteAccountAuditConfigurationRequest$ = [3, n0, _DAACR,
    0,
    [_dSA],
    [[2, { [_hQ]: _dSA }]]
];
exports.DeleteAccountAuditConfigurationResponse$ = [3, n0, _DAACRe,
    0,
    [],
    []
];
exports.DeleteAuditSuppressionRequest$ = [3, n0, _DASR,
    0,
    [_cN, _rIe],
    [0, () => exports.ResourceIdentifier$], 2
];
exports.DeleteAuditSuppressionResponse$ = [3, n0, _DASRe,
    0,
    [],
    []
];
exports.DeleteAuthorizerRequest$ = [3, n0, _DAR,
    0,
    [_aNu],
    [[0, 1]], 1
];
exports.DeleteAuthorizerResponse$ = [3, n0, _DARe,
    0,
    [],
    []
];
exports.DeleteBillingGroupRequest$ = [3, n0, _DBGR,
    0,
    [_bGN, _eV],
    [[0, 1], [1, { [_hQ]: _eV }]], 1
];
exports.DeleteBillingGroupResponse$ = [3, n0, _DBGRe,
    0,
    [],
    []
];
exports.DeleteCACertificateRequest$ = [3, n0, _DCACR,
    0,
    [_cI],
    [[0, 1]], 1
];
exports.DeleteCACertificateResponse$ = [3, n0, _DCACRe,
    0,
    [],
    []
];
exports.DeleteCertificateProviderRequest$ = [3, n0, _DCPR,
    0,
    [_cPN],
    [[0, 1]], 1
];
exports.DeleteCertificateProviderResponse$ = [3, n0, _DCPRe,
    0,
    [],
    []
];
exports.DeleteCertificateRequest$ = [3, n0, _DCR,
    0,
    [_cI, _fD],
    [[0, 1], [2, { [_hQ]: _fD }]], 1
];
exports.DeleteCommandExecutionRequest$ = [3, n0, _DCER,
    0,
    [_eI, _tAa],
    [[0, 1], [0, { [_hQ]: _tAa }]], 2
];
exports.DeleteCommandExecutionResponse$ = [3, n0, _DCERe,
    0,
    [],
    []
];
exports.DeleteCommandRequest$ = [3, n0, _DCRe,
    0,
    [_cIo],
    [[0, 1]], 1
];
exports.DeleteCommandResponse$ = [3, n0, _DCRel,
    0,
    [_sCt],
    [[1, 32]]
];
exports.DeleteCustomMetricRequest$ = [3, n0, _DCMR,
    0,
    [_mNe],
    [[0, 1]], 1
];
exports.DeleteCustomMetricResponse$ = [3, n0, _DCMRe,
    0,
    [],
    []
];
exports.DeleteDimensionRequest$ = [3, n0, _DDR,
    0,
    [_n],
    [[0, 1]], 1
];
exports.DeleteDimensionResponse$ = [3, n0, _DDRe,
    0,
    [],
    []
];
exports.DeleteDomainConfigurationRequest$ = [3, n0, _DDCR,
    0,
    [_dCN],
    [[0, 1]], 1
];
exports.DeleteDomainConfigurationResponse$ = [3, n0, _DDCRe,
    0,
    [],
    []
];
exports.DeleteDynamicThingGroupRequest$ = [3, n0, _DDTGR,
    0,
    [_tGNh, _eV],
    [[0, 1], [1, { [_hQ]: _eV }]], 1
];
exports.DeleteDynamicThingGroupResponse$ = [3, n0, _DDTGRe,
    0,
    [],
    []
];
exports.DeleteFleetMetricRequest$ = [3, n0, _DFMR,
    0,
    [_mNe, _eV],
    [[0, 1], [1, { [_hQ]: _eV }]], 1
];
exports.DeleteJobExecutionRequest$ = [3, n0, _DJER,
    0,
    [_jI, _tN, _eN, _fo, _nI],
    [[0, 1], [0, 1], [1, 1], [2, { [_hQ]: _fo }], [0, { [_hQ]: _nI }]], 3
];
exports.DeleteJobRequest$ = [3, n0, _DJR,
    0,
    [_jI, _fo, _nI],
    [[0, 1], [2, { [_hQ]: _fo }], [0, { [_hQ]: _nI }]], 1
];
exports.DeleteJobTemplateRequest$ = [3, n0, _DJTR,
    0,
    [_jTI],
    [[0, 1]], 1
];
exports.DeleteMitigationActionRequest$ = [3, n0, _DMAR,
    0,
    [_aN],
    [[0, 1]], 1
];
exports.DeleteMitigationActionResponse$ = [3, n0, _DMARe,
    0,
    [],
    []
];
exports.DeleteOTAUpdateRequest$ = [3, n0, _DOTAUR,
    0,
    [_oUI, _dSe, _fDAWSJ],
    [[0, 1], [2, { [_hQ]: _dSe }], [2, { [_hQ]: _fDAWSJ }]], 1
];
exports.DeleteOTAUpdateResponse$ = [3, n0, _DOTAURe,
    0,
    [],
    []
];
exports.DeletePackageRequest$ = [3, n0, _DPR,
    0,
    [_pN, _cT],
    [[0, 1], [0, { [_hQ]: _cT, [_iT]: 1 }]], 1
];
exports.DeletePackageResponse$ = [3, n0, _DPRe,
    0,
    [],
    []
];
exports.DeletePackageVersionRequest$ = [3, n0, _DPVR,
    0,
    [_pN, _vN, _cT],
    [[0, 1], [0, 1], [0, { [_hQ]: _cT, [_iT]: 1 }]], 2
];
exports.DeletePackageVersionResponse$ = [3, n0, _DPVRe,
    0,
    [],
    []
];
exports.DeletePolicyRequest$ = [3, n0, _DPRel,
    0,
    [_pNo],
    [[0, 1]], 1
];
exports.DeletePolicyVersionRequest$ = [3, n0, _DPVRel,
    0,
    [_pNo, _pVI],
    [[0, 1], [0, 1]], 2
];
exports.DeleteProvisioningTemplateRequest$ = [3, n0, _DPTR,
    0,
    [_tNe],
    [[0, 1]], 1
];
exports.DeleteProvisioningTemplateResponse$ = [3, n0, _DPTRe,
    0,
    [],
    []
];
exports.DeleteProvisioningTemplateVersionRequest$ = [3, n0, _DPTVR,
    0,
    [_tNe, _vIe],
    [[0, 1], [1, 1]], 2
];
exports.DeleteProvisioningTemplateVersionResponse$ = [3, n0, _DPTVRe,
    0,
    [],
    []
];
exports.DeleteRegistrationCodeRequest$ = [3, n0, _DRCR,
    0,
    [],
    []
];
exports.DeleteRegistrationCodeResponse$ = [3, n0, _DRCRe,
    0,
    [],
    []
];
exports.DeleteRoleAliasRequest$ = [3, n0, _DRAR,
    0,
    [_rAol],
    [[0, 1]], 1
];
exports.DeleteRoleAliasResponse$ = [3, n0, _DRARe,
    0,
    [],
    []
];
exports.DeleteScheduledAuditRequest$ = [3, n0, _DSAR,
    0,
    [_sAN],
    [[0, 1]], 1
];
exports.DeleteScheduledAuditResponse$ = [3, n0, _DSARe,
    0,
    [],
    []
];
exports.DeleteSecurityProfileRequest$ = [3, n0, _DSPR,
    0,
    [_sPN, _eV],
    [[0, 1], [1, { [_hQ]: _eV }]], 1
];
exports.DeleteSecurityProfileResponse$ = [3, n0, _DSPRe,
    0,
    [],
    []
];
exports.DeleteStreamRequest$ = [3, n0, _DSR,
    0,
    [_sIt],
    [[0, 1]], 1
];
exports.DeleteStreamResponse$ = [3, n0, _DSRe,
    0,
    [],
    []
];
exports.DeleteThingGroupRequest$ = [3, n0, _DTGR,
    0,
    [_tGNh, _eV],
    [[0, 1], [1, { [_hQ]: _eV }]], 1
];
exports.DeleteThingGroupResponse$ = [3, n0, _DTGRe,
    0,
    [],
    []
];
exports.DeleteThingRequest$ = [3, n0, _DTR,
    0,
    [_tN, _eV],
    [[0, 1], [1, { [_hQ]: _eV }]], 1
];
exports.DeleteThingResponse$ = [3, n0, _DTRe,
    0,
    [],
    []
];
exports.DeleteThingTypeRequest$ = [3, n0, _DTTR,
    0,
    [_tTN],
    [[0, 1]], 1
];
exports.DeleteThingTypeResponse$ = [3, n0, _DTTRe,
    0,
    [],
    []
];
exports.DeleteTopicRuleDestinationRequest$ = [3, n0, _DTRDR,
    0,
    [_ar],
    [[0, 1]], 1
];
exports.DeleteTopicRuleDestinationResponse$ = [3, n0, _DTRDRe,
    0,
    [],
    []
];
exports.DeleteTopicRuleRequest$ = [3, n0, _DTRR,
    0,
    [_rN],
    [[0, 1]], 1
];
exports.DeleteV2LoggingLevelRequest$ = [3, n0, _DVLLR,
    0,
    [_tTa, _tNa],
    [[0, { [_hQ]: _tTa }], [0, { [_hQ]: _tNa }]], 2
];
exports.Denied$ = [3, n0, _De,
    0,
    [_iDm, _eDx],
    [() => exports.ImplicitDeny$, () => exports.ExplicitDeny$]
];
exports.DeprecateThingTypeRequest$ = [3, n0, _DTTRep,
    0,
    [_tTN, _uD],
    [[0, 1], 2], 1
];
exports.DeprecateThingTypeResponse$ = [3, n0, _DTTRepr,
    0,
    [],
    []
];
exports.DescribeAccountAuditConfigurationRequest$ = [3, n0, _DAACRes,
    0,
    [],
    []
];
exports.DescribeAccountAuditConfigurationResponse$ = [3, n0, _DAACResc,
    0,
    [_rAo, _aNTC, _aCC],
    [0, () => AuditNotificationTargetConfigurations, () => AuditCheckConfigurations]
];
exports.DescribeAuditFindingRequest$ = [3, n0, _DAFR,
    0,
    [_fI],
    [[0, 1]], 1
];
exports.DescribeAuditFindingResponse$ = [3, n0, _DAFRe,
    0,
    [_fin],
    [() => exports.AuditFinding$]
];
exports.DescribeAuditMitigationActionsTaskRequest$ = [3, n0, _DAMATR,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.DescribeAuditMitigationActionsTaskResponse$ = [3, n0, _DAMATRe,
    0,
    [_tS, _sT, _eT, _tSas, _tar, _aCTAM, _aDc],
    [0, 4, 4, () => AuditMitigationActionsTaskStatistics, () => exports.AuditMitigationActionsTaskTarget$, [2, n0, _ACTAM, 0, 0, 64 | 0], () => MitigationActionList]
];
exports.DescribeAuditSuppressionRequest$ = [3, n0, _DASRes,
    0,
    [_cN, _rIe],
    [0, () => exports.ResourceIdentifier$], 2
];
exports.DescribeAuditSuppressionResponse$ = [3, n0, _DASResc,
    0,
    [_cN, _rIe, _eD, _sI, _d],
    [0, () => exports.ResourceIdentifier$, 4, 2, 0]
];
exports.DescribeAuditTaskRequest$ = [3, n0, _DATR,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.DescribeAuditTaskResponse$ = [3, n0, _DATRe,
    0,
    [_tS, _tT, _tST, _tSas, _sAN, _aDu],
    [0, 0, 4, () => exports.TaskStatistics$, 0, () => AuditDetails]
];
exports.DescribeAuthorizerRequest$ = [3, n0, _DARes,
    0,
    [_aNu],
    [[0, 1]], 1
];
exports.DescribeAuthorizerResponse$ = [3, n0, _DAResc,
    0,
    [_aDut],
    [() => exports.AuthorizerDescription$]
];
exports.DescribeBillingGroupRequest$ = [3, n0, _DBGRes,
    0,
    [_bGN],
    [[0, 1]], 1
];
exports.DescribeBillingGroupResponse$ = [3, n0, _DBGResc,
    0,
    [_bGN, _bGI, _bGA, _ve, _bGP, _bGM],
    [0, 0, 0, 1, () => exports.BillingGroupProperties$, () => exports.BillingGroupMetadata$]
];
exports.DescribeCACertificateRequest$ = [3, n0, _DCACRes,
    0,
    [_cI],
    [[0, 1]], 1
];
exports.DescribeCACertificateResponse$ = [3, n0, _DCACResc,
    0,
    [_cDe, _rCe],
    [() => exports.CACertificateDescription$, () => exports.RegistrationConfig$]
];
exports.DescribeCertificateProviderRequest$ = [3, n0, _DCPRes,
    0,
    [_cPN],
    [[0, 1]], 1
];
exports.DescribeCertificateProviderResponse$ = [3, n0, _DCPResc,
    0,
    [_cPN, _cPA, _lFA, _aDFO, _cD, _lMD],
    [0, 0, 0, 64 | 0, 4, 4]
];
exports.DescribeCertificateRequest$ = [3, n0, _DCRes,
    0,
    [_cI],
    [[0, 1]], 1
];
exports.DescribeCertificateResponse$ = [3, n0, _DCResc,
    0,
    [_cDe],
    [() => exports.CertificateDescription$]
];
exports.DescribeCustomMetricRequest$ = [3, n0, _DCMRes,
    0,
    [_mNe],
    [[0, 1]], 1
];
exports.DescribeCustomMetricResponse$ = [3, n0, _DCMResc,
    0,
    [_mNe, _mA, _mTe, _dN, _cD, _lMD],
    [0, 0, 0, 0, 4, 4]
];
exports.DescribeDefaultAuthorizerRequest$ = [3, n0, _DDAR,
    0,
    [],
    []
];
exports.DescribeDefaultAuthorizerResponse$ = [3, n0, _DDARe,
    0,
    [_aDut],
    [() => exports.AuthorizerDescription$]
];
exports.DescribeDetectMitigationActionsTaskRequest$ = [3, n0, _DDMATR,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.DescribeDetectMitigationActionsTaskResponse$ = [3, n0, _DDMATRe,
    0,
    [_tSask],
    [() => exports.DetectMitigationActionsTaskSummary$]
];
exports.DescribeDimensionRequest$ = [3, n0, _DDRes,
    0,
    [_n],
    [[0, 1]], 1
];
exports.DescribeDimensionResponse$ = [3, n0, _DDResc,
    0,
    [_n, _ar, _ty, _sVt, _cD, _lMD],
    [0, 0, 0, 64 | 0, 4, 4]
];
exports.DescribeDomainConfigurationRequest$ = [3, n0, _DDCRes,
    0,
    [_dCN],
    [[0, 1]], 1
];
exports.DescribeDomainConfigurationResponse$ = [3, n0, _DDCResc,
    0,
    [_dCN, _dCA, _dNo, _sCe, _aC, _dCS, _sTe, _dT, _lSCD, _tC, _sCC, _aTu, _aP, _cCC],
    [0, 0, 0, () => ServerCertificates, () => exports.AuthorizerConfig$, 0, 0, 0, 4, () => exports.TlsConfig$, () => exports.ServerCertificateConfig$, 0, 0, () => exports.ClientCertificateConfig$]
];
exports.DescribeEncryptionConfigurationRequest$ = [3, n0, _DECR,
    0,
    [],
    []
];
exports.DescribeEncryptionConfigurationResponse$ = [3, n0, _DECRe,
    0,
    [_eTn, _kKA, _kARA, _cDo, _lMD],
    [0, 0, 0, () => exports.ConfigurationDetails$, 4]
];
exports.DescribeEndpointRequest$ = [3, n0, _DER,
    0,
    [_eTnd],
    [[0, { [_hQ]: _eTnd }]]
];
exports.DescribeEndpointResponse$ = [3, n0, _DERe,
    0,
    [_eA],
    [0]
];
exports.DescribeEventConfigurationsRequest$ = [3, n0, _DECRes,
    0,
    [],
    []
];
exports.DescribeEventConfigurationsResponse$ = [3, n0, _DECResc,
    0,
    [_eCv, _cD, _lMD],
    [() => EventConfigurations, 4, 4]
];
exports.DescribeFleetMetricRequest$ = [3, n0, _DFMRe,
    0,
    [_mNe],
    [[0, 1]], 1
];
exports.DescribeFleetMetricResponse$ = [3, n0, _DFMRes,
    0,
    [_mNe, _qS, _aTg, _pe, _aF, _d, _qV, _iN, _cD, _lMD, _u, _ve, _mA],
    [0, 0, () => exports.AggregationType$, 1, 0, 0, 0, 0, 4, 4, 0, 1, 0]
];
exports.DescribeIndexRequest$ = [3, n0, _DIR,
    0,
    [_iN],
    [[0, 1]], 1
];
exports.DescribeIndexResponse$ = [3, n0, _DIRe,
    0,
    [_iN, _iSn, _sc],
    [0, 0, 0]
];
exports.DescribeJobExecutionRequest$ = [3, n0, _DJERe,
    0,
    [_jI, _tN, _eN],
    [[0, 1], [0, 1], [1, { [_hQ]: _eN }]], 2
];
exports.DescribeJobExecutionResponse$ = [3, n0, _DJERes,
    0,
    [_exe],
    [() => exports.JobExecution$]
];
exports.DescribeJobRequest$ = [3, n0, _DJRe,
    0,
    [_jI, _bS],
    [[0, 1], [2, { [_hQ]: _bS }]], 1
];
exports.DescribeJobResponse$ = [3, n0, _DJRes,
    0,
    [_dSo, _j],
    [0, () => exports.Job$]
];
exports.DescribeJobTemplateRequest$ = [3, n0, _DJTRe,
    0,
    [_jTI],
    [[0, 1]], 1
];
exports.DescribeJobTemplateResponse$ = [3, n0, _DJTRes,
    0,
    [_jTA, _jTI, _d, _dSo, _do, _cAr, _pUC, _jERC, _aCb, _tCi, _jERCo, _mW, _dPV],
    [0, 0, 0, 0, 0, 4, () => exports.PresignedUrlConfig$, () => exports.JobExecutionsRolloutConfig$, () => exports.AbortConfig$, () => exports.TimeoutConfig$, () => exports.JobExecutionsRetryConfig$, () => MaintenanceWindows, 64 | 0]
];
exports.DescribeManagedJobTemplateRequest$ = [3, n0, _DMJTR,
    0,
    [_tNe, _tV],
    [[0, 1], [0, { [_hQ]: _tV }]], 1
];
exports.DescribeManagedJobTemplateResponse$ = [3, n0, _DMJTRe,
    0,
    [_tNe, _tAem, _d, _tV, _env, _dP, _do],
    [0, 0, 0, 0, 64 | 0, () => DocumentParameters, 0]
];
exports.DescribeMitigationActionRequest$ = [3, n0, _DMARes,
    0,
    [_aN],
    [[0, 1]], 1
];
exports.DescribeMitigationActionResponse$ = [3, n0, _DMAResc,
    0,
    [_aN, _aT, _aAc, _aI, _rAo, _aPc, _cD, _lMD],
    [0, 0, 0, 0, 0, () => exports.MitigationActionParams$, 4, 4]
];
exports.DescribeProvisioningTemplateRequest$ = [3, n0, _DPTRes,
    0,
    [_tNe],
    [[0, 1]], 1
];
exports.DescribeProvisioningTemplateResponse$ = [3, n0, _DPTResc,
    0,
    [_tAem, _tNe, _d, _cD, _lMD, _dVI, _tB, _en, _pRA, _pPH, _ty],
    [0, 0, 0, 4, 4, 1, 0, 2, 0, () => exports.ProvisioningHook$, 0]
];
exports.DescribeProvisioningTemplateVersionRequest$ = [3, n0, _DPTVRes,
    0,
    [_tNe, _vIe],
    [[0, 1], [1, 1]], 2
];
exports.DescribeProvisioningTemplateVersionResponse$ = [3, n0, _DPTVResc,
    0,
    [_vIe, _cD, _tB, _iDV],
    [1, 4, 0, 2]
];
exports.DescribeRoleAliasRequest$ = [3, n0, _DRARes,
    0,
    [_rAol],
    [[0, 1]], 1
];
exports.DescribeRoleAliasResponse$ = [3, n0, _DRAResc,
    0,
    [_rAD],
    [() => exports.RoleAliasDescription$]
];
exports.DescribeScheduledAuditRequest$ = [3, n0, _DSARes,
    0,
    [_sAN],
    [[0, 1]], 1
];
exports.DescribeScheduledAuditResponse$ = [3, n0, _DSAResc,
    0,
    [_fr, _dOM, _dOW, _tCN, _sAN, _sAAc],
    [0, 0, 0, 64 | 0, 0, 0]
];
exports.DescribeSecurityProfileRequest$ = [3, n0, _DSPRes,
    0,
    [_sPN],
    [[0, 1]], 1
];
exports.DescribeSecurityProfileResponse$ = [3, n0, _DSPResc,
    0,
    [_sPN, _sPA, _sPD, _be, _aTl, _aMTR, _aMTRV, _ve, _cD, _lMD, _mEC],
    [0, 0, 0, () => Behaviors, () => AlertTargets, 64 | 0, () => AdditionalMetricsToRetainV2List, 1, 4, 4, () => exports.MetricsExportConfig$]
];
exports.DescribeStreamRequest$ = [3, n0, _DSRes,
    0,
    [_sIt],
    [[0, 1]], 1
];
exports.DescribeStreamResponse$ = [3, n0, _DSResc,
    0,
    [_sItr],
    [() => exports.StreamInfo$]
];
exports.DescribeThingGroupRequest$ = [3, n0, _DTGRes,
    0,
    [_tGNh],
    [[0, 1]], 1
];
exports.DescribeThingGroupResponse$ = [3, n0, _DTGResc,
    0,
    [_tGNh, _tGI, _tGA, _ve, _tGP, _tGM, _iN, _qS, _qV, _st],
    [0, 0, 0, 1, () => exports.ThingGroupProperties$, () => exports.ThingGroupMetadata$, 0, 0, 0, 0]
];
exports.DescribeThingRegistrationTaskRequest$ = [3, n0, _DTRTR,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.DescribeThingRegistrationTaskResponse$ = [3, n0, _DTRTRe,
    0,
    [_tI, _cD, _lMD, _tB, _iFB, _iFK, _rAo, _st, _m, _sCu, _fC, _pP],
    [0, 4, 4, 0, 0, 0, 0, 0, 0, 1, 1, 1]
];
exports.DescribeThingRequest$ = [3, n0, _DTRes,
    0,
    [_tN],
    [[0, 1]], 1
];
exports.DescribeThingResponse$ = [3, n0, _DTResc,
    0,
    [_dCI, _tN, _tIh, _tA, _tTN, _at, _ve, _bGN],
    [0, 0, 0, 0, 0, 128 | 0, 1, 0]
];
exports.DescribeThingTypeRequest$ = [3, n0, _DTTRes,
    0,
    [_tTN],
    [[0, 1]], 1
];
exports.DescribeThingTypeResponse$ = [3, n0, _DTTResc,
    0,
    [_tTN, _tTI, _tTA, _tTP, _tTM],
    [0, 0, 0, () => exports.ThingTypeProperties$, () => exports.ThingTypeMetadata$]
];
exports.Destination$ = [3, n0, _Des,
    0,
    [_sDe],
    [() => exports.S3Destination$]
];
exports.DetachPolicyRequest$ = [3, n0, _DPRet,
    0,
    [_pNo, _tar],
    [[0, 1], 0], 2
];
exports.DetachPrincipalPolicyRequest$ = [3, n0, _DPPR,
    0,
    [_pNo, _pr],
    [[0, 1], [0, { [_hH]: _xaip }]], 2
];
exports.DetachSecurityProfileRequest$ = [3, n0, _DSPRet,
    0,
    [_sPN, _sPTA],
    [[0, 1], [0, { [_hQ]: _sPTA }]], 2
];
exports.DetachSecurityProfileResponse$ = [3, n0, _DSPReta,
    0,
    [],
    []
];
exports.DetachThingPrincipalRequest$ = [3, n0, _DTPR,
    0,
    [_tN, _pr],
    [[0, 1], [0, { [_hH]: _xap }]], 2
];
exports.DetachThingPrincipalResponse$ = [3, n0, _DTPRe,
    0,
    [],
    []
];
exports.DetectMitigationActionExecution$ = [3, n0, _DMAE,
    0,
    [_tI, _vI, _aN, _tN, _eSD, _eED, _st, _eC, _m],
    [0, 0, 0, 0, 4, 4, 0, 0, 0]
];
exports.DetectMitigationActionsTaskStatistics$ = [3, n0, _DMATS,
    0,
    [_aE, _aS, _aFc],
    [1, 1, 1]
];
exports.DetectMitigationActionsTaskSummary$ = [3, n0, _DMATSe,
    0,
    [_tI, _tS, _tST, _tET, _tar, _vEOR, _oAVI, _sAI, _aDc, _tSas],
    [0, 0, 4, 4, () => exports.DetectMitigationActionsTaskTarget$, () => exports.ViolationEventOccurrenceRange$, 2, 2, () => MitigationActionList, () => exports.DetectMitigationActionsTaskStatistics$]
];
exports.DetectMitigationActionsTaskTarget$ = [3, n0, _DMATT,
    0,
    [_vIi, _sPN, _bN],
    [64 | 0, 0, 0]
];
exports.DisableTopicRuleRequest$ = [3, n0, _DTRRi,
    0,
    [_rN],
    [[0, 1]], 1
];
exports.DisassociateSbomFromPackageVersionRequest$ = [3, n0, _DSFPVR,
    0,
    [_pN, _vN, _cT],
    [[0, 1], [0, 1], [0, { [_hQ]: _cT, [_iT]: 1 }]], 2
];
exports.DisassociateSbomFromPackageVersionResponse$ = [3, n0, _DSFPVRi,
    0,
    [],
    []
];
exports.DocumentParameter$ = [3, n0, _DP,
    0,
    [_ke, _d, _reg, _exa, _op],
    [0, 0, 0, 0, 2]
];
exports.DomainConfigurationSummary$ = [3, n0, _DCS,
    0,
    [_dCN, _dCA, _sTe],
    [0, 0, 0]
];
exports.DynamoDBAction$ = [3, n0, _DDBA,
    0,
    [_tNab, _rAo, _hKF, _hKV, _ope, _hKT, _rKF, _rKV, _rKT, _pF],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], 4
];
exports.DynamoDBv2Action$ = [3, n0, _DDBAy,
    0,
    [_rAo, _pI],
    [0, () => exports.PutItemInput$], 2
];
exports.EffectivePolicy$ = [3, n0, _EP,
    0,
    [_pNo, _pAo, _pDo],
    [0, 0, 0]
];
exports.ElasticsearchAction$ = [3, n0, _EA,
    0,
    [_rAo, _end, _i, _ty, _id],
    [0, 0, 0, 0, 0], 5
];
exports.EnableIoTLoggingParams$ = [3, n0, _EITLP,
    0,
    [_rAFL, _lL],
    [0, 0], 2
];
exports.EnableTopicRuleRequest$ = [3, n0, _ETRR,
    0,
    [_rN],
    [[0, 1]], 1
];
exports.ErrorInfo$ = [3, n0, _EI,
    0,
    [_cod, _m],
    [0, 0]
];
exports.ExplicitDeny$ = [3, n0, _ED,
    0,
    [_p],
    [() => Policies]
];
exports.ExponentialRolloutRate$ = [3, n0, _ERR,
    0,
    [_bRPM, _iF, _rIC],
    [1, 1, () => exports.RateIncreaseCriteria$], 3
];
exports.Field$ = [3, n0, _F,
    0,
    [_n, _ty],
    [0, 0]
];
exports.FileLocation$ = [3, n0, _FL,
    0,
    [_stre, _sL],
    [() => exports._Stream$, () => exports.S3Location$]
];
exports.FirehoseAction$ = [3, n0, _FA,
    0,
    [_rAo, _dSN, _sep, _bM],
    [0, 0, 0, 2], 2
];
exports.FleetMetricNameAndArn$ = [3, n0, _FMNAA,
    0,
    [_mNe, _mA],
    [0, 0]
];
exports.GeoLocationTarget$ = [3, n0, _GLT,
    0,
    [_n, _or],
    [0, 0]
];
exports.GetBehaviorModelTrainingSummariesRequest$ = [3, n0, _GBMTSR,
    0,
    [_sPN, _mR, _nT],
    [[0, { [_hQ]: _sPN }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.GetBehaviorModelTrainingSummariesResponse$ = [3, n0, _GBMTSRe,
    0,
    [_su, _nT],
    [() => BehaviorModelTrainingSummaries, 0]
];
exports.GetBucketsAggregationRequest$ = [3, n0, _GBAR,
    0,
    [_qS, _aF, _bAT, _iN, _qV],
    [0, 0, () => exports.BucketsAggregationType$, 0, 0], 3
];
exports.GetBucketsAggregationResponse$ = [3, n0, _GBARe,
    0,
    [_tCo, _bu],
    [1, () => Buckets]
];
exports.GetCardinalityRequest$ = [3, n0, _GCR,
    0,
    [_qS, _iN, _aF, _qV],
    [0, 0, 0, 0], 1
];
exports.GetCardinalityResponse$ = [3, n0, _GCRe,
    0,
    [_ca],
    [1]
];
exports.GetCommandExecutionRequest$ = [3, n0, _GCER,
    0,
    [_eI, _tAa, _iR],
    [[0, 1], [0, { [_hQ]: _tAa }], [2, { [_hQ]: _iR }]], 2
];
exports.GetCommandExecutionResponse$ = [3, n0, _GCERe,
    0,
    [_eI, _cAo, _tAa, _st, _sRt, _res, _par, _eTS, _cAr, _lUA, _sAt, _cAom, _tTL],
    [0, 0, 0, 0, () => exports.StatusReason$, () => CommandExecutionResultMap, () => CommandExecutionParameterMap, 1, 4, 4, 4, 4, 4]
];
exports.GetCommandRequest$ = [3, n0, _GCRet,
    0,
    [_cIo],
    [[0, 1]], 1
];
exports.GetCommandResponse$ = [3, n0, _GCReto,
    0,
    [_cIo, _cAo, _na, _dN, _d, _mP, _pa, _pT, _pre, _rAo, _cAr, _lUA, _dep, _pD],
    [0, 0, 0, 0, 0, () => CommandParameterList, () => exports.CommandPayload$, 0, () => exports.CommandPreprocessor$, 0, 4, 4, 2, 2]
];
exports.GetEffectivePoliciesRequest$ = [3, n0, _GEPR,
    0,
    [_pr, _cIPI, _tN],
    [0, 0, [0, { [_hQ]: _tN }]]
];
exports.GetEffectivePoliciesResponse$ = [3, n0, _GEPRe,
    0,
    [_eP],
    [() => EffectivePolicies]
];
exports.GetIndexingConfigurationRequest$ = [3, n0, _GICR,
    0,
    [],
    []
];
exports.GetIndexingConfigurationResponse$ = [3, n0, _GICRe,
    0,
    [_tIC, _tGIC],
    [() => exports.ThingIndexingConfiguration$, () => exports.ThingGroupIndexingConfiguration$]
];
exports.GetJobDocumentRequest$ = [3, n0, _GJDR,
    0,
    [_jI, _bS],
    [[0, 1], [2, { [_hQ]: _bS }]], 1
];
exports.GetJobDocumentResponse$ = [3, n0, _GJDRe,
    0,
    [_do],
    [0]
];
exports.GetLoggingOptionsRequest$ = [3, n0, _GLOR,
    0,
    [],
    []
];
exports.GetLoggingOptionsResponse$ = [3, n0, _GLORe,
    0,
    [_rAo, _lL],
    [0, 0]
];
exports.GetOTAUpdateRequest$ = [3, n0, _GOTAUR,
    0,
    [_oUI],
    [[0, 1]], 1
];
exports.GetOTAUpdateResponse$ = [3, n0, _GOTAURe,
    0,
    [_oUIt],
    [() => exports.OTAUpdateInfo$]
];
exports.GetPackageConfigurationRequest$ = [3, n0, _GPCR,
    0,
    [],
    []
];
exports.GetPackageConfigurationResponse$ = [3, n0, _GPCRe,
    0,
    [_vUBJC],
    [() => exports.VersionUpdateByJobsConfig$]
];
exports.GetPackageRequest$ = [3, n0, _GPR,
    0,
    [_pN],
    [[0, 1]], 1
];
exports.GetPackageResponse$ = [3, n0, _GPRe,
    0,
    [_pN, _pA, _d, _dVN, _cD, _lMD],
    [0, 0, [() => ResourceDescription, 0], 0, 4, 4]
];
exports.GetPackageVersionRequest$ = [3, n0, _GPVR,
    0,
    [_pN, _vN],
    [[0, 1], [0, 1]], 2
];
exports.GetPackageVersionResponse$ = [3, n0, _GPVRe,
    0,
    [_pVA, _pN, _vN, _d, _at, _art, _st, _eRr, _cD, _lMD, _sb, _sVS, _rec],
    [0, 0, 0, [() => ResourceDescription, 0], [() => ResourceAttributes, 0], () => exports.PackageVersionArtifact$, 0, 0, 4, 4, () => exports.Sbom$, 0, [() => PackageVersionRecipe, 0]]
];
exports.GetPercentilesRequest$ = [3, n0, _GPRet,
    0,
    [_qS, _iN, _aF, _qV, _per],
    [0, 0, 0, 0, 64 | 1], 1
];
exports.GetPercentilesResponse$ = [3, n0, _GPRete,
    0,
    [_perc],
    [() => Percentiles]
];
exports.GetPolicyRequest$ = [3, n0, _GPReto,
    0,
    [_pNo],
    [[0, 1]], 1
];
exports.GetPolicyResponse$ = [3, n0, _GPRetol,
    0,
    [_pNo, _pAo, _pDo, _dVI, _cD, _lMD, _gI],
    [0, 0, 0, 0, 4, 4, 0]
];
exports.GetPolicyVersionRequest$ = [3, n0, _GPVRet,
    0,
    [_pNo, _pVI],
    [[0, 1], [0, 1]], 2
];
exports.GetPolicyVersionResponse$ = [3, n0, _GPVReto,
    0,
    [_pAo, _pNo, _pDo, _pVI, _iDV, _cD, _lMD, _gI],
    [0, 0, 0, 0, 2, 4, 4, 0]
];
exports.GetRegistrationCodeRequest$ = [3, n0, _GRCR,
    0,
    [],
    []
];
exports.GetRegistrationCodeResponse$ = [3, n0, _GRCRe,
    0,
    [_rCeg],
    [0]
];
exports.GetStatisticsRequest$ = [3, n0, _GSR,
    0,
    [_qS, _iN, _aF, _qV],
    [0, 0, 0, 0], 1
];
exports.GetStatisticsResponse$ = [3, n0, _GSRe,
    0,
    [_sta],
    [() => exports.Statistics$]
];
exports.GetThingConnectivityDataRequest$ = [3, n0, _GTCDR,
    0,
    [_tN],
    [[() => ConnectivityApiThingName, 1]], 1
];
exports.GetThingConnectivityDataResponse$ = [3, n0, _GTCDRe,
    0,
    [_tN, _conn, _ti, _dR],
    [[() => ConnectivityApiThingName, 0], 2, 4, 0]
];
exports.GetTopicRuleDestinationRequest$ = [3, n0, _GTRDR,
    0,
    [_ar],
    [[0, 1]], 1
];
exports.GetTopicRuleDestinationResponse$ = [3, n0, _GTRDRe,
    0,
    [_tRD],
    [() => exports.TopicRuleDestination$]
];
exports.GetTopicRuleRequest$ = [3, n0, _GTRR,
    0,
    [_rN],
    [[0, 1]], 1
];
exports.GetTopicRuleResponse$ = [3, n0, _GTRRe,
    0,
    [_rAu, _ru],
    [0, () => exports.TopicRule$]
];
exports.GetV2LoggingOptionsRequest$ = [3, n0, _GVLOR,
    0,
    [_ver],
    [[2, { [_hQ]: _ver }]]
];
exports.GetV2LoggingOptionsResponse$ = [3, n0, _GVLORe,
    0,
    [_rAo, _dLL, _dAL, _eCv],
    [0, 0, 2, () => LogEventConfigurations]
];
exports.GroupNameAndArn$ = [3, n0, _GNAA,
    0,
    [_gN, _gA],
    [0, 0]
];
exports.HttpAction$ = [3, n0, _HA,
    0,
    [_ur, _cU, _he, _au, _eB, _bC],
    [0, 0, () => HeaderList, () => exports.HttpAuthorization$, 2, () => exports.BatchConfig$], 1
];
exports.HttpActionHeader$ = [3, n0, _HAH,
    0,
    [_ke, _va],
    [0, 0], 2
];
exports.HttpAuthorization$ = [3, n0, _HAt,
    0,
    [_sig],
    [() => exports.SigV4Authorization$]
];
exports.HttpContext$ = [3, n0, _HC,
    0,
    [_he, _qS],
    [128 | 0, 0]
];
exports.HttpUrlDestinationConfiguration$ = [3, n0, _HUDC,
    0,
    [_cU],
    [0], 1
];
exports.HttpUrlDestinationProperties$ = [3, n0, _HUDP,
    0,
    [_cU],
    [0]
];
exports.HttpUrlDestinationSummary$ = [3, n0, _HUDS,
    0,
    [_cU],
    [0]
];
exports.ImplicitDeny$ = [3, n0, _ID,
    0,
    [_p],
    [() => Policies]
];
exports.IndexingFilter$ = [3, n0, _IF,
    0,
    [_nSN, _gL],
    [64 | 0, () => GeoLocationsFilter]
];
exports.IotAnalyticsAction$ = [3, n0, _IAA,
    0,
    [_cAh, _cNh, _bM, _rAo],
    [0, 0, 2, 0]
];
exports.IotEventsAction$ = [3, n0, _IEA,
    0,
    [_iNn, _rAo, _mI, _bM],
    [0, 0, 0, 2], 2
];
exports.IotSiteWiseAction$ = [3, n0, _ISWA,
    0,
    [_pAPVE, _rAo],
    [() => PutAssetPropertyValueEntryList, 0], 2
];
exports.IssuerCertificateIdentifier$ = [3, n0, _ICI,
    0,
    [_iCS, _iI, _iCSN],
    [0, 0, 0]
];
exports.Job$ = [3, n0, _J,
    0,
    [_jA, _jI, _tSa, _st, _fCo, _rC, _co, _ta, _d, _pUC, _jERC, _aCb, _cAr, _lUA, _cAom, _jPD, _tCi, _nI, _jTA, _jERCo, _dP, _iC, _sC, _sJR, _dPV],
    [0, 0, 0, 0, 2, 0, 0, 64 | 0, 0, () => exports.PresignedUrlConfig$, () => exports.JobExecutionsRolloutConfig$, () => exports.AbortConfig$, 4, 4, 4, () => exports.JobProcessDetails$, () => exports.TimeoutConfig$, 0, 0, () => exports.JobExecutionsRetryConfig$, 128 | 0, 2, () => exports.SchedulingConfig$, () => ScheduledJobRolloutList, 64 | 0]
];
exports.JobExecution$ = [3, n0, _JE,
    0,
    [_jI, _st, _fCo, _sDt, _tA, _qA, _sAt, _lUA, _eN, _vNe, _aSBTO],
    [0, 0, 2, () => exports.JobExecutionStatusDetails$, 0, 4, 4, 4, 1, 1, 1]
];
exports.JobExecutionsRetryConfig$ = [3, n0, _JERC,
    0,
    [_cL],
    [() => RetryCriteriaList], 1
];
exports.JobExecutionsRolloutConfig$ = [3, n0, _JERCo,
    0,
    [_mPM, _eR],
    [1, () => exports.ExponentialRolloutRate$]
];
exports.JobExecutionStatusDetails$ = [3, n0, _JESD,
    0,
    [_dM],
    [128 | 0]
];
exports.JobExecutionSummary$ = [3, n0, _JES,
    0,
    [_st, _qA, _sAt, _lUA, _eN, _rAe],
    [0, 4, 4, 4, 1, 1]
];
exports.JobExecutionSummaryForJob$ = [3, n0, _JESFJ,
    0,
    [_tA, _jES],
    [0, () => exports.JobExecutionSummary$]
];
exports.JobExecutionSummaryForThing$ = [3, n0, _JESFT,
    0,
    [_jI, _jES],
    [0, () => exports.JobExecutionSummary$]
];
exports.JobProcessDetails$ = [3, n0, _JPD,
    0,
    [_pTr, _nOCT, _nOST, _nOFT, _nORT, _nOQT, _nOIPT, _nORTu, _nOTOT],
    [64 | 0, 1, 1, 1, 1, 1, 1, 1, 1]
];
exports.JobSummary$ = [3, n0, _JS,
    0,
    [_jA, _jI, _tGI, _tSa, _st, _cAr, _lUA, _cAom, _iC],
    [0, 0, 0, 0, 0, 4, 4, 4, 2]
];
exports.JobTemplateSummary$ = [3, n0, _JTS,
    0,
    [_jTA, _jTI, _d, _cAr],
    [0, 0, 0, 4]
];
exports.KafkaAction$ = [3, n0, _KA,
    0,
    [_dA, _to, _cPl, _ke, _part, _he],
    [0, 0, 128 | 0, 0, 0, () => KafkaHeaders], 3
];
exports.KafkaActionHeader$ = [3, n0, _KAH,
    0,
    [_ke, _va],
    [0, 0], 2
];
exports.KeyPair$ = [3, n0, _KP,
    0,
    [_PKu, _PK],
    [0, [() => PrivateKey, 0]]
];
exports.KinesisAction$ = [3, n0, _KAi,
    0,
    [_rAo, _sN, _pK],
    [0, 0, 0], 2
];
exports.LambdaAction$ = [3, n0, _LA,
    0,
    [_fA],
    [0], 1
];
exports.ListActiveViolationsRequest$ = [3, n0, _LAVR,
    0,
    [_tN, _sPN, _bCT, _lSA, _vS, _nT, _mR],
    [[0, { [_hQ]: _tN }], [0, { [_hQ]: _sPN }], [0, { [_hQ]: _bCT }], [2, { [_hQ]: _lSA }], [0, { [_hQ]: _vS }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]]
];
exports.ListActiveViolationsResponse$ = [3, n0, _LAVRi,
    0,
    [_aV, _nT],
    [() => ActiveViolations, 0]
];
exports.ListAttachedPoliciesRequest$ = [3, n0, _LAPR,
    0,
    [_tar, _recu, _mar, _pS],
    [[0, 1], [2, { [_hQ]: _recu }], [0, { [_hQ]: _mar }], [1, { [_hQ]: _pS }]], 1
];
exports.ListAttachedPoliciesResponse$ = [3, n0, _LAPRi,
    0,
    [_p, _nM],
    [() => Policies, 0]
];
exports.ListAuditFindingsRequest$ = [3, n0, _LAFR,
    0,
    [_tI, _cN, _rIe, _mR, _nT, _sT, _eT, _lSF],
    [0, 0, () => exports.ResourceIdentifier$, 1, 0, 4, 4, 2]
];
exports.ListAuditFindingsResponse$ = [3, n0, _LAFRi,
    0,
    [_find, _nT],
    [() => AuditFindings, 0]
];
exports.ListAuditMitigationActionsExecutionsRequest$ = [3, n0, _LAMAER,
    0,
    [_tI, _fI, _aSc, _mR, _nT],
    [[0, { [_hQ]: _tI }], [0, { [_hQ]: _fI }], [0, { [_hQ]: _aSc }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 2
];
exports.ListAuditMitigationActionsExecutionsResponse$ = [3, n0, _LAMAERi,
    0,
    [_aEc, _nT],
    [() => AuditMitigationActionExecutionMetadataList, 0]
];
exports.ListAuditMitigationActionsTasksRequest$ = [3, n0, _LAMATR,
    0,
    [_sT, _eT, _aTI, _fI, _tS, _mR, _nT],
    [[4, { [_hQ]: _sT }], [4, { [_hQ]: _eT }], [0, { [_hQ]: _aTI }], [0, { [_hQ]: _fI }], [0, { [_hQ]: _tS }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 2
];
exports.ListAuditMitigationActionsTasksResponse$ = [3, n0, _LAMATRi,
    0,
    [_tas, _nT],
    [() => AuditMitigationActionsTaskMetadataList, 0]
];
exports.ListAuditSuppressionsRequest$ = [3, n0, _LASR,
    0,
    [_cN, _rIe, _aO, _nT, _mR],
    [0, () => exports.ResourceIdentifier$, 2, 0, 1]
];
exports.ListAuditSuppressionsResponse$ = [3, n0, _LASRi,
    0,
    [_sup, _nT],
    [() => AuditSuppressionList, 0]
];
exports.ListAuditTasksRequest$ = [3, n0, _LATR,
    0,
    [_sT, _eT, _tT, _tS, _nT, _mR],
    [[4, { [_hQ]: _sT }], [4, { [_hQ]: _eT }], [0, { [_hQ]: _tT }], [0, { [_hQ]: _tS }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 2
];
exports.ListAuditTasksResponse$ = [3, n0, _LATRi,
    0,
    [_tas, _nT],
    [() => AuditTaskMetadataList, 0]
];
exports.ListAuthorizersRequest$ = [3, n0, _LAR,
    0,
    [_pS, _mar, _aO, _st],
    [[1, { [_hQ]: _pS }], [0, { [_hQ]: _mar }], [2, { [_hQ]: _iAO }], [0, { [_hQ]: _st }]]
];
exports.ListAuthorizersResponse$ = [3, n0, _LARi,
    0,
    [_aut, _nM],
    [() => Authorizers, 0]
];
exports.ListBillingGroupsRequest$ = [3, n0, _LBGR,
    0,
    [_nT, _mR, _nPF],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nPF }]]
];
exports.ListBillingGroupsResponse$ = [3, n0, _LBGRi,
    0,
    [_bG, _nT],
    [() => BillingGroupNameAndArnList, 0]
];
exports.ListCACertificatesRequest$ = [3, n0, _LCACR,
    0,
    [_pS, _mar, _aO, _tNe],
    [[1, { [_hQ]: _pS }], [0, { [_hQ]: _mar }], [2, { [_hQ]: _iAO }], [0, { [_hQ]: _tNe }]]
];
exports.ListCACertificatesResponse$ = [3, n0, _LCACRi,
    0,
    [_ce, _nM],
    [() => CACertificates, 0]
];
exports.ListCertificateProvidersRequest$ = [3, n0, _LCPR,
    0,
    [_nT, _aO],
    [[0, { [_hQ]: _nT }], [2, { [_hQ]: _iAO }]]
];
exports.ListCertificateProvidersResponse$ = [3, n0, _LCPRi,
    0,
    [_cPe, _nT],
    [() => CertificateProviders, 0]
];
exports.ListCertificatesByCARequest$ = [3, n0, _LCBCAR,
    0,
    [_cCI, _pS, _mar, _aO],
    [[0, 1], [1, { [_hQ]: _pS }], [0, { [_hQ]: _mar }], [2, { [_hQ]: _iAO }]], 1
];
exports.ListCertificatesByCAResponse$ = [3, n0, _LCBCARi,
    0,
    [_ce, _nM],
    [() => Certificates, 0]
];
exports.ListCertificatesRequest$ = [3, n0, _LCR,
    0,
    [_pS, _mar, _aO],
    [[1, { [_hQ]: _pS }], [0, { [_hQ]: _mar }], [2, { [_hQ]: _iAO }]]
];
exports.ListCertificatesResponse$ = [3, n0, _LCRi,
    0,
    [_ce, _nM],
    [() => Certificates, 0]
];
exports.ListCommandExecutionsRequest$ = [3, n0, _LCER,
    0,
    [_mR, _nT, _na, _st, _sO, _sTF, _cTF, _tAa, _cAo],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }], 0, 0, 0, () => exports.TimeFilter$, () => exports.TimeFilter$, 0, 0]
];
exports.ListCommandExecutionsResponse$ = [3, n0, _LCERi,
    0,
    [_cE, _nT],
    [() => CommandExecutionSummaryList, 0]
];
exports.ListCommandsRequest$ = [3, n0, _LCRis,
    0,
    [_mR, _nT, _na, _cPNo, _sO],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }], [0, { [_hQ]: _na }], [0, { [_hQ]: _cPNo }], [0, { [_hQ]: _sO }]]
];
exports.ListCommandsResponse$ = [3, n0, _LCRist,
    0,
    [_com, _nT],
    [() => CommandSummaryList, 0]
];
exports.ListCustomMetricsRequest$ = [3, n0, _LCMR,
    0,
    [_nT, _mR],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]]
];
exports.ListCustomMetricsResponse$ = [3, n0, _LCMRi,
    0,
    [_mNet, _nT],
    [64 | 0, 0]
];
exports.ListDetectMitigationActionsExecutionsRequest$ = [3, n0, _LDMAER,
    0,
    [_tI, _vI, _tN, _sT, _eT, _mR, _nT],
    [[0, { [_hQ]: _tI }], [0, { [_hQ]: _vI }], [0, { [_hQ]: _tN }], [4, { [_hQ]: _sT }], [4, { [_hQ]: _eT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.ListDetectMitigationActionsExecutionsResponse$ = [3, n0, _LDMAERi,
    0,
    [_aEc, _nT],
    [() => DetectMitigationActionExecutionList, 0]
];
exports.ListDetectMitigationActionsTasksRequest$ = [3, n0, _LDMATR,
    0,
    [_sT, _eT, _mR, _nT],
    [[4, { [_hQ]: _sT }], [4, { [_hQ]: _eT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 2
];
exports.ListDetectMitigationActionsTasksResponse$ = [3, n0, _LDMATRi,
    0,
    [_tas, _nT],
    [() => DetectMitigationActionsTaskSummaryList, 0]
];
exports.ListDimensionsRequest$ = [3, n0, _LDR,
    0,
    [_nT, _mR],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]]
];
exports.ListDimensionsResponse$ = [3, n0, _LDRi,
    0,
    [_dNi, _nT],
    [64 | 0, 0]
];
exports.ListDomainConfigurationsRequest$ = [3, n0, _LDCR,
    0,
    [_mar, _pS, _sTe],
    [[0, { [_hQ]: _mar }], [1, { [_hQ]: _pS }], [0, { [_hQ]: _sTe }]]
];
exports.ListDomainConfigurationsResponse$ = [3, n0, _LDCRi,
    0,
    [_dCo, _nM],
    [() => DomainConfigurations, 0]
];
exports.ListFleetMetricsRequest$ = [3, n0, _LFMR,
    0,
    [_nT, _mR],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]]
];
exports.ListFleetMetricsResponse$ = [3, n0, _LFMRi,
    0,
    [_fM, _nT],
    [() => FleetMetricNameAndArnList, 0]
];
exports.ListIndicesRequest$ = [3, n0, _LIR,
    0,
    [_nT, _mR],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]]
];
exports.ListIndicesResponse$ = [3, n0, _LIRi,
    0,
    [_iNnd, _nT],
    [64 | 0, 0]
];
exports.ListJobExecutionsForJobRequest$ = [3, n0, _LJEFJR,
    0,
    [_jI, _st, _mR, _nT],
    [[0, 1], [0, { [_hQ]: _st }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 1
];
exports.ListJobExecutionsForJobResponse$ = [3, n0, _LJEFJRi,
    0,
    [_eS, _nT],
    [() => JobExecutionSummaryForJobList, 0]
];
exports.ListJobExecutionsForThingRequest$ = [3, n0, _LJEFTR,
    0,
    [_tN, _st, _nI, _mR, _nT, _jI],
    [[0, 1], [0, { [_hQ]: _st }], [0, { [_hQ]: _nI }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }], [0, { [_hQ]: _jI }]], 1
];
exports.ListJobExecutionsForThingResponse$ = [3, n0, _LJEFTRi,
    0,
    [_eS, _nT],
    [() => JobExecutionSummaryForThingList, 0]
];
exports.ListJobsRequest$ = [3, n0, _LJR,
    0,
    [_st, _tSa, _mR, _nT, _tGNh, _tGI, _nI],
    [[0, { [_hQ]: _st }], [0, { [_hQ]: _tSa }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }], [0, { [_hQ]: _tGNh }], [0, { [_hQ]: _tGI }], [0, { [_hQ]: _nI }]]
];
exports.ListJobsResponse$ = [3, n0, _LJRi,
    0,
    [_jo, _nT],
    [() => JobSummaryList, 0]
];
exports.ListJobTemplatesRequest$ = [3, n0, _LJTR,
    0,
    [_mR, _nT],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.ListJobTemplatesResponse$ = [3, n0, _LJTRi,
    0,
    [_jT, _nT],
    [() => JobTemplateSummaryList, 0]
];
exports.ListManagedJobTemplatesRequest$ = [3, n0, _LMJTR,
    0,
    [_tNe, _mR, _nT],
    [[0, { [_hQ]: _tNe }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.ListManagedJobTemplatesResponse$ = [3, n0, _LMJTRi,
    0,
    [_mJT, _nT],
    [() => ManagedJobTemplatesSummaryList, 0]
];
exports.ListMetricValuesRequest$ = [3, n0, _LMVR,
    0,
    [_tN, _mNe, _sT, _eT, _dNim, _dVO, _mR, _nT],
    [[0, { [_hQ]: _tN }], [0, { [_hQ]: _mNe }], [4, { [_hQ]: _sT }], [4, { [_hQ]: _eT }], [0, { [_hQ]: _dNim }], [0, { [_hQ]: _dVO }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 4
];
exports.ListMetricValuesResponse$ = [3, n0, _LMVRi,
    0,
    [_mDL, _nT],
    [() => MetricDatumList, 0]
];
exports.ListMitigationActionsRequest$ = [3, n0, _LMAR,
    0,
    [_aT, _mR, _nT],
    [[0, { [_hQ]: _aT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.ListMitigationActionsResponse$ = [3, n0, _LMARi,
    0,
    [_aIc, _nT],
    [() => MitigationActionIdentifierList, 0]
];
exports.ListOTAUpdatesRequest$ = [3, n0, _LOTAUR,
    0,
    [_mR, _nT, _oUS],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }], [0, { [_hQ]: _oUS }]]
];
exports.ListOTAUpdatesResponse$ = [3, n0, _LOTAURi,
    0,
    [_oU, _nT],
    [() => OTAUpdatesSummary, 0]
];
exports.ListOutgoingCertificatesRequest$ = [3, n0, _LOCR,
    0,
    [_pS, _mar, _aO],
    [[1, { [_hQ]: _pS }], [0, { [_hQ]: _mar }], [2, { [_hQ]: _iAO }]]
];
exports.ListOutgoingCertificatesResponse$ = [3, n0, _LOCRi,
    0,
    [_oC, _nM],
    [() => OutgoingCertificates, 0]
];
exports.ListPackagesRequest$ = [3, n0, _LPR,
    0,
    [_mR, _nT],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.ListPackagesResponse$ = [3, n0, _LPRi,
    0,
    [_pSa, _nT],
    [() => PackageSummaryList, 0]
];
exports.ListPackageVersionsRequest$ = [3, n0, _LPVR,
    0,
    [_pN, _st, _mR, _nT],
    [[0, 1], [0, { [_hQ]: _st }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 1
];
exports.ListPackageVersionsResponse$ = [3, n0, _LPVRi,
    0,
    [_pVS, _nT],
    [() => PackageVersionSummaryList, 0]
];
exports.ListPoliciesRequest$ = [3, n0, _LPRis,
    0,
    [_mar, _pS, _aO],
    [[0, { [_hQ]: _mar }], [1, { [_hQ]: _pS }], [2, { [_hQ]: _iAO }]]
];
exports.ListPoliciesResponse$ = [3, n0, _LPRist,
    0,
    [_p, _nM],
    [() => Policies, 0]
];
exports.ListPolicyPrincipalsRequest$ = [3, n0, _LPPR,
    0,
    [_pNo, _mar, _pS, _aO],
    [[0, { [_hH]: _xaip_ }], [0, { [_hQ]: _mar }], [1, { [_hQ]: _pS }], [2, { [_hQ]: _iAO }]], 1
];
exports.ListPolicyPrincipalsResponse$ = [3, n0, _LPPRi,
    0,
    [_pri, _nM],
    [64 | 0, 0]
];
exports.ListPolicyVersionsRequest$ = [3, n0, _LPVRis,
    0,
    [_pNo],
    [[0, 1]], 1
];
exports.ListPolicyVersionsResponse$ = [3, n0, _LPVRist,
    0,
    [_pV],
    [() => PolicyVersions]
];
exports.ListPrincipalPoliciesRequest$ = [3, n0, _LPPRis,
    0,
    [_pr, _mar, _pS, _aO],
    [[0, { [_hH]: _xaip }], [0, { [_hQ]: _mar }], [1, { [_hQ]: _pS }], [2, { [_hQ]: _iAO }]], 1
];
exports.ListPrincipalPoliciesResponse$ = [3, n0, _LPPRist,
    0,
    [_p, _nM],
    [() => Policies, 0]
];
exports.ListPrincipalThingsRequest$ = [3, n0, _LPTR,
    0,
    [_pr, _nT, _mR],
    [[0, { [_hH]: _xap }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 1
];
exports.ListPrincipalThingsResponse$ = [3, n0, _LPTRi,
    0,
    [_th, _nT],
    [64 | 0, 0]
];
exports.ListPrincipalThingsV2Request$ = [3, n0, _LPTVR,
    0,
    [_pr, _nT, _mR, _tPT],
    [[0, { [_hH]: _xap }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _tPT }]], 1
];
exports.ListPrincipalThingsV2Response$ = [3, n0, _LPTVRi,
    0,
    [_pTO, _nT],
    [() => PrincipalThingObjects, 0]
];
exports.ListProvisioningTemplatesRequest$ = [3, n0, _LPTRis,
    0,
    [_mR, _nT],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.ListProvisioningTemplatesResponse$ = [3, n0, _LPTRist,
    0,
    [_te, _nT],
    [() => ProvisioningTemplateListing, 0]
];
exports.ListProvisioningTemplateVersionsRequest$ = [3, n0, _LPTVRis,
    0,
    [_tNe, _mR, _nT],
    [[0, 1], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 1
];
exports.ListProvisioningTemplateVersionsResponse$ = [3, n0, _LPTVRist,
    0,
    [_vers, _nT],
    [() => ProvisioningTemplateVersionListing, 0]
];
exports.ListRelatedResourcesForAuditFindingRequest$ = [3, n0, _LRRFAFR,
    0,
    [_fI, _nT, _mR],
    [[0, { [_hQ]: _fI }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 1
];
exports.ListRelatedResourcesForAuditFindingResponse$ = [3, n0, _LRRFAFRi,
    0,
    [_rR, _nT],
    [() => RelatedResources, 0]
];
exports.ListRoleAliasesRequest$ = [3, n0, _LRAR,
    0,
    [_pS, _mar, _aO],
    [[1, { [_hQ]: _pS }], [0, { [_hQ]: _mar }], [2, { [_hQ]: _iAO }]]
];
exports.ListRoleAliasesResponse$ = [3, n0, _LRARi,
    0,
    [_rAole, _nM],
    [64 | 0, 0]
];
exports.ListSbomValidationResultsRequest$ = [3, n0, _LSVRR,
    0,
    [_pN, _vN, _vR, _mR, _nT],
    [[0, 1], [0, 1], [0, { [_hQ]: _vR }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]], 2
];
exports.ListSbomValidationResultsResponse$ = [3, n0, _LSVRRi,
    0,
    [_vRS, _nT],
    [() => SbomValidationResultSummaryList, 0]
];
exports.ListScheduledAuditsRequest$ = [3, n0, _LSAR,
    0,
    [_nT, _mR],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]]
];
exports.ListScheduledAuditsResponse$ = [3, n0, _LSARi,
    0,
    [_sAc, _nT],
    [() => ScheduledAuditMetadataList, 0]
];
exports.ListSecurityProfilesForTargetRequest$ = [3, n0, _LSPFTR,
    0,
    [_sPTA, _nT, _mR, _recu],
    [[0, { [_hQ]: _sPTA }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [2, { [_hQ]: _recu }]], 1
];
exports.ListSecurityProfilesForTargetResponse$ = [3, n0, _LSPFTRi,
    0,
    [_sPTM, _nT],
    [() => SecurityProfileTargetMappings, 0]
];
exports.ListSecurityProfilesRequest$ = [3, n0, _LSPR,
    0,
    [_nT, _mR, _dNim, _mNe],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _dNim }], [0, { [_hQ]: _mNe }]]
];
exports.ListSecurityProfilesResponse$ = [3, n0, _LSPRi,
    0,
    [_sPI, _nT],
    [() => SecurityProfileIdentifiers, 0]
];
exports.ListStreamsRequest$ = [3, n0, _LSR,
    0,
    [_mR, _nT, _aO],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }], [2, { [_hQ]: _iAO }]]
];
exports.ListStreamsResponse$ = [3, n0, _LSRi,
    0,
    [_strea, _nT],
    [() => StreamsSummary, 0]
];
exports.ListTagsForResourceRequest$ = [3, n0, _LTFRR,
    0,
    [_rA, _nT],
    [[0, { [_hQ]: _rA }], [0, { [_hQ]: _nT }]], 1
];
exports.ListTagsForResourceResponse$ = [3, n0, _LTFRRi,
    0,
    [_tag, _nT],
    [() => TagList, 0]
];
exports.ListTargetsForPolicyRequest$ = [3, n0, _LTFPR,
    0,
    [_pNo, _mar, _pS],
    [[0, 1], [0, { [_hQ]: _mar }], [1, { [_hQ]: _pS }]], 1
];
exports.ListTargetsForPolicyResponse$ = [3, n0, _LTFPRi,
    0,
    [_ta, _nM],
    [64 | 0, 0]
];
exports.ListTargetsForSecurityProfileRequest$ = [3, n0, _LTFSPR,
    0,
    [_sPN, _nT, _mR],
    [[0, 1], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 1
];
exports.ListTargetsForSecurityProfileResponse$ = [3, n0, _LTFSPRi,
    0,
    [_sPT, _nT],
    [() => SecurityProfileTargets, 0]
];
exports.ListThingGroupsForThingRequest$ = [3, n0, _LTGFTR,
    0,
    [_tN, _nT, _mR],
    [[0, 1], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 1
];
exports.ListThingGroupsForThingResponse$ = [3, n0, _LTGFTRi,
    0,
    [_tG, _nT],
    [() => ThingGroupNameAndArnList, 0]
];
exports.ListThingGroupsRequest$ = [3, n0, _LTGR,
    0,
    [_nT, _mR, _pG, _nPF, _recu],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _pG }], [0, { [_hQ]: _nPF }], [2, { [_hQ]: _recu }]]
];
exports.ListThingGroupsResponse$ = [3, n0, _LTGRi,
    0,
    [_tG, _nT],
    [() => ThingGroupNameAndArnList, 0]
];
exports.ListThingPrincipalsRequest$ = [3, n0, _LTPR,
    0,
    [_tN, _nT, _mR],
    [[0, 1], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 1
];
exports.ListThingPrincipalsResponse$ = [3, n0, _LTPRi,
    0,
    [_pri, _nT],
    [64 | 0, 0]
];
exports.ListThingPrincipalsV2Request$ = [3, n0, _LTPVR,
    0,
    [_tN, _nT, _mR, _tPT],
    [[0, 1], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _tPT }]], 1
];
exports.ListThingPrincipalsV2Response$ = [3, n0, _LTPVRi,
    0,
    [_tPO, _nT],
    [() => ThingPrincipalObjects, 0]
];
exports.ListThingRegistrationTaskReportsRequest$ = [3, n0, _LTRTRR,
    0,
    [_tI, _rT, _nT, _mR],
    [[0, 1], [0, { [_hQ]: _rT }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 2
];
exports.ListThingRegistrationTaskReportsResponse$ = [3, n0, _LTRTRRi,
    0,
    [_rL, _rT, _nT],
    [64 | 0, 0, 0]
];
exports.ListThingRegistrationTasksRequest$ = [3, n0, _LTRTR,
    0,
    [_nT, _mR, _st],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _st }]]
];
exports.ListThingRegistrationTasksResponse$ = [3, n0, _LTRTRi,
    0,
    [_tIa, _nT],
    [64 | 0, 0]
];
exports.ListThingsInBillingGroupRequest$ = [3, n0, _LTIBGR,
    0,
    [_bGN, _nT, _mR],
    [[0, 1], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 1
];
exports.ListThingsInBillingGroupResponse$ = [3, n0, _LTIBGRi,
    0,
    [_th, _nT],
    [64 | 0, 0]
];
exports.ListThingsInThingGroupRequest$ = [3, n0, _LTITGR,
    0,
    [_tGNh, _recu, _nT, _mR],
    [[0, 1], [2, { [_hQ]: _recu }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 1
];
exports.ListThingsInThingGroupResponse$ = [3, n0, _LTITGRi,
    0,
    [_th, _nT],
    [64 | 0, 0]
];
exports.ListThingsRequest$ = [3, n0, _LTR,
    0,
    [_nT, _mR, _aNt, _aVt, _tTN, _uPAV],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _aNt }], [0, { [_hQ]: _aVt }], [0, { [_hQ]: _tTN }], [2, { [_hQ]: _uPAV }]]
];
exports.ListThingsResponse$ = [3, n0, _LTRi,
    0,
    [_th, _nT],
    [() => ThingAttributeList, 0]
];
exports.ListThingTypesRequest$ = [3, n0, _LTTR,
    0,
    [_nT, _mR, _tTN],
    [[0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _tTN }]]
];
exports.ListThingTypesResponse$ = [3, n0, _LTTRi,
    0,
    [_tTh, _nT],
    [() => ThingTypeList, 0]
];
exports.ListTopicRuleDestinationsRequest$ = [3, n0, _LTRDR,
    0,
    [_mR, _nT],
    [[1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }]]
];
exports.ListTopicRuleDestinationsResponse$ = [3, n0, _LTRDRi,
    0,
    [_dSes, _nT],
    [() => TopicRuleDestinationSummaries, 0]
];
exports.ListTopicRulesRequest$ = [3, n0, _LTRR,
    0,
    [_to, _mR, _nT, _rD],
    [[0, { [_hQ]: _to }], [1, { [_hQ]: _mR }], [0, { [_hQ]: _nT }], [2, { [_hQ]: _rD }]]
];
exports.ListTopicRulesResponse$ = [3, n0, _LTRRi,
    0,
    [_rul, _nT],
    [() => TopicRuleList, 0]
];
exports.ListV2LoggingLevelsRequest$ = [3, n0, _LVLLR,
    0,
    [_tTa, _nT, _mR],
    [[0, { [_hQ]: _tTa }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]]
];
exports.ListV2LoggingLevelsResponse$ = [3, n0, _LVLLRi,
    0,
    [_lTC, _nT],
    [() => LogTargetConfigurations, 0]
];
exports.ListViolationEventsRequest$ = [3, n0, _LVER,
    0,
    [_sT, _eT, _tN, _sPN, _bCT, _lSA, _vS, _nT, _mR],
    [[4, { [_hQ]: _sT }], [4, { [_hQ]: _eT }], [0, { [_hQ]: _tN }], [0, { [_hQ]: _sPN }], [0, { [_hQ]: _bCT }], [2, { [_hQ]: _lSA }], [0, { [_hQ]: _vS }], [0, { [_hQ]: _nT }], [1, { [_hQ]: _mR }]], 2
];
exports.ListViolationEventsResponse$ = [3, n0, _LVERi,
    0,
    [_vE, _nT],
    [() => ViolationEvents, 0]
];
exports.LocationAction$ = [3, n0, _LAo,
    0,
    [_rAo, _tNr, _dI, _la, _lon, _ti],
    [0, 0, 0, 0, 0, () => exports.LocationTimestamp$], 5
];
exports.LocationTimestamp$ = [3, n0, _LT,
    0,
    [_va, _u],
    [0, 0], 1
];
exports.LogEventConfiguration$ = [3, n0, _LEC,
    0,
    [_eTv, _lL, _lD],
    [0, 0, 0], 1
];
exports.LoggingOptionsPayload$ = [3, n0, _LOP,
    0,
    [_rAo, _lL],
    [0, 0], 1
];
exports.LogTarget$ = [3, n0, _LTo,
    0,
    [_tTa, _tNa],
    [0, 0], 1
];
exports.LogTargetConfiguration$ = [3, n0, _LTC,
    0,
    [_lT, _lL],
    [() => exports.LogTarget$, 0]
];
exports.MachineLearningDetectionConfig$ = [3, n0, _MLDC,
    0,
    [_cLo],
    [0], 1
];
exports.MaintenanceWindow$ = [3, n0, _MW,
    0,
    [_sT, _dIM],
    [0, 1], 2
];
exports.ManagedJobTemplateSummary$ = [3, n0, _MJTS,
    0,
    [_tAem, _tNe, _d, _env, _tV],
    [0, 0, 0, 64 | 0, 0]
];
exports.MetricDatum$ = [3, n0, _MD,
    0,
    [_ti, _va],
    [4, () => exports.MetricValue$]
];
exports.MetricDimension$ = [3, n0, _MDe,
    0,
    [_dNim, _oper],
    [0, 0], 1
];
exports.MetricsExportConfig$ = [3, n0, _MEC,
    0,
    [_mTq, _rAo],
    [0, 0], 2
];
exports.MetricToRetain$ = [3, n0, _MTR,
    0,
    [_met, _mD, _eM],
    [0, () => exports.MetricDimension$, 2], 1
];
exports.MetricValue$ = [3, n0, _MV,
    0,
    [_cou, _ci, _po, _nu, _num, _stri],
    [1, 64 | 0, 64 | 1, 1, 64 | 1, 64 | 0]
];
exports.MitigationAction$ = [3, n0, _MA,
    0,
    [_n, _id, _rAo, _aPc],
    [0, 0, 0, () => exports.MitigationActionParams$]
];
exports.MitigationActionIdentifier$ = [3, n0, _MAI,
    0,
    [_aN, _aAc, _cD],
    [0, 0, 4]
];
exports.MitigationActionParams$ = [3, n0, _MAP,
    0,
    [_uDCP, _uCACP, _aTTTGP, _rDPVP, _eITLP, _pFTSP],
    [() => exports.UpdateDeviceCertificateParams$, () => exports.UpdateCACertificateParams$, () => exports.AddThingsToThingGroupParams$, () => exports.ReplaceDefaultPolicyVersionParams$, () => exports.EnableIoTLoggingParams$, () => exports.PublishFindingToSnsParams$]
];
exports.Mqtt5Configuration$ = [3, n0, _MC,
    0,
    [_pAr],
    [() => PropagatingAttributeList]
];
exports.MqttContext$ = [3, n0, _MCq,
    0,
    [_us, _pas, _cIl],
    [0, 21, 0]
];
exports.MqttHeaders$ = [3, n0, _MH,
    0,
    [_pFI, _cTo, _rTe, _cDor, _mE, _uP],
    [0, 0, 0, 0, 0, () => UserProperties]
];
exports.NonCompliantResource$ = [3, n0, _NCR,
    0,
    [_rTes, _rIe, _aId],
    [0, () => exports.ResourceIdentifier$, 128 | 0]
];
exports.OpenSearchAction$ = [3, n0, _OSA,
    0,
    [_rAo, _end, _i, _ty, _id],
    [0, 0, 0, 0, 0], 5
];
exports.OTAUpdateFile$ = [3, n0, _OTAUF,
    0,
    [_fN, _fTil, _fV, _fL, _cSo, _at],
    [0, 1, 0, () => exports.FileLocation$, () => exports.CodeSigning$, 128 | 0]
];
exports.OTAUpdateInfo$ = [3, n0, _OTAUI,
    0,
    [_oUI, _oUA, _cD, _lMD, _d, _ta, _pro, _aJERC, _aJPUC, _tSa, _oUF, _oUS, _aIJI, _aIJA, _eIr, _aPd],
    [0, 0, 4, 4, 0, 64 | 0, 64 | 0, () => exports.AwsJobExecutionsRolloutConfig$, () => exports.AwsJobPresignedUrlConfig$, 0, () => OTAUpdateFiles, 0, 0, 0, () => exports.ErrorInfo$, 128 | 0]
];
exports.OTAUpdateSummary$ = [3, n0, _OTAUS,
    0,
    [_oUI, _oUA, _cD],
    [0, 0, 4]
];
exports.OutgoingCertificate$ = [3, n0, _OC,
    0,
    [_cAe, _cI, _tTr, _tDr, _tM, _cD],
    [0, 0, 0, 4, 0, 4]
];
exports.PackageSummary$ = [3, n0, _PS,
    0,
    [_pN, _dVN, _cD, _lMD],
    [0, 0, 4, 4]
];
exports.PackageVersionArtifact$ = [3, n0, _PVA,
    0,
    [_sL],
    [() => exports.S3Location$]
];
exports.PackageVersionSummary$ = [3, n0, _PVS,
    0,
    [_pN, _vN, _st, _cD, _lMD],
    [0, 0, 0, 4, 4]
];
exports.PercentPair$ = [3, n0, _PP,
    0,
    [_perce, _va],
    [1, 1]
];
exports.Policy$ = [3, n0, _P,
    0,
    [_pNo, _pAo],
    [0, 0]
];
exports.PolicyVersion$ = [3, n0, _PV,
    0,
    [_vIe, _iDV, _cDr],
    [0, 2, 4]
];
exports.PolicyVersionIdentifier$ = [3, n0, _PVI,
    0,
    [_pNo, _pVI],
    [0, 0]
];
exports.PresignedUrlConfig$ = [3, n0, _PUC,
    0,
    [_rAo, _eIS],
    [0, 1]
];
exports.PrincipalThingObject$ = [3, n0, _PTO,
    0,
    [_tN, _tPT],
    [0, 0], 1
];
exports.PropagatingAttribute$ = [3, n0, _PA,
    0,
    [_uPK, _tAh, _cAon],
    [0, 0, 0]
];
exports.ProvisioningHook$ = [3, n0, _PH,
    0,
    [_tAa, _pVa],
    [0, 0], 1
];
exports.ProvisioningTemplateSummary$ = [3, n0, _PTS,
    0,
    [_tAem, _tNe, _d, _cD, _lMD, _en, _ty],
    [0, 0, 0, 4, 4, 2, 0]
];
exports.ProvisioningTemplateVersionSummary$ = [3, n0, _PTVS,
    0,
    [_vIe, _cD, _iDV],
    [1, 4, 2]
];
exports.PublishFindingToSnsParams$ = [3, n0, _PFTSP,
    0,
    [_tAo],
    [0], 1
];
exports.PutAssetPropertyValueEntry$ = [3, n0, _PAPVE,
    0,
    [_pVr, _eIn, _aIs, _pIr, _pAro],
    [() => AssetPropertyValueList, 0, 0, 0, 0], 1
];
exports.PutItemInput$ = [3, n0, _PII,
    0,
    [_tNab],
    [0], 1
];
exports.PutVerificationStateOnViolationRequest$ = [3, n0, _PVSOVR,
    0,
    [_vI, _vS, _vSD],
    [[0, 1], 0, 0], 2
];
exports.PutVerificationStateOnViolationResponse$ = [3, n0, _PVSOVRu,
    0,
    [],
    []
];
exports.RateIncreaseCriteria$ = [3, n0, _RIC,
    0,
    [_nONT, _nOST],
    [1, 1]
];
exports.RegisterCACertificateRequest$ = [3, n0, _RCACR,
    0,
    [_cCa, _vCe, _sAA, _aAR, _rCe, _tag, _cMe],
    [0, 0, [2, { [_hQ]: _sAA }], [2, { [_hQ]: _aAR }], () => exports.RegistrationConfig$, () => TagList, 0], 1
];
exports.RegisterCACertificateResponse$ = [3, n0, _RCACRe,
    0,
    [_cAe, _cI],
    [0, 0]
];
exports.RegisterCertificateRequest$ = [3, n0, _RCR,
    0,
    [_cP, _cCP, _sAA, _st],
    [0, 0, [2, { [_hQ]: _sAA }], 0], 1
];
exports.RegisterCertificateResponse$ = [3, n0, _RCRe,
    0,
    [_cAe, _cI],
    [0, 0]
];
exports.RegisterCertificateWithoutCARequest$ = [3, n0, _RCWCAR,
    0,
    [_cP, _st],
    [0, 0], 1
];
exports.RegisterCertificateWithoutCAResponse$ = [3, n0, _RCWCARe,
    0,
    [_cAe, _cI],
    [0, 0]
];
exports.RegisterThingRequest$ = [3, n0, _RTR,
    0,
    [_tB, _par],
    [0, 128 | 0], 1
];
exports.RegisterThingResponse$ = [3, n0, _RTRe,
    0,
    [_cP, _rAes],
    [0, 128 | 0]
];
exports.RegistrationConfig$ = [3, n0, _RC,
    0,
    [_tB, _rAo, _tNe],
    [0, 0, 0]
];
exports.RejectCertificateTransferRequest$ = [3, n0, _RCTR,
    0,
    [_cI, _rRe],
    [[0, 1], 0], 1
];
exports.RelatedResource$ = [3, n0, _RR,
    0,
    [_rTes, _rIe, _aId],
    [0, () => exports.ResourceIdentifier$, 128 | 0]
];
exports.RemoveThingFromBillingGroupRequest$ = [3, n0, _RTFBGR,
    0,
    [_bGN, _bGA, _tN, _tA],
    [0, 0, 0, 0]
];
exports.RemoveThingFromBillingGroupResponse$ = [3, n0, _RTFBGRe,
    0,
    [],
    []
];
exports.RemoveThingFromThingGroupRequest$ = [3, n0, _RTFTGR,
    0,
    [_tGNh, _tGA, _tN, _tA],
    [0, 0, 0, 0]
];
exports.RemoveThingFromThingGroupResponse$ = [3, n0, _RTFTGRe,
    0,
    [],
    []
];
exports.ReplaceDefaultPolicyVersionParams$ = [3, n0, _RDPVP,
    0,
    [_tNe],
    [0], 1
];
exports.ReplaceTopicRuleRequest$ = [3, n0, _RTRR,
    0,
    [_rN, _tRP],
    [[0, 1], [() => exports.TopicRulePayload$, 16]], 2
];
exports.RepublishAction$ = [3, n0, _RA,
    0,
    [_rAo, _to, _qo, _he],
    [0, 0, 1, () => exports.MqttHeaders$], 2
];
exports.ResourceIdentifier$ = [3, n0, _RI,
    0,
    [_dCIe, _cCI, _cIPI, _cIl, _pVIo, _ac, _iRA, _rAA, _iCI, _dCAe],
    [0, 0, 0, 0, () => exports.PolicyVersionIdentifier$, 0, 0, 0, () => exports.IssuerCertificateIdentifier$, 0]
];
exports.RetryCriteria$ = [3, n0, _RCe,
    0,
    [_fT, _nOR],
    [0, 1], 2
];
exports.RoleAliasDescription$ = [3, n0, _RAD,
    0,
    [_rAol, _rAA, _rAo, _ow, _cDS, _cD, _lMD],
    [0, 0, 0, 0, 1, 4, 4]
];
exports.S3Action$ = [3, n0, _SA,
    0,
    [_rAo, _bNu, _ke, _cAa],
    [0, 0, 0, 0], 3
];
exports.S3Destination$ = [3, n0, _SD,
    0,
    [_buc, _pref],
    [0, 0]
];
exports.S3Location$ = [3, n0, _SL,
    0,
    [_buc, _ke, _ve],
    [0, 0, 0]
];
exports.SalesforceAction$ = [3, n0, _SAa,
    0,
    [_tok, _ur],
    [0, 0], 2
];
exports.Sbom$ = [3, n0, _Sb,
    0,
    [_sL],
    [() => exports.S3Location$]
];
exports.SbomValidationResultSummary$ = [3, n0, _SVRS,
    0,
    [_fN, _vR, _eC, _eMr],
    [0, 0, 0, 0]
];
exports.ScheduledAuditMetadata$ = [3, n0, _SAM,
    0,
    [_sAN, _sAAc, _fr, _dOM, _dOW],
    [0, 0, 0, 0, 0]
];
exports.ScheduledJobRollout$ = [3, n0, _SJR,
    0,
    [_sT],
    [0]
];
exports.SchedulingConfig$ = [3, n0, _SC,
    0,
    [_sT, _eT, _eBn, _mW],
    [0, 0, 0, () => MaintenanceWindows]
];
exports.SearchIndexRequest$ = [3, n0, _SIR,
    0,
    [_qS, _iN, _nT, _mR, _qV],
    [0, 0, 0, 1, 0], 1
];
exports.SearchIndexResponse$ = [3, n0, _SIRe,
    0,
    [_nT, _th, _tG],
    [0, () => ThingDocumentList, () => ThingGroupDocumentList]
];
exports.SecurityProfileIdentifier$ = [3, n0, _SPI,
    0,
    [_n, _ar],
    [0, 0], 2
];
exports.SecurityProfileTarget$ = [3, n0, _SPT,
    0,
    [_ar],
    [0], 1
];
exports.SecurityProfileTargetMapping$ = [3, n0, _SPTM,
    0,
    [_sPIe, _tar],
    [() => exports.SecurityProfileIdentifier$, () => exports.SecurityProfileTarget$]
];
exports.ServerCertificateConfig$ = [3, n0, _SCC,
    0,
    [_eOCSPC, _oLA, _oARA],
    [2, 0, 0]
];
exports.ServerCertificateSummary$ = [3, n0, _SCS,
    0,
    [_sCAe, _sCS, _sCSD],
    [0, 0, 0]
];
exports.SetDefaultAuthorizerRequest$ = [3, n0, _SDAR,
    0,
    [_aNu],
    [0], 1
];
exports.SetDefaultAuthorizerResponse$ = [3, n0, _SDARe,
    0,
    [_aNu, _aA],
    [0, 0]
];
exports.SetDefaultPolicyVersionRequest$ = [3, n0, _SDPVR,
    0,
    [_pNo, _pVI],
    [[0, 1], [0, 1]], 2
];
exports.SetLoggingOptionsRequest$ = [3, n0, _SLOR,
    0,
    [_lOP],
    [[() => exports.LoggingOptionsPayload$, 16]], 1
];
exports.SetV2LoggingLevelRequest$ = [3, n0, _SVLLR,
    0,
    [_lT, _lL],
    [() => exports.LogTarget$, 0], 2
];
exports.SetV2LoggingOptionsRequest$ = [3, n0, _SVLOR,
    0,
    [_rAo, _dLL, _dAL, _eCv],
    [0, 0, 2, () => LogEventConfigurations]
];
exports.SigningProfileParameter$ = [3, n0, _SPP,
    0,
    [_cAe, _pl, _cPOD],
    [0, 0, 0]
];
exports.SigV4Authorization$ = [3, n0, _SVA,
    0,
    [_sRi, _sNe, _rAo],
    [0, 0, 0], 3
];
exports.SnsAction$ = [3, n0, _SAn,
    0,
    [_tAa, _rAo, _mF],
    [0, 0, 0], 2
];
exports.SqsAction$ = [3, n0, _SAq,
    0,
    [_rAo, _qU, _uB],
    [0, 0, 2], 2
];
exports.StartAuditMitigationActionsTaskRequest$ = [3, n0, _SAMATR,
    0,
    [_tI, _tar, _aCTAM, _cRT],
    [[0, 1], () => exports.AuditMitigationActionsTaskTarget$, [2, n0, _ACTAM, 0, 0, 64 | 0], [0, 4]], 3
];
exports.StartAuditMitigationActionsTaskResponse$ = [3, n0, _SAMATRt,
    0,
    [_tI],
    [0]
];
exports.StartDetectMitigationActionsTaskRequest$ = [3, n0, _SDMATR,
    0,
    [_tI, _tar, _act, _vEOR, _iOAV, _iSA, _cRT],
    [[0, 1], () => exports.DetectMitigationActionsTaskTarget$, 64 | 0, () => exports.ViolationEventOccurrenceRange$, 2, 2, [0, 4]], 3
];
exports.StartDetectMitigationActionsTaskResponse$ = [3, n0, _SDMATRt,
    0,
    [_tI],
    [0]
];
exports.StartOnDemandAuditTaskRequest$ = [3, n0, _SODATR,
    0,
    [_tCN],
    [64 | 0], 1
];
exports.StartOnDemandAuditTaskResponse$ = [3, n0, _SODATRt,
    0,
    [_tI],
    [0]
];
exports.StartSigningJobParameter$ = [3, n0, _SSJP,
    0,
    [_sPP, _sPNi, _des],
    [() => exports.SigningProfileParameter$, 0, () => exports.Destination$]
];
exports.StartThingRegistrationTaskRequest$ = [3, n0, _STRTR,
    0,
    [_tB, _iFB, _iFK, _rAo],
    [0, 0, 0, 0], 4
];
exports.StartThingRegistrationTaskResponse$ = [3, n0, _STRTRt,
    0,
    [_tI],
    [0]
];
exports.StatisticalThreshold$ = [3, n0, _ST,
    0,
    [_stat],
    [0]
];
exports.Statistics$ = [3, n0, _St,
    0,
    [_cou, _av, _sum, _min, _max, _sOS, _var, _sDtd],
    [1, 1, 1, 1, 1, 1, 1, 1]
];
exports.StatusReason$ = [3, n0, _SR,
    0,
    [_rC, _rDe],
    [0, 0], 1
];
exports.StepFunctionsAction$ = [3, n0, _SFA,
    0,
    [_sMN, _rAo, _eNP],
    [0, 0, 0], 2
];
exports.StopThingRegistrationTaskRequest$ = [3, n0, _STRTRto,
    0,
    [_tI],
    [[0, 1]], 1
];
exports.StopThingRegistrationTaskResponse$ = [3, n0, _STRTRtop,
    0,
    [],
    []
];
exports._Stream$ = [3, n0, _Str,
    0,
    [_sIt, _fIil],
    [0, 1]
];
exports.StreamFile$ = [3, n0, _SF,
    0,
    [_fIil, _sL],
    [1, () => exports.S3Location$]
];
exports.StreamInfo$ = [3, n0, _SI,
    0,
    [_sIt, _sAtr, _sVtr, _d, _fi, _cAr, _lUA, _rAo],
    [0, 0, 1, 0, () => StreamFiles, 4, 4, 0]
];
exports.StreamSummary$ = [3, n0, _SS,
    0,
    [_sIt, _sAtr, _sVtr, _d],
    [0, 0, 1, 0]
];
exports.Tag$ = [3, n0, _T,
    0,
    [_K, _V],
    [0, 0], 1
];
exports.TagResourceRequest$ = [3, n0, _TRR,
    0,
    [_rA, _tag],
    [0, () => TagList], 2
];
exports.TagResourceResponse$ = [3, n0, _TRRa,
    0,
    [],
    []
];
exports.TaskStatistics$ = [3, n0, _TS,
    0,
    [_tCot, _iPC, _wFDCC, _cCo, _nCC, _fCa, _cCan],
    [1, 1, 1, 1, 1, 1, 1]
];
exports.TaskStatisticsForAuditCheck$ = [3, n0, _TSFAC,
    0,
    [_tFC, _fFC, _sFC, _sFCk, _cFC],
    [1, 1, 1, 1, 1]
];
exports.TermsAggregation$ = [3, n0, _TA,
    0,
    [_mB],
    [1]
];
exports.TestAuthorizationRequest$ = [3, n0, _TAR,
    0,
    [_aIut, _pr, _cIPI, _cIl, _pNTA, _pNTS],
    [() => AuthInfos, 0, 0, [0, { [_hQ]: _cIl }], 64 | 0, 64 | 0], 1
];
exports.TestAuthorizationResponse$ = [3, n0, _TARe,
    0,
    [_aR],
    [() => AuthResults]
];
exports.TestInvokeAuthorizerRequest$ = [3, n0, _TIAR,
    0,
    [_aNu, _tok, _tSo, _hC, _mC, _tCl],
    [[0, 1], 0, 0, () => exports.HttpContext$, () => exports.MqttContext$, () => exports.TlsContext$], 1
];
exports.TestInvokeAuthorizerResponse$ = [3, n0, _TIARe,
    0,
    [_iAs, _pIri, _pDol, _rAIS, _dAIS],
    [2, 0, 64 | 0, 1, 1]
];
exports.ThingAttribute$ = [3, n0, _TAh,
    0,
    [_tN, _tTN, _tA, _at, _ve],
    [0, 0, 0, 128 | 0, 1]
];
exports.ThingConnectivity$ = [3, n0, _TC,
    0,
    [_conn, _ti, _dR],
    [2, 1, 0]
];
exports.ThingDocument$ = [3, n0, _TD,
    0,
    [_tN, _tIh, _tTN, _tGN, _at, _sh, _dD, _conne],
    [0, 0, 0, 64 | 0, 128 | 0, 0, 0, () => exports.ThingConnectivity$]
];
exports.ThingGroupDocument$ = [3, n0, _TGD,
    0,
    [_tGNh, _tGI, _tGD, _at, _pGNa],
    [0, 0, 0, 128 | 0, 64 | 0]
];
exports.ThingGroupIndexingConfiguration$ = [3, n0, _TGIC,
    0,
    [_tGIM, _mFa, _cF],
    [0, () => Fields, () => Fields], 1
];
exports.ThingGroupMetadata$ = [3, n0, _TGM,
    0,
    [_pGN, _rTPTG, _cD],
    [0, () => ThingGroupNameAndArnList, 4]
];
exports.ThingGroupProperties$ = [3, n0, _TGP,
    0,
    [_tGD, _aPt],
    [0, () => exports.AttributePayload$]
];
exports.ThingIndexingConfiguration$ = [3, n0, _TIC,
    0,
    [_tIM, _tCIM, _dDIM, _nSIM, _mFa, _cF, _fil],
    [0, 0, 0, 0, () => Fields, () => Fields, () => exports.IndexingFilter$], 1
];
exports.ThingPrincipalObject$ = [3, n0, _TPO,
    0,
    [_pr, _tPT],
    [0, 0], 1
];
exports.ThingTypeDefinition$ = [3, n0, _TTD,
    0,
    [_tTN, _tTA, _tTP, _tTM],
    [0, 0, () => exports.ThingTypeProperties$, () => exports.ThingTypeMetadata$]
];
exports.ThingTypeMetadata$ = [3, n0, _TTM,
    0,
    [_dep, _dDe, _cD],
    [2, 4, 4]
];
exports.ThingTypeProperties$ = [3, n0, _TTP,
    0,
    [_tTD, _sAe, _mCq],
    [0, 64 | 0, () => exports.Mqtt5Configuration$]
];
exports.TimeFilter$ = [3, n0, _TF,
    0,
    [_af, _bef],
    [0, 0]
];
exports.TimeoutConfig$ = [3, n0, _TCi,
    0,
    [_iPTIM],
    [1]
];
exports.TimestreamAction$ = [3, n0, _TAi,
    0,
    [_rAo, _dNa, _tNab, _di, _ti],
    [0, 0, 0, () => TimestreamDimensionList, () => exports.TimestreamTimestamp$], 4
];
exports.TimestreamDimension$ = [3, n0, _TDi,
    0,
    [_n, _va],
    [0, 0], 2
];
exports.TimestreamTimestamp$ = [3, n0, _TT,
    0,
    [_va, _u],
    [0, 0], 2
];
exports.TlsConfig$ = [3, n0, _TCl,
    0,
    [_sP],
    [0]
];
exports.TlsContext$ = [3, n0, _TCls,
    0,
    [_sNer],
    [0]
];
exports.TopicRule$ = [3, n0, _TR,
    0,
    [_rN, _sql, _d, _cAr, _act, _rD, _aISV, _eAr],
    [0, 0, 0, 4, () => ActionList, 2, 0, () => exports.Action$]
];
exports.TopicRuleDestination$ = [3, n0, _TRD,
    0,
    [_ar, _st, _cAr, _lUA, _sRt, _hUP, _vP],
    [0, 0, 4, 4, 0, () => exports.HttpUrlDestinationProperties$, () => exports.VpcDestinationProperties$]
];
exports.TopicRuleDestinationConfiguration$ = [3, n0, _TRDC,
    0,
    [_hUC, _vCp],
    [() => exports.HttpUrlDestinationConfiguration$, () => exports.VpcDestinationConfiguration$]
];
exports.TopicRuleDestinationSummary$ = [3, n0, _TRDS,
    0,
    [_ar, _st, _cAr, _lUA, _sRt, _hUS, _vDS],
    [0, 0, 4, 4, 0, () => exports.HttpUrlDestinationSummary$, () => exports.VpcDestinationSummary$]
];
exports.TopicRuleListItem$ = [3, n0, _TRLI,
    0,
    [_rAu, _rN, _tPo, _cAr, _rD],
    [0, 0, 0, 4, 2]
];
exports.TopicRulePayload$ = [3, n0, _TRP,
    0,
    [_sql, _act, _d, _rD, _aISV, _eAr],
    [0, () => ActionList, 0, 2, 0, () => exports.Action$], 2
];
exports.TransferCertificateRequest$ = [3, n0, _TCR,
    0,
    [_cI, _tAA, _tM],
    [[0, 1], [0, { [_hQ]: _tAA }], 0], 2
];
exports.TransferCertificateResponse$ = [3, n0, _TCRr,
    0,
    [_tCA],
    [0]
];
exports.TransferData$ = [3, n0, _TDr,
    0,
    [_tM, _rRe, _tDr, _aDcc, _rDej],
    [0, 0, 4, 4, 4]
];
exports.UntagResourceRequest$ = [3, n0, _URR,
    0,
    [_rA, _tK],
    [0, 64 | 0], 2
];
exports.UntagResourceResponse$ = [3, n0, _URRn,
    0,
    [],
    []
];
exports.UpdateAccountAuditConfigurationRequest$ = [3, n0, _UAACR,
    0,
    [_rAo, _aNTC, _aCC],
    [0, () => AuditNotificationTargetConfigurations, () => AuditCheckConfigurations]
];
exports.UpdateAccountAuditConfigurationResponse$ = [3, n0, _UAACRp,
    0,
    [],
    []
];
exports.UpdateAuditSuppressionRequest$ = [3, n0, _UASR,
    0,
    [_cN, _rIe, _eD, _sI, _d],
    [0, () => exports.ResourceIdentifier$, 4, 2, 0], 2
];
exports.UpdateAuditSuppressionResponse$ = [3, n0, _UASRp,
    0,
    [],
    []
];
exports.UpdateAuthorizerRequest$ = [3, n0, _UAR,
    0,
    [_aNu, _aFA, _tKN, _tSPK, _st, _eCFH],
    [[0, 1], 0, 0, 128 | 0, 0, 2], 1
];
exports.UpdateAuthorizerResponse$ = [3, n0, _UARp,
    0,
    [_aNu, _aA],
    [0, 0]
];
exports.UpdateBillingGroupRequest$ = [3, n0, _UBGR,
    0,
    [_bGN, _bGP, _eV],
    [[0, 1], () => exports.BillingGroupProperties$, 1], 2
];
exports.UpdateBillingGroupResponse$ = [3, n0, _UBGRp,
    0,
    [_ve],
    [1]
];
exports.UpdateCACertificateParams$ = [3, n0, _UCACP,
    0,
    [_a],
    [0], 1
];
exports.UpdateCACertificateRequest$ = [3, n0, _UCACR,
    0,
    [_cI, _nS, _nARS, _rCe, _rAR],
    [[0, 1], [0, { [_hQ]: _nS }], [0, { [_hQ]: _nARS }], () => exports.RegistrationConfig$, 2], 1
];
exports.UpdateCertificateProviderRequest$ = [3, n0, _UCPR,
    0,
    [_cPN, _lFA, _aDFO],
    [[0, 1], 0, 64 | 0], 1
];
exports.UpdateCertificateProviderResponse$ = [3, n0, _UCPRp,
    0,
    [_cPN, _cPA],
    [0, 0]
];
exports.UpdateCertificateRequest$ = [3, n0, _UCR,
    0,
    [_cI, _nS],
    [[0, 1], [0, { [_hQ]: _nS }]], 2
];
exports.UpdateCommandRequest$ = [3, n0, _UCRp,
    0,
    [_cIo, _dN, _d, _dep],
    [[0, 1], 0, 0, 2], 1
];
exports.UpdateCommandResponse$ = [3, n0, _UCRpd,
    0,
    [_cIo, _dN, _d, _dep, _lUA],
    [0, 0, 0, 2, 4]
];
exports.UpdateCustomMetricRequest$ = [3, n0, _UCMR,
    0,
    [_mNe, _dN],
    [[0, 1], 0], 2
];
exports.UpdateCustomMetricResponse$ = [3, n0, _UCMRp,
    0,
    [_mNe, _mA, _mTe, _dN, _cD, _lMD],
    [0, 0, 0, 0, 4, 4]
];
exports.UpdateDeviceCertificateParams$ = [3, n0, _UDCP,
    0,
    [_a],
    [0], 1
];
exports.UpdateDimensionRequest$ = [3, n0, _UDR,
    0,
    [_n, _sVt],
    [[0, 1], 64 | 0], 2
];
exports.UpdateDimensionResponse$ = [3, n0, _UDRp,
    0,
    [_n, _ar, _ty, _sVt, _cD, _lMD],
    [0, 0, 0, 64 | 0, 4, 4]
];
exports.UpdateDomainConfigurationRequest$ = [3, n0, _UDCR,
    0,
    [_dCN, _aC, _dCS, _rAC, _tC, _sCC, _aTu, _aP, _cCC],
    [[0, 1], () => exports.AuthorizerConfig$, 0, 2, () => exports.TlsConfig$, () => exports.ServerCertificateConfig$, 0, 0, () => exports.ClientCertificateConfig$], 1
];
exports.UpdateDomainConfigurationResponse$ = [3, n0, _UDCRp,
    0,
    [_dCN, _dCA],
    [0, 0]
];
exports.UpdateDynamicThingGroupRequest$ = [3, n0, _UDTGR,
    0,
    [_tGNh, _tGP, _eV, _iN, _qS, _qV],
    [[0, 1], () => exports.ThingGroupProperties$, 1, 0, 0, 0], 2
];
exports.UpdateDynamicThingGroupResponse$ = [3, n0, _UDTGRp,
    0,
    [_ve],
    [1]
];
exports.UpdateEncryptionConfigurationRequest$ = [3, n0, _UECR,
    0,
    [_eTn, _kKA, _kARA],
    [0, 0, 0], 1
];
exports.UpdateEncryptionConfigurationResponse$ = [3, n0, _UECRp,
    0,
    [],
    []
];
exports.UpdateEventConfigurationsRequest$ = [3, n0, _UECRpd,
    0,
    [_eCv],
    [() => EventConfigurations]
];
exports.UpdateEventConfigurationsResponse$ = [3, n0, _UECRpda,
    0,
    [],
    []
];
exports.UpdateFleetMetricRequest$ = [3, n0, _UFMR,
    0,
    [_mNe, _iN, _qS, _aTg, _pe, _aF, _d, _qV, _u, _eV],
    [[0, 1], 0, 0, () => exports.AggregationType$, 1, 0, 0, 0, 0, 1], 2
];
exports.UpdateIndexingConfigurationRequest$ = [3, n0, _UICR,
    0,
    [_tIC, _tGIC],
    [() => exports.ThingIndexingConfiguration$, () => exports.ThingGroupIndexingConfiguration$]
];
exports.UpdateIndexingConfigurationResponse$ = [3, n0, _UICRp,
    0,
    [],
    []
];
exports.UpdateJobRequest$ = [3, n0, _UJR,
    0,
    [_jI, _d, _pUC, _jERC, _aCb, _tCi, _nI, _jERCo],
    [[0, 1], 0, () => exports.PresignedUrlConfig$, () => exports.JobExecutionsRolloutConfig$, () => exports.AbortConfig$, () => exports.TimeoutConfig$, [0, { [_hQ]: _nI }], () => exports.JobExecutionsRetryConfig$], 1
];
exports.UpdateMitigationActionRequest$ = [3, n0, _UMAR,
    0,
    [_aN, _rAo, _aPc],
    [[0, 1], 0, () => exports.MitigationActionParams$], 1
];
exports.UpdateMitigationActionResponse$ = [3, n0, _UMARp,
    0,
    [_aAc, _aI],
    [0, 0]
];
exports.UpdatePackageConfigurationRequest$ = [3, n0, _UPCR,
    0,
    [_vUBJC, _cT],
    [() => exports.VersionUpdateByJobsConfig$, [0, { [_hQ]: _cT, [_iT]: 1 }]]
];
exports.UpdatePackageConfigurationResponse$ = [3, n0, _UPCRp,
    0,
    [],
    []
];
exports.UpdatePackageRequest$ = [3, n0, _UPR,
    0,
    [_pN, _d, _dVN, _uDV, _cT],
    [[0, 1], [() => ResourceDescription, 0], 0, 2, [0, { [_hQ]: _cT, [_iT]: 1 }]], 1
];
exports.UpdatePackageResponse$ = [3, n0, _UPRp,
    0,
    [],
    []
];
exports.UpdatePackageVersionRequest$ = [3, n0, _UPVR,
    0,
    [_pN, _vN, _d, _at, _art, _a, _rec, _cT],
    [[0, 1], [0, 1], [() => ResourceDescription, 0], [() => ResourceAttributes, 0], () => exports.PackageVersionArtifact$, 0, [() => PackageVersionRecipe, 0], [0, { [_hQ]: _cT, [_iT]: 1 }]], 2
];
exports.UpdatePackageVersionResponse$ = [3, n0, _UPVRp,
    0,
    [],
    []
];
exports.UpdateProvisioningTemplateRequest$ = [3, n0, _UPTR,
    0,
    [_tNe, _d, _en, _dVI, _pRA, _pPH, _rPPH],
    [[0, 1], 0, 2, 1, 0, () => exports.ProvisioningHook$, 2], 1
];
exports.UpdateProvisioningTemplateResponse$ = [3, n0, _UPTRp,
    0,
    [],
    []
];
exports.UpdateRoleAliasRequest$ = [3, n0, _URAR,
    0,
    [_rAol, _rAo, _cDS],
    [[0, 1], 0, 1], 1
];
exports.UpdateRoleAliasResponse$ = [3, n0, _URARp,
    0,
    [_rAol, _rAA],
    [0, 0]
];
exports.UpdateScheduledAuditRequest$ = [3, n0, _USAR,
    0,
    [_sAN, _fr, _dOM, _dOW, _tCN],
    [[0, 1], 0, 0, 0, 64 | 0], 1
];
exports.UpdateScheduledAuditResponse$ = [3, n0, _USARp,
    0,
    [_sAAc],
    [0]
];
exports.UpdateSecurityProfileRequest$ = [3, n0, _USPR,
    0,
    [_sPN, _sPD, _be, _aTl, _aMTR, _aMTRV, _dB, _dAT, _dAMTR, _eV, _mEC, _dMEC],
    [[0, 1], 0, () => Behaviors, () => AlertTargets, 64 | 0, () => AdditionalMetricsToRetainV2List, 2, 2, 2, [1, { [_hQ]: _eV }], () => exports.MetricsExportConfig$, 2], 1
];
exports.UpdateSecurityProfileResponse$ = [3, n0, _USPRp,
    0,
    [_sPN, _sPA, _sPD, _be, _aTl, _aMTR, _aMTRV, _ve, _cD, _lMD, _mEC],
    [0, 0, 0, () => Behaviors, () => AlertTargets, 64 | 0, () => AdditionalMetricsToRetainV2List, 1, 4, 4, () => exports.MetricsExportConfig$]
];
exports.UpdateStreamRequest$ = [3, n0, _USR,
    0,
    [_sIt, _d, _fi, _rAo],
    [[0, 1], 0, () => StreamFiles, 0], 1
];
exports.UpdateStreamResponse$ = [3, n0, _USRp,
    0,
    [_sIt, _sAtr, _d, _sVtr],
    [0, 0, 0, 1]
];
exports.UpdateThingGroupRequest$ = [3, n0, _UTGR,
    0,
    [_tGNh, _tGP, _eV],
    [[0, 1], () => exports.ThingGroupProperties$, 1], 2
];
exports.UpdateThingGroupResponse$ = [3, n0, _UTGRp,
    0,
    [_ve],
    [1]
];
exports.UpdateThingGroupsForThingRequest$ = [3, n0, _UTGFTR,
    0,
    [_tN, _tGTA, _tGTR, _oDG],
    [0, 64 | 0, 64 | 0, 2]
];
exports.UpdateThingGroupsForThingResponse$ = [3, n0, _UTGFTRp,
    0,
    [],
    []
];
exports.UpdateThingRequest$ = [3, n0, _UTR,
    0,
    [_tN, _tTN, _aPt, _eV, _rTT],
    [[0, 1], 0, () => exports.AttributePayload$, 1, 2], 1
];
exports.UpdateThingResponse$ = [3, n0, _UTRp,
    0,
    [],
    []
];
exports.UpdateThingTypeRequest$ = [3, n0, _UTTR,
    0,
    [_tTN, _tTP],
    [[0, 1], () => exports.ThingTypeProperties$], 1
];
exports.UpdateThingTypeResponse$ = [3, n0, _UTTRp,
    0,
    [],
    []
];
exports.UpdateTopicRuleDestinationRequest$ = [3, n0, _UTRDR,
    0,
    [_ar, _st],
    [0, 0], 2
];
exports.UpdateTopicRuleDestinationResponse$ = [3, n0, _UTRDRp,
    0,
    [],
    []
];
exports.UserProperty$ = [3, n0, _UP,
    0,
    [_ke, _va],
    [0, 0], 2
];
exports.ValidateSecurityProfileBehaviorsRequest$ = [3, n0, _VSPBR,
    0,
    [_be],
    [() => Behaviors], 1
];
exports.ValidateSecurityProfileBehaviorsResponse$ = [3, n0, _VSPBRa,
    0,
    [_vali, _vEa],
    [2, () => ValidationErrors]
];
exports.ValidationError$ = [3, n0, _VEa,
    0,
    [_eMr],
    [0]
];
exports.VersionUpdateByJobsConfig$ = [3, n0, _VUBJC,
    0,
    [_en, _rAo],
    [2, 0]
];
exports.ViolationEvent$ = [3, n0, _VEi,
    0,
    [_vI, _tN, _sPN, _b, _mV, _vEAI, _vET, _vS, _vSD, _vETi],
    [0, 0, 0, () => exports.Behavior$, () => exports.MetricValue$, () => exports.ViolationEventAdditionalInfo$, 0, 0, 0, 4]
];
exports.ViolationEventAdditionalInfo$ = [3, n0, _VEAI,
    0,
    [_cLo],
    [0]
];
exports.ViolationEventOccurrenceRange$ = [3, n0, _VEOR,
    0,
    [_sT, _eT],
    [4, 4], 2
];
exports.VpcDestinationConfiguration$ = [3, n0, _VDC,
    0,
    [_sIu, _vIp, _rAo, _sG],
    [64 | 0, 0, 0, 64 | 0], 3
];
exports.VpcDestinationProperties$ = [3, n0, _VDP,
    0,
    [_sIu, _sG, _vIp, _rAo],
    [64 | 0, 64 | 0, 0, 0]
];
exports.VpcDestinationSummary$ = [3, n0, _VDS,
    0,
    [_sIu, _sG, _vIp, _rAo],
    [64 | 0, 64 | 0, 0, 0]
];
var __Unit = "unit";
var AbortCriteriaList = [1, n0, _ACL,
    0, () => exports.AbortCriteria$
];
var ActionList = [1, n0, _AL,
    0, () => exports.Action$
];
var ActiveViolations = [1, n0, _AVc,
    0, () => exports.ActiveViolation$
];
var AdditionalMetricsToRetainList = 64 | 0;
var AdditionalMetricsToRetainV2List = [1, n0, _AMTRVL,
    0, () => exports.MetricToRetain$
];
var AggregationTypeValues = 64 | 0;
var AssetPropertyValueList = [1, n0, _APVL,
    0, () => exports.AssetPropertyValue$
];
var AuditFindings = [1, n0, _AFu,
    0, () => exports.AuditFinding$
];
var AuditMitigationActionExecutionMetadataList = [1, n0, _AMAEML,
    0, () => exports.AuditMitigationActionExecutionMetadata$
];
var AuditMitigationActionsTaskMetadataList = [1, n0, _AMATML,
    0, () => exports.AuditMitigationActionsTaskMetadata$
];
var AuditSuppressionList = [1, n0, _ASL,
    0, () => exports.AuditSuppression$
];
var AuditTaskMetadataList = [1, n0, _ATML,
    0, () => exports.AuditTaskMetadata$
];
var AuthInfos = [1, n0, _AIu,
    0, () => exports.AuthInfo$
];
var Authorizers = [1, n0, _Au,
    0, () => exports.AuthorizerSummary$
];
var AuthResults = [1, n0, _ARu,
    0, () => exports.AuthResult$
];
var AwsJobAbortCriteriaList = [1, n0, _AJACL,
    0, () => exports.AwsJobAbortCriteria$
];
var BehaviorModelTrainingSummaries = [1, n0, _BMTSe,
    0, () => exports.BehaviorModelTrainingSummary$
];
var Behaviors = [1, n0, _Be,
    0, () => exports.Behavior$
];
var BillingGroupNameAndArnList = [1, n0, _BGNAAL,
    0, () => exports.GroupNameAndArn$
];
var Buckets = [1, n0, _Buc,
    0, () => exports.Bucket$
];
var CACertificates = [1, n0, _CACe,
    0, () => exports.CACertificate$
];
var CertificateProviderAccountDefaultForOperations = 64 | 0;
var CertificateProviders = [1, n0, _CPe,
    0, () => exports.CertificateProviderSummary$
];
var Certificates = [1, n0, _Ce,
    0, () => exports.Certificate$
];
var Cidrs = 64 | 0;
var CommandExecutionSummaryList = [1, n0, _CESL,
    0, () => exports.CommandExecutionSummary$
];
var CommandParameterList = [1, n0, _CPL,
    0, () => exports.CommandParameter$
];
var CommandParameterValueConditionList = [1, n0, _CPVCL,
    0, () => exports.CommandParameterValueCondition$
];
var CommandParameterValueStringList = 64 | 0;
var CommandSummaryList = [1, n0, _CSL,
    0, () => exports.CommandSummary$
];
var DestinationPackageVersions = 64 | 0;
var DetectMitigationActionExecutionList = [1, n0, _DMAEL,
    0, () => exports.DetectMitigationActionExecution$
];
var DetectMitigationActionsTaskSummaryList = [1, n0, _DMATSL,
    0, () => exports.DetectMitigationActionsTaskSummary$
];
var DetectMitigationActionsToExecuteList = 64 | 0;
var DimensionNames = 64 | 0;
var DimensionStringValues = 64 | 0;
var DocumentParameters = [1, n0, _DPo,
    0, () => exports.DocumentParameter$
];
var DomainConfigurations = [1, n0, _DC,
    0, () => exports.DomainConfigurationSummary$
];
var EffectivePolicies = [1, n0, _EPf,
    0, () => exports.EffectivePolicy$
];
var Environments = 64 | 0;
var Fields = [1, n0, _Fi,
    0, () => exports.Field$
];
var FindingIds = 64 | 0;
var FleetMetricNameAndArnList = [1, n0, _FMNAAL,
    0, () => exports.FleetMetricNameAndArn$
];
var GeoLocationsFilter = [1, n0, _GLF,
    0, () => exports.GeoLocationTarget$
];
var HeaderList = [1, n0, _HL,
    0, () => exports.HttpActionHeader$
];
var IndexNamesList = 64 | 0;
var JobExecutionSummaryForJobList = [1, n0, _JESFJL,
    0, () => exports.JobExecutionSummaryForJob$
];
var JobExecutionSummaryForThingList = [1, n0, _JESFTL,
    0, () => exports.JobExecutionSummaryForThing$
];
var JobSummaryList = [1, n0, _JSL,
    0, () => exports.JobSummary$
];
var JobTargets = 64 | 0;
var JobTemplateSummaryList = [1, n0, _JTSL,
    0, () => exports.JobTemplateSummary$
];
var KafkaHeaders = [1, n0, _KH,
    0, () => exports.KafkaActionHeader$
];
var LogEventConfigurations = [1, n0, _LECo,
    0, () => exports.LogEventConfiguration$
];
var LogTargetConfigurations = [1, n0, _LTCo,
    0, () => exports.LogTargetConfiguration$
];
var MaintenanceWindows = [1, n0, _MWa,
    0, () => exports.MaintenanceWindow$
];
var ManagedJobTemplatesSummaryList = [1, n0, _MJTSL,
    0, () => exports.ManagedJobTemplateSummary$
];
var MetricDatumList = [1, n0, _MDL,
    0, () => exports.MetricDatum$
];
var MetricNames = 64 | 0;
var MissingContextValues = 64 | 0;
var MitigationActionIdentifierList = [1, n0, _MAIL,
    0, () => exports.MitigationActionIdentifier$
];
var MitigationActionList = [1, n0, _MAL,
    0, () => exports.MitigationAction$
];
var MitigationActionNameList = 64 | 0;
var NamedShadowNamesFilter = 64 | 0;
var NumberList = 64 | 1;
var OTAUpdateFiles = [1, n0, _OTAUFp,
    0, () => exports.OTAUpdateFile$
];
var OTAUpdatesSummary = [1, n0, _OTAUSp,
    0, () => exports.OTAUpdateSummary$
];
var OutgoingCertificates = [1, n0, _OCu,
    0, () => exports.OutgoingCertificate$
];
var PackageSummaryList = [1, n0, _PSL,
    0, () => exports.PackageSummary$
];
var PackageVersionSummaryList = [1, n0, _PVSL,
    0, () => exports.PackageVersionSummary$
];
var Percentiles = [1, n0, _Pe,
    0, () => exports.PercentPair$
];
var PercentList = 64 | 1;
var Policies = [1, n0, _Po,
    0, () => exports.Policy$
];
var PolicyDocuments = 64 | 0;
var PolicyNames = 64 | 0;
var PolicyTargets = 64 | 0;
var PolicyVersions = [1, n0, _PVo,
    0, () => exports.PolicyVersion$
];
var Ports = 64 | 1;
var Principals = 64 | 0;
var PrincipalThingObjects = [1, n0, _PTOr,
    0, () => exports.PrincipalThingObject$
];
var ProcessingTargetNameList = 64 | 0;
var PropagatingAttributeList = [1, n0, _PAL,
    0, () => exports.PropagatingAttribute$
];
var Protocols = 64 | 0;
var ProvisioningTemplateListing = [1, n0, _PTL,
    0, () => exports.ProvisioningTemplateSummary$
];
var ProvisioningTemplateVersionListing = [1, n0, _PTVL,
    0, () => exports.ProvisioningTemplateVersionSummary$
];
var PutAssetPropertyValueEntryList = [1, n0, _PAPVEL,
    0, () => exports.PutAssetPropertyValueEntry$
];
var ReasonForNonComplianceCodes = 64 | 0;
var RelatedResources = [1, n0, _RRe,
    0, () => exports.RelatedResource$
];
var Resources = 64 | 0;
var RetryCriteriaList = [1, n0, _RCL,
    0, () => exports.RetryCriteria$
];
var RoleAliases = 64 | 0;
var S3FileUrlList = 64 | 0;
var SbomValidationResultSummaryList = [1, n0, _SVRSL,
    0, () => exports.SbomValidationResultSummary$
];
var ScheduledAuditMetadataList = [1, n0, _SAML,
    0, () => exports.ScheduledAuditMetadata$
];
var ScheduledJobRolloutList = [1, n0, _SJRL,
    0, () => exports.ScheduledJobRollout$
];
var SearchableAttributes = 64 | 0;
var SecurityGroupList = 64 | 0;
var SecurityProfileIdentifiers = [1, n0, _SPIe,
    0, () => exports.SecurityProfileIdentifier$
];
var SecurityProfileTargetMappings = [1, n0, _SPTMe,
    0, () => exports.SecurityProfileTargetMapping$
];
var SecurityProfileTargets = [1, n0, _SPTe,
    0, () => exports.SecurityProfileTarget$
];
var ServerCertificateArns = 64 | 0;
var ServerCertificates = [1, n0, _SCe,
    0, () => exports.ServerCertificateSummary$
];
var StreamFiles = [1, n0, _SFt,
    0, () => exports.StreamFile$
];
var StreamsSummary = [1, n0, _SSt,
    0, () => exports.StreamSummary$
];
var StringList = 64 | 0;
var SubnetIdList = 64 | 0;
var TagKeyList = 64 | 0;
var TagList = [1, n0, _TL,
    0, () => exports.Tag$
];
var TargetAuditCheckNames = 64 | 0;
var Targets = 64 | 0;
var TargetViolationIdsForDetectMitigationActions = 64 | 0;
var TaskIdList = 64 | 0;
var ThingAttributeList = [1, n0, _TAL,
    0, () => exports.ThingAttribute$
];
var ThingDocumentList = [1, n0, _TDL,
    0, () => exports.ThingDocument$
];
var ThingGroupDocumentList = [1, n0, _TGDL,
    0, () => exports.ThingGroupDocument$
];
var ThingGroupList = 64 | 0;
var ThingGroupNameAndArnList = [1, n0, _TGNAAL,
    0, () => exports.GroupNameAndArn$
];
var ThingGroupNameList = 64 | 0;
var ThingGroupNames = 64 | 0;
var ThingNameList = 64 | 0;
var ThingPrincipalObjects = [1, n0, _TPOh,
    0, () => exports.ThingPrincipalObject$
];
var ThingTypeList = [1, n0, _TTL,
    0, () => exports.ThingTypeDefinition$
];
var TimestreamDimensionList = [1, n0, _TDLi,
    0, () => exports.TimestreamDimension$
];
var TopicRuleDestinationSummaries = [1, n0, _TRDSo,
    0, () => exports.TopicRuleDestinationSummary$
];
var TopicRuleList = [1, n0, _TRL,
    0, () => exports.TopicRuleListItem$
];
var UserProperties = [1, n0, _UPs,
    0, () => exports.UserProperty$
];
var ValidationErrors = [1, n0, _VEal,
    0, () => exports.ValidationError$
];
var ViolationEvents = [1, n0, _VEio,
    0, () => exports.ViolationEvent$
];
var AdditionalParameterMap = 128 | 0;
var AlertTargets = [2, n0, _ATle,
    0, 0, () => exports.AlertTarget$
];
var Attributes = 128 | 0;
var AttributesMap = 128 | 0;
var AuditCheckConfigurations = [2, n0, _ACCu,
    0, 0, () => exports.AuditCheckConfiguration$
];
var AuditCheckToActionsMapping = [2, n0, _ACTAM,
    0, 0, 64 | 0
];
var AuditCheckToReasonCodeFilter = [2, n0, _ACTRCF,
    0, 0, 64 | 0
];
var AuditDetails = [2, n0, _ADu,
    0, 0, () => exports.AuditCheckDetails$
];
var AuditMitigationActionsTaskStatistics = [2, n0, _AMATS,
    0, 0, () => exports.TaskStatisticsForAuditCheck$
];
var AuditNotificationTargetConfigurations = [2, n0, _ANTC,
    0, 0, () => exports.AuditNotificationTarget$
];
var CheckCustomConfiguration = 128 | 0;
var ClientProperties = 128 | 0;
var CommandExecutionParameterMap = [2, n0, _CEPM,
    0, 0, () => exports.CommandParameterValue$
];
var CommandExecutionResultMap = [2, n0, _CERM,
    0, 0, () => exports.CommandExecutionResult$
];
var DetailsMap = 128 | 0;
var EventConfigurations = [2, n0, _EC,
    0, 0, () => exports.Configuration$
];
var HttpHeaders = 128 | 0;
var ParameterMap = 128 | 0;
var _Parameters = 128 | 0;
var PublicKeyMap = 128 | 0;
var ResourceArns = 128 | 0;
var ResourceAttributes = [2, n0, _RAe,
    8, 0, 0
];
var StringMap = 128 | 0;
var TagMap = 128 | 0;
exports.AssetPropertyVariant$ = [4, n0, _APVs,
    0,
    [_sVtri, _iV, _dVo, _bV],
    [0, 0, 0, 0]
];
exports.AcceptCertificateTransfer$ = [9, n0, _ACT,
    { [_h]: ["PATCH", "/accept-certificate-transfer/{certificateId}", 200] }, () => exports.AcceptCertificateTransferRequest$, () => __Unit
];
exports.AddThingToBillingGroup$ = [9, n0, _ATTBG,
    { [_h]: ["PUT", "/billing-groups/addThingToBillingGroup", 200] }, () => exports.AddThingToBillingGroupRequest$, () => exports.AddThingToBillingGroupResponse$
];
exports.AddThingToThingGroup$ = [9, n0, _ATTTG,
    { [_h]: ["PUT", "/thing-groups/addThingToThingGroup", 200] }, () => exports.AddThingToThingGroupRequest$, () => exports.AddThingToThingGroupResponse$
];
exports.AssociateSbomWithPackageVersion$ = [9, n0, _ASWPV,
    { [_h]: ["PUT", "/packages/{packageName}/versions/{versionName}/sbom", 200] }, () => exports.AssociateSbomWithPackageVersionRequest$, () => exports.AssociateSbomWithPackageVersionResponse$
];
exports.AssociateTargetsWithJob$ = [9, n0, _ATWJ,
    { [_h]: ["POST", "/jobs/{jobId}/targets", 200] }, () => exports.AssociateTargetsWithJobRequest$, () => exports.AssociateTargetsWithJobResponse$
];
exports.AttachPolicy$ = [9, n0, _APt,
    { [_h]: ["PUT", "/target-policies/{policyName}", 200] }, () => exports.AttachPolicyRequest$, () => __Unit
];
exports.AttachPrincipalPolicy$ = [9, n0, _APP,
    { [_h]: ["PUT", "/principal-policies/{policyName}", 200] }, () => exports.AttachPrincipalPolicyRequest$, () => __Unit
];
exports.AttachSecurityProfile$ = [9, n0, _ASP,
    { [_h]: ["PUT", "/security-profiles/{securityProfileName}/targets", 200] }, () => exports.AttachSecurityProfileRequest$, () => exports.AttachSecurityProfileResponse$
];
exports.AttachThingPrincipal$ = [9, n0, _ATP,
    { [_h]: ["PUT", "/things/{thingName}/principals", 200] }, () => exports.AttachThingPrincipalRequest$, () => exports.AttachThingPrincipalResponse$
];
exports.CancelAuditMitigationActionsTask$ = [9, n0, _CAMAT,
    { [_h]: ["PUT", "/audit/mitigationactions/tasks/{taskId}/cancel", 200] }, () => exports.CancelAuditMitigationActionsTaskRequest$, () => exports.CancelAuditMitigationActionsTaskResponse$
];
exports.CancelAuditTask$ = [9, n0, _CAT,
    { [_h]: ["PUT", "/audit/tasks/{taskId}/cancel", 200] }, () => exports.CancelAuditTaskRequest$, () => exports.CancelAuditTaskResponse$
];
exports.CancelCertificateTransfer$ = [9, n0, _CCT,
    { [_h]: ["PATCH", "/cancel-certificate-transfer/{certificateId}", 200] }, () => exports.CancelCertificateTransferRequest$, () => __Unit
];
exports.CancelDetectMitigationActionsTask$ = [9, n0, _CDMAT,
    { [_h]: ["PUT", "/detect/mitigationactions/tasks/{taskId}/cancel", 200] }, () => exports.CancelDetectMitigationActionsTaskRequest$, () => exports.CancelDetectMitigationActionsTaskResponse$
];
exports.CancelJob$ = [9, n0, _CJ,
    { [_h]: ["PUT", "/jobs/{jobId}/cancel", 200] }, () => exports.CancelJobRequest$, () => exports.CancelJobResponse$
];
exports.CancelJobExecution$ = [9, n0, _CJE,
    { [_h]: ["PUT", "/things/{thingName}/jobs/{jobId}/cancel", 200] }, () => exports.CancelJobExecutionRequest$, () => __Unit
];
exports.ClearDefaultAuthorizer$ = [9, n0, _CDA,
    { [_h]: ["DELETE", "/default-authorizer", 200] }, () => exports.ClearDefaultAuthorizerRequest$, () => exports.ClearDefaultAuthorizerResponse$
];
exports.ConfirmTopicRuleDestination$ = [9, n0, _CTRD,
    { [_h]: ["GET", "/confirmdestination/{confirmationToken+}", 200] }, () => exports.ConfirmTopicRuleDestinationRequest$, () => exports.ConfirmTopicRuleDestinationResponse$
];
exports.CreateAuditSuppression$ = [9, n0, _CAS,
    { [_h]: ["POST", "/audit/suppressions/create", 200] }, () => exports.CreateAuditSuppressionRequest$, () => exports.CreateAuditSuppressionResponse$
];
exports.CreateAuthorizer$ = [9, n0, _CA,
    { [_h]: ["POST", "/authorizer/{authorizerName}", 200] }, () => exports.CreateAuthorizerRequest$, () => exports.CreateAuthorizerResponse$
];
exports.CreateBillingGroup$ = [9, n0, _CBG,
    { [_h]: ["POST", "/billing-groups/{billingGroupName}", 200] }, () => exports.CreateBillingGroupRequest$, () => exports.CreateBillingGroupResponse$
];
exports.CreateCertificateFromCsr$ = [9, n0, _CCFC,
    { [_h]: ["POST", "/certificates", 200] }, () => exports.CreateCertificateFromCsrRequest$, () => exports.CreateCertificateFromCsrResponse$
];
exports.CreateCertificateProvider$ = [9, n0, _CCP,
    { [_h]: ["POST", "/certificate-providers/{certificateProviderName}", 200] }, () => exports.CreateCertificateProviderRequest$, () => exports.CreateCertificateProviderResponse$
];
exports.CreateCommand$ = [9, n0, _CC,
    { [_h]: ["PUT", "/commands/{commandId}", 200] }, () => exports.CreateCommandRequest$, () => exports.CreateCommandResponse$
];
exports.CreateCustomMetric$ = [9, n0, _CCM,
    { [_h]: ["POST", "/custom-metric/{metricName}", 200] }, () => exports.CreateCustomMetricRequest$, () => exports.CreateCustomMetricResponse$
];
exports.CreateDimension$ = [9, n0, _CDr,
    { [_h]: ["POST", "/dimensions/{name}", 200] }, () => exports.CreateDimensionRequest$, () => exports.CreateDimensionResponse$
];
exports.CreateDomainConfiguration$ = [9, n0, _CDC,
    { [_h]: ["POST", "/domainConfigurations/{domainConfigurationName}", 200] }, () => exports.CreateDomainConfigurationRequest$, () => exports.CreateDomainConfigurationResponse$
];
exports.CreateDynamicThingGroup$ = [9, n0, _CDTG,
    { [_h]: ["POST", "/dynamic-thing-groups/{thingGroupName}", 200] }, () => exports.CreateDynamicThingGroupRequest$, () => exports.CreateDynamicThingGroupResponse$
];
exports.CreateFleetMetric$ = [9, n0, _CFM,
    { [_h]: ["PUT", "/fleet-metric/{metricName}", 200] }, () => exports.CreateFleetMetricRequest$, () => exports.CreateFleetMetricResponse$
];
exports.CreateJob$ = [9, n0, _CJr,
    { [_h]: ["PUT", "/jobs/{jobId}", 200] }, () => exports.CreateJobRequest$, () => exports.CreateJobResponse$
];
exports.CreateJobTemplate$ = [9, n0, _CJT,
    { [_h]: ["PUT", "/job-templates/{jobTemplateId}", 200] }, () => exports.CreateJobTemplateRequest$, () => exports.CreateJobTemplateResponse$
];
exports.CreateKeysAndCertificate$ = [9, n0, _CKAC,
    { [_h]: ["POST", "/keys-and-certificate", 200] }, () => exports.CreateKeysAndCertificateRequest$, () => exports.CreateKeysAndCertificateResponse$
];
exports.CreateMitigationAction$ = [9, n0, _CMAr,
    { [_h]: ["POST", "/mitigationactions/actions/{actionName}", 200] }, () => exports.CreateMitigationActionRequest$, () => exports.CreateMitigationActionResponse$
];
exports.CreateOTAUpdate$ = [9, n0, _COTAU,
    { [_h]: ["POST", "/otaUpdates/{otaUpdateId}", 200] }, () => exports.CreateOTAUpdateRequest$, () => exports.CreateOTAUpdateResponse$
];
exports.CreatePackage$ = [9, n0, _CPr,
    { [_h]: ["PUT", "/packages/{packageName}", 200] }, () => exports.CreatePackageRequest$, () => exports.CreatePackageResponse$
];
exports.CreatePackageVersion$ = [9, n0, _CPVr,
    { [_h]: ["PUT", "/packages/{packageName}/versions/{versionName}", 200] }, () => exports.CreatePackageVersionRequest$, () => exports.CreatePackageVersionResponse$
];
exports.CreatePolicy$ = [9, n0, _CPre,
    { [_h]: ["POST", "/policies/{policyName}", 200] }, () => exports.CreatePolicyRequest$, () => exports.CreatePolicyResponse$
];
exports.CreatePolicyVersion$ = [9, n0, _CPVre,
    { [_h]: ["POST", "/policies/{policyName}/version", 200] }, () => exports.CreatePolicyVersionRequest$, () => exports.CreatePolicyVersionResponse$
];
exports.CreateProvisioningClaim$ = [9, n0, _CPC,
    { [_h]: ["POST", "/provisioning-templates/{templateName}/provisioning-claim", 200] }, () => exports.CreateProvisioningClaimRequest$, () => exports.CreateProvisioningClaimResponse$
];
exports.CreateProvisioningTemplate$ = [9, n0, _CPT,
    { [_h]: ["POST", "/provisioning-templates", 200] }, () => exports.CreateProvisioningTemplateRequest$, () => exports.CreateProvisioningTemplateResponse$
];
exports.CreateProvisioningTemplateVersion$ = [9, n0, _CPTV,
    { [_h]: ["POST", "/provisioning-templates/{templateName}/versions", 200] }, () => exports.CreateProvisioningTemplateVersionRequest$, () => exports.CreateProvisioningTemplateVersionResponse$
];
exports.CreateRoleAlias$ = [9, n0, _CRA,
    { [_h]: ["POST", "/role-aliases/{roleAlias}", 200] }, () => exports.CreateRoleAliasRequest$, () => exports.CreateRoleAliasResponse$
];
exports.CreateScheduledAudit$ = [9, n0, _CSA,
    { [_h]: ["POST", "/audit/scheduledaudits/{scheduledAuditName}", 200] }, () => exports.CreateScheduledAuditRequest$, () => exports.CreateScheduledAuditResponse$
];
exports.CreateSecurityProfile$ = [9, n0, _CSP,
    { [_h]: ["POST", "/security-profiles/{securityProfileName}", 200] }, () => exports.CreateSecurityProfileRequest$, () => exports.CreateSecurityProfileResponse$
];
exports.CreateStream$ = [9, n0, _CSr,
    { [_h]: ["POST", "/streams/{streamId}", 200] }, () => exports.CreateStreamRequest$, () => exports.CreateStreamResponse$
];
exports.CreateThing$ = [9, n0, _CT,
    { [_h]: ["POST", "/things/{thingName}", 200] }, () => exports.CreateThingRequest$, () => exports.CreateThingResponse$
];
exports.CreateThingGroup$ = [9, n0, _CTG,
    { [_h]: ["POST", "/thing-groups/{thingGroupName}", 200] }, () => exports.CreateThingGroupRequest$, () => exports.CreateThingGroupResponse$
];
exports.CreateThingType$ = [9, n0, _CTT,
    { [_h]: ["POST", "/thing-types/{thingTypeName}", 200] }, () => exports.CreateThingTypeRequest$, () => exports.CreateThingTypeResponse$
];
exports.CreateTopicRule$ = [9, n0, _CTRre,
    { [_h]: ["POST", "/rules/{ruleName}", 200] }, () => exports.CreateTopicRuleRequest$, () => __Unit
];
exports.CreateTopicRuleDestination$ = [9, n0, _CTRDr,
    { [_h]: ["POST", "/destinations", 200] }, () => exports.CreateTopicRuleDestinationRequest$, () => exports.CreateTopicRuleDestinationResponse$
];
exports.DeleteAccountAuditConfiguration$ = [9, n0, _DAAC,
    { [_h]: ["DELETE", "/audit/configuration", 200] }, () => exports.DeleteAccountAuditConfigurationRequest$, () => exports.DeleteAccountAuditConfigurationResponse$
];
exports.DeleteAuditSuppression$ = [9, n0, _DAS,
    { [_h]: ["POST", "/audit/suppressions/delete", 200] }, () => exports.DeleteAuditSuppressionRequest$, () => exports.DeleteAuditSuppressionResponse$
];
exports.DeleteAuthorizer$ = [9, n0, _DA,
    { [_h]: ["DELETE", "/authorizer/{authorizerName}", 200] }, () => exports.DeleteAuthorizerRequest$, () => exports.DeleteAuthorizerResponse$
];
exports.DeleteBillingGroup$ = [9, n0, _DBG,
    { [_h]: ["DELETE", "/billing-groups/{billingGroupName}", 200] }, () => exports.DeleteBillingGroupRequest$, () => exports.DeleteBillingGroupResponse$
];
exports.DeleteCACertificate$ = [9, n0, _DCAC,
    { [_h]: ["DELETE", "/cacertificate/{certificateId}", 200] }, () => exports.DeleteCACertificateRequest$, () => exports.DeleteCACertificateResponse$
];
exports.DeleteCertificate$ = [9, n0, _DCe,
    { [_h]: ["DELETE", "/certificates/{certificateId}", 200] }, () => exports.DeleteCertificateRequest$, () => __Unit
];
exports.DeleteCertificateProvider$ = [9, n0, _DCP,
    { [_h]: ["DELETE", "/certificate-providers/{certificateProviderName}", 200] }, () => exports.DeleteCertificateProviderRequest$, () => exports.DeleteCertificateProviderResponse$
];
exports.DeleteCommand$ = [9, n0, _DCel,
    { [_h]: ["DELETE", "/commands/{commandId}", 200] }, () => exports.DeleteCommandRequest$, () => exports.DeleteCommandResponse$
];
exports.DeleteCommandExecution$ = [9, n0, _DCEe,
    { [_h]: ["DELETE", "/command-executions/{executionId}", 200] }, () => exports.DeleteCommandExecutionRequest$, () => exports.DeleteCommandExecutionResponse$
];
exports.DeleteCustomMetric$ = [9, n0, _DCM,
    { [_h]: ["DELETE", "/custom-metric/{metricName}", 200] }, () => exports.DeleteCustomMetricRequest$, () => exports.DeleteCustomMetricResponse$
];
exports.DeleteDimension$ = [9, n0, _DD,
    { [_h]: ["DELETE", "/dimensions/{name}", 200] }, () => exports.DeleteDimensionRequest$, () => exports.DeleteDimensionResponse$
];
exports.DeleteDomainConfiguration$ = [9, n0, _DDC,
    { [_h]: ["DELETE", "/domainConfigurations/{domainConfigurationName}", 200] }, () => exports.DeleteDomainConfigurationRequest$, () => exports.DeleteDomainConfigurationResponse$
];
exports.DeleteDynamicThingGroup$ = [9, n0, _DDTG,
    { [_h]: ["DELETE", "/dynamic-thing-groups/{thingGroupName}", 200] }, () => exports.DeleteDynamicThingGroupRequest$, () => exports.DeleteDynamicThingGroupResponse$
];
exports.DeleteFleetMetric$ = [9, n0, _DFM,
    { [_h]: ["DELETE", "/fleet-metric/{metricName}", 200] }, () => exports.DeleteFleetMetricRequest$, () => __Unit
];
exports.DeleteJob$ = [9, n0, _DJ,
    { [_h]: ["DELETE", "/jobs/{jobId}", 200] }, () => exports.DeleteJobRequest$, () => __Unit
];
exports.DeleteJobExecution$ = [9, n0, _DJE,
    { [_h]: ["DELETE", "/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}", 200] }, () => exports.DeleteJobExecutionRequest$, () => __Unit
];
exports.DeleteJobTemplate$ = [9, n0, _DJT,
    { [_h]: ["DELETE", "/job-templates/{jobTemplateId}", 200] }, () => exports.DeleteJobTemplateRequest$, () => __Unit
];
exports.DeleteMitigationAction$ = [9, n0, _DMA,
    { [_h]: ["DELETE", "/mitigationactions/actions/{actionName}", 200] }, () => exports.DeleteMitigationActionRequest$, () => exports.DeleteMitigationActionResponse$
];
exports.DeleteOTAUpdate$ = [9, n0, _DOTAU,
    { [_h]: ["DELETE", "/otaUpdates/{otaUpdateId}", 200] }, () => exports.DeleteOTAUpdateRequest$, () => exports.DeleteOTAUpdateResponse$
];
exports.DeletePackage$ = [9, n0, _DPe,
    { [_h]: ["DELETE", "/packages/{packageName}", 200] }, () => exports.DeletePackageRequest$, () => exports.DeletePackageResponse$
];
exports.DeletePackageVersion$ = [9, n0, _DPV,
    { [_h]: ["DELETE", "/packages/{packageName}/versions/{versionName}", 200] }, () => exports.DeletePackageVersionRequest$, () => exports.DeletePackageVersionResponse$
];
exports.DeletePolicy$ = [9, n0, _DPel,
    { [_h]: ["DELETE", "/policies/{policyName}", 200] }, () => exports.DeletePolicyRequest$, () => __Unit
];
exports.DeletePolicyVersion$ = [9, n0, _DPVe,
    { [_h]: ["DELETE", "/policies/{policyName}/version/{policyVersionId}", 200] }, () => exports.DeletePolicyVersionRequest$, () => __Unit
];
exports.DeleteProvisioningTemplate$ = [9, n0, _DPT,
    { [_h]: ["DELETE", "/provisioning-templates/{templateName}", 200] }, () => exports.DeleteProvisioningTemplateRequest$, () => exports.DeleteProvisioningTemplateResponse$
];
exports.DeleteProvisioningTemplateVersion$ = [9, n0, _DPTV,
    { [_h]: ["DELETE", "/provisioning-templates/{templateName}/versions/{versionId}", 200] }, () => exports.DeleteProvisioningTemplateVersionRequest$, () => exports.DeleteProvisioningTemplateVersionResponse$
];
exports.DeleteRegistrationCode$ = [9, n0, _DRC,
    { [_h]: ["DELETE", "/registrationcode", 200] }, () => exports.DeleteRegistrationCodeRequest$, () => exports.DeleteRegistrationCodeResponse$
];
exports.DeleteRoleAlias$ = [9, n0, _DRA,
    { [_h]: ["DELETE", "/role-aliases/{roleAlias}", 200] }, () => exports.DeleteRoleAliasRequest$, () => exports.DeleteRoleAliasResponse$
];
exports.DeleteScheduledAudit$ = [9, n0, _DSA,
    { [_h]: ["DELETE", "/audit/scheduledaudits/{scheduledAuditName}", 200] }, () => exports.DeleteScheduledAuditRequest$, () => exports.DeleteScheduledAuditResponse$
];
exports.DeleteSecurityProfile$ = [9, n0, _DSP,
    { [_h]: ["DELETE", "/security-profiles/{securityProfileName}", 200] }, () => exports.DeleteSecurityProfileRequest$, () => exports.DeleteSecurityProfileResponse$
];
exports.DeleteStream$ = [9, n0, _DS,
    { [_h]: ["DELETE", "/streams/{streamId}", 200] }, () => exports.DeleteStreamRequest$, () => exports.DeleteStreamResponse$
];
exports.DeleteThing$ = [9, n0, _DT,
    { [_h]: ["DELETE", "/things/{thingName}", 200] }, () => exports.DeleteThingRequest$, () => exports.DeleteThingResponse$
];
exports.DeleteThingGroup$ = [9, n0, _DTG,
    { [_h]: ["DELETE", "/thing-groups/{thingGroupName}", 200] }, () => exports.DeleteThingGroupRequest$, () => exports.DeleteThingGroupResponse$
];
exports.DeleteThingType$ = [9, n0, _DTT,
    { [_h]: ["DELETE", "/thing-types/{thingTypeName}", 200] }, () => exports.DeleteThingTypeRequest$, () => exports.DeleteThingTypeResponse$
];
exports.DeleteTopicRule$ = [9, n0, _DTRel,
    { [_h]: ["DELETE", "/rules/{ruleName}", 200] }, () => exports.DeleteTopicRuleRequest$, () => __Unit
];
exports.DeleteTopicRuleDestination$ = [9, n0, _DTRD,
    { [_h]: ["DELETE", "/destinations/{arn+}", 200] }, () => exports.DeleteTopicRuleDestinationRequest$, () => exports.DeleteTopicRuleDestinationResponse$
];
exports.DeleteV2LoggingLevel$ = [9, n0, _DVLL,
    { [_h]: ["DELETE", "/v2LoggingLevel", 200] }, () => exports.DeleteV2LoggingLevelRequest$, () => __Unit
];
exports.DeprecateThingType$ = [9, n0, _DTTe,
    { [_h]: ["POST", "/thing-types/{thingTypeName}/deprecate", 200] }, () => exports.DeprecateThingTypeRequest$, () => exports.DeprecateThingTypeResponse$
];
exports.DescribeAccountAuditConfiguration$ = [9, n0, _DAACe,
    { [_h]: ["GET", "/audit/configuration", 200] }, () => exports.DescribeAccountAuditConfigurationRequest$, () => exports.DescribeAccountAuditConfigurationResponse$
];
exports.DescribeAuditFinding$ = [9, n0, _DAF,
    { [_h]: ["GET", "/audit/findings/{findingId}", 200] }, () => exports.DescribeAuditFindingRequest$, () => exports.DescribeAuditFindingResponse$
];
exports.DescribeAuditMitigationActionsTask$ = [9, n0, _DAMAT,
    { [_h]: ["GET", "/audit/mitigationactions/tasks/{taskId}", 200] }, () => exports.DescribeAuditMitigationActionsTaskRequest$, () => exports.DescribeAuditMitigationActionsTaskResponse$
];
exports.DescribeAuditSuppression$ = [9, n0, _DASe,
    { [_h]: ["POST", "/audit/suppressions/describe", 200] }, () => exports.DescribeAuditSuppressionRequest$, () => exports.DescribeAuditSuppressionResponse$
];
exports.DescribeAuditTask$ = [9, n0, _DAT,
    { [_h]: ["GET", "/audit/tasks/{taskId}", 200] }, () => exports.DescribeAuditTaskRequest$, () => exports.DescribeAuditTaskResponse$
];
exports.DescribeAuthorizer$ = [9, n0, _DAe,
    { [_h]: ["GET", "/authorizer/{authorizerName}", 200] }, () => exports.DescribeAuthorizerRequest$, () => exports.DescribeAuthorizerResponse$
];
exports.DescribeBillingGroup$ = [9, n0, _DBGe,
    { [_h]: ["GET", "/billing-groups/{billingGroupName}", 200] }, () => exports.DescribeBillingGroupRequest$, () => exports.DescribeBillingGroupResponse$
];
exports.DescribeCACertificate$ = [9, n0, _DCACe,
    { [_h]: ["GET", "/cacertificate/{certificateId}", 200] }, () => exports.DescribeCACertificateRequest$, () => exports.DescribeCACertificateResponse$
];
exports.DescribeCertificate$ = [9, n0, _DCes,
    { [_h]: ["GET", "/certificates/{certificateId}", 200] }, () => exports.DescribeCertificateRequest$, () => exports.DescribeCertificateResponse$
];
exports.DescribeCertificateProvider$ = [9, n0, _DCPe,
    { [_h]: ["GET", "/certificate-providers/{certificateProviderName}", 200] }, () => exports.DescribeCertificateProviderRequest$, () => exports.DescribeCertificateProviderResponse$
];
exports.DescribeCustomMetric$ = [9, n0, _DCMe,
    { [_h]: ["GET", "/custom-metric/{metricName}", 200] }, () => exports.DescribeCustomMetricRequest$, () => exports.DescribeCustomMetricResponse$
];
exports.DescribeDefaultAuthorizer$ = [9, n0, _DDA,
    { [_h]: ["GET", "/default-authorizer", 200] }, () => exports.DescribeDefaultAuthorizerRequest$, () => exports.DescribeDefaultAuthorizerResponse$
];
exports.DescribeDetectMitigationActionsTask$ = [9, n0, _DDMAT,
    { [_h]: ["GET", "/detect/mitigationactions/tasks/{taskId}", 200] }, () => exports.DescribeDetectMitigationActionsTaskRequest$, () => exports.DescribeDetectMitigationActionsTaskResponse$
];
exports.DescribeDimension$ = [9, n0, _DDe,
    { [_h]: ["GET", "/dimensions/{name}", 200] }, () => exports.DescribeDimensionRequest$, () => exports.DescribeDimensionResponse$
];
exports.DescribeDomainConfiguration$ = [9, n0, _DDCe,
    { [_h]: ["GET", "/domainConfigurations/{domainConfigurationName}", 200] }, () => exports.DescribeDomainConfigurationRequest$, () => exports.DescribeDomainConfigurationResponse$
];
exports.DescribeEncryptionConfiguration$ = [9, n0, _DEC,
    { [_h]: ["GET", "/encryption-configuration", 200] }, () => exports.DescribeEncryptionConfigurationRequest$, () => exports.DescribeEncryptionConfigurationResponse$
];
exports.DescribeEndpoint$ = [9, n0, _DE,
    { [_h]: ["GET", "/endpoint", 200] }, () => exports.DescribeEndpointRequest$, () => exports.DescribeEndpointResponse$
];
exports.DescribeEventConfigurations$ = [9, n0, _DECe,
    { [_h]: ["GET", "/event-configurations", 200] }, () => exports.DescribeEventConfigurationsRequest$, () => exports.DescribeEventConfigurationsResponse$
];
exports.DescribeFleetMetric$ = [9, n0, _DFMe,
    { [_h]: ["GET", "/fleet-metric/{metricName}", 200] }, () => exports.DescribeFleetMetricRequest$, () => exports.DescribeFleetMetricResponse$
];
exports.DescribeIndex$ = [9, n0, _DI,
    { [_h]: ["GET", "/indices/{indexName}", 200] }, () => exports.DescribeIndexRequest$, () => exports.DescribeIndexResponse$
];
exports.DescribeJob$ = [9, n0, _DJe,
    { [_h]: ["GET", "/jobs/{jobId}", 200] }, () => exports.DescribeJobRequest$, () => exports.DescribeJobResponse$
];
exports.DescribeJobExecution$ = [9, n0, _DJEe,
    { [_h]: ["GET", "/things/{thingName}/jobs/{jobId}", 200] }, () => exports.DescribeJobExecutionRequest$, () => exports.DescribeJobExecutionResponse$
];
exports.DescribeJobTemplate$ = [9, n0, _DJTe,
    { [_h]: ["GET", "/job-templates/{jobTemplateId}", 200] }, () => exports.DescribeJobTemplateRequest$, () => exports.DescribeJobTemplateResponse$
];
exports.DescribeManagedJobTemplate$ = [9, n0, _DMJT,
    { [_h]: ["GET", "/managed-job-templates/{templateName}", 200] }, () => exports.DescribeManagedJobTemplateRequest$, () => exports.DescribeManagedJobTemplateResponse$
];
exports.DescribeMitigationAction$ = [9, n0, _DMAe,
    { [_h]: ["GET", "/mitigationactions/actions/{actionName}", 200] }, () => exports.DescribeMitigationActionRequest$, () => exports.DescribeMitigationActionResponse$
];
exports.DescribeProvisioningTemplate$ = [9, n0, _DPTe,
    { [_h]: ["GET", "/provisioning-templates/{templateName}", 200] }, () => exports.DescribeProvisioningTemplateRequest$, () => exports.DescribeProvisioningTemplateResponse$
];
exports.DescribeProvisioningTemplateVersion$ = [9, n0, _DPTVe,
    { [_h]: ["GET", "/provisioning-templates/{templateName}/versions/{versionId}", 200] }, () => exports.DescribeProvisioningTemplateVersionRequest$, () => exports.DescribeProvisioningTemplateVersionResponse$
];
exports.DescribeRoleAlias$ = [9, n0, _DRAe,
    { [_h]: ["GET", "/role-aliases/{roleAlias}", 200] }, () => exports.DescribeRoleAliasRequest$, () => exports.DescribeRoleAliasResponse$
];
exports.DescribeScheduledAudit$ = [9, n0, _DSAe,
    { [_h]: ["GET", "/audit/scheduledaudits/{scheduledAuditName}", 200] }, () => exports.DescribeScheduledAuditRequest$, () => exports.DescribeScheduledAuditResponse$
];
exports.DescribeSecurityProfile$ = [9, n0, _DSPe,
    { [_h]: ["GET", "/security-profiles/{securityProfileName}", 200] }, () => exports.DescribeSecurityProfileRequest$, () => exports.DescribeSecurityProfileResponse$
];
exports.DescribeStream$ = [9, n0, _DSe,
    { [_h]: ["GET", "/streams/{streamId}", 200] }, () => exports.DescribeStreamRequest$, () => exports.DescribeStreamResponse$
];
exports.DescribeThing$ = [9, n0, _DTe,
    { [_h]: ["GET", "/things/{thingName}", 200] }, () => exports.DescribeThingRequest$, () => exports.DescribeThingResponse$
];
exports.DescribeThingGroup$ = [9, n0, _DTGe,
    { [_h]: ["GET", "/thing-groups/{thingGroupName}", 200] }, () => exports.DescribeThingGroupRequest$, () => exports.DescribeThingGroupResponse$
];
exports.DescribeThingRegistrationTask$ = [9, n0, _DTRT,
    { [_h]: ["GET", "/thing-registration-tasks/{taskId}", 200] }, () => exports.DescribeThingRegistrationTaskRequest$, () => exports.DescribeThingRegistrationTaskResponse$
];
exports.DescribeThingType$ = [9, n0, _DTTes,
    { [_h]: ["GET", "/thing-types/{thingTypeName}", 200] }, () => exports.DescribeThingTypeRequest$, () => exports.DescribeThingTypeResponse$
];
exports.DetachPolicy$ = [9, n0, _DPet,
    { [_h]: ["POST", "/target-policies/{policyName}", 200] }, () => exports.DetachPolicyRequest$, () => __Unit
];
exports.DetachPrincipalPolicy$ = [9, n0, _DPP,
    { [_h]: ["DELETE", "/principal-policies/{policyName}", 200] }, () => exports.DetachPrincipalPolicyRequest$, () => __Unit
];
exports.DetachSecurityProfile$ = [9, n0, _DSPet,
    { [_h]: ["DELETE", "/security-profiles/{securityProfileName}/targets", 200] }, () => exports.DetachSecurityProfileRequest$, () => exports.DetachSecurityProfileResponse$
];
exports.DetachThingPrincipal$ = [9, n0, _DTP,
    { [_h]: ["DELETE", "/things/{thingName}/principals", 200] }, () => exports.DetachThingPrincipalRequest$, () => exports.DetachThingPrincipalResponse$
];
exports.DisableTopicRule$ = [9, n0, _DTRi,
    { [_h]: ["POST", "/rules/{ruleName}/disable", 200] }, () => exports.DisableTopicRuleRequest$, () => __Unit
];
exports.DisassociateSbomFromPackageVersion$ = [9, n0, _DSFPV,
    { [_h]: ["DELETE", "/packages/{packageName}/versions/{versionName}/sbom", 200] }, () => exports.DisassociateSbomFromPackageVersionRequest$, () => exports.DisassociateSbomFromPackageVersionResponse$
];
exports.EnableTopicRule$ = [9, n0, _ETR,
    { [_h]: ["POST", "/rules/{ruleName}/enable", 200] }, () => exports.EnableTopicRuleRequest$, () => __Unit
];
exports.GetBehaviorModelTrainingSummaries$ = [9, n0, _GBMTS,
    { [_h]: ["GET", "/behavior-model-training/summaries", 200] }, () => exports.GetBehaviorModelTrainingSummariesRequest$, () => exports.GetBehaviorModelTrainingSummariesResponse$
];
exports.GetBucketsAggregation$ = [9, n0, _GBA,
    { [_h]: ["POST", "/indices/buckets", 200] }, () => exports.GetBucketsAggregationRequest$, () => exports.GetBucketsAggregationResponse$
];
exports.GetCardinality$ = [9, n0, _GC,
    { [_h]: ["POST", "/indices/cardinality", 200] }, () => exports.GetCardinalityRequest$, () => exports.GetCardinalityResponse$
];
exports.GetCommand$ = [9, n0, _GCe,
    { [_h]: ["GET", "/commands/{commandId}", 200] }, () => exports.GetCommandRequest$, () => exports.GetCommandResponse$
];
exports.GetCommandExecution$ = [9, n0, _GCE,
    { [_h]: ["GET", "/command-executions/{executionId}", 200] }, () => exports.GetCommandExecutionRequest$, () => exports.GetCommandExecutionResponse$
];
exports.GetEffectivePolicies$ = [9, n0, _GEP,
    { [_h]: ["POST", "/effective-policies", 200] }, () => exports.GetEffectivePoliciesRequest$, () => exports.GetEffectivePoliciesResponse$
];
exports.GetIndexingConfiguration$ = [9, n0, _GIC,
    { [_h]: ["GET", "/indexing/config", 200] }, () => exports.GetIndexingConfigurationRequest$, () => exports.GetIndexingConfigurationResponse$
];
exports.GetJobDocument$ = [9, n0, _GJD,
    { [_h]: ["GET", "/jobs/{jobId}/job-document", 200] }, () => exports.GetJobDocumentRequest$, () => exports.GetJobDocumentResponse$
];
exports.GetLoggingOptions$ = [9, n0, _GLO,
    { [_h]: ["GET", "/loggingOptions", 200] }, () => exports.GetLoggingOptionsRequest$, () => exports.GetLoggingOptionsResponse$
];
exports.GetOTAUpdate$ = [9, n0, _GOTAU,
    { [_h]: ["GET", "/otaUpdates/{otaUpdateId}", 200] }, () => exports.GetOTAUpdateRequest$, () => exports.GetOTAUpdateResponse$
];
exports.GetPackage$ = [9, n0, _GP,
    { [_h]: ["GET", "/packages/{packageName}", 200] }, () => exports.GetPackageRequest$, () => exports.GetPackageResponse$
];
exports.GetPackageConfiguration$ = [9, n0, _GPC,
    { [_h]: ["GET", "/package-configuration", 200] }, () => exports.GetPackageConfigurationRequest$, () => exports.GetPackageConfigurationResponse$
];
exports.GetPackageVersion$ = [9, n0, _GPV,
    { [_h]: ["GET", "/packages/{packageName}/versions/{versionName}", 200] }, () => exports.GetPackageVersionRequest$, () => exports.GetPackageVersionResponse$
];
exports.GetPercentiles$ = [9, n0, _GPe,
    { [_h]: ["POST", "/indices/percentiles", 200] }, () => exports.GetPercentilesRequest$, () => exports.GetPercentilesResponse$
];
exports.GetPolicy$ = [9, n0, _GPet,
    { [_h]: ["GET", "/policies/{policyName}", 200] }, () => exports.GetPolicyRequest$, () => exports.GetPolicyResponse$
];
exports.GetPolicyVersion$ = [9, n0, _GPVe,
    { [_h]: ["GET", "/policies/{policyName}/version/{policyVersionId}", 200] }, () => exports.GetPolicyVersionRequest$, () => exports.GetPolicyVersionResponse$
];
exports.GetRegistrationCode$ = [9, n0, _GRC,
    { [_h]: ["GET", "/registrationcode", 200] }, () => exports.GetRegistrationCodeRequest$, () => exports.GetRegistrationCodeResponse$
];
exports.GetStatistics$ = [9, n0, _GS,
    { [_h]: ["POST", "/indices/statistics", 200] }, () => exports.GetStatisticsRequest$, () => exports.GetStatisticsResponse$
];
exports.GetThingConnectivityData$ = [9, n0, _GTCD,
    { [_h]: ["POST", "/things/{thingName}/connectivity-data", 200] }, () => exports.GetThingConnectivityDataRequest$, () => exports.GetThingConnectivityDataResponse$
];
exports.GetTopicRule$ = [9, n0, _GTR,
    { [_h]: ["GET", "/rules/{ruleName}", 200] }, () => exports.GetTopicRuleRequest$, () => exports.GetTopicRuleResponse$
];
exports.GetTopicRuleDestination$ = [9, n0, _GTRD,
    { [_h]: ["GET", "/destinations/{arn+}", 200] }, () => exports.GetTopicRuleDestinationRequest$, () => exports.GetTopicRuleDestinationResponse$
];
exports.GetV2LoggingOptions$ = [9, n0, _GVLO,
    { [_h]: ["GET", "/v2LoggingOptions", 200] }, () => exports.GetV2LoggingOptionsRequest$, () => exports.GetV2LoggingOptionsResponse$
];
exports.ListActiveViolations$ = [9, n0, _LAV,
    { [_h]: ["GET", "/active-violations", 200] }, () => exports.ListActiveViolationsRequest$, () => exports.ListActiveViolationsResponse$
];
exports.ListAttachedPolicies$ = [9, n0, _LAP,
    { [_h]: ["POST", "/attached-policies/{target}", 200] }, () => exports.ListAttachedPoliciesRequest$, () => exports.ListAttachedPoliciesResponse$
];
exports.ListAuditFindings$ = [9, n0, _LAF,
    { [_h]: ["POST", "/audit/findings", 200] }, () => exports.ListAuditFindingsRequest$, () => exports.ListAuditFindingsResponse$
];
exports.ListAuditMitigationActionsExecutions$ = [9, n0, _LAMAE,
    { [_h]: ["GET", "/audit/mitigationactions/executions", 200] }, () => exports.ListAuditMitigationActionsExecutionsRequest$, () => exports.ListAuditMitigationActionsExecutionsResponse$
];
exports.ListAuditMitigationActionsTasks$ = [9, n0, _LAMAT,
    { [_h]: ["GET", "/audit/mitigationactions/tasks", 200] }, () => exports.ListAuditMitigationActionsTasksRequest$, () => exports.ListAuditMitigationActionsTasksResponse$
];
exports.ListAuditSuppressions$ = [9, n0, _LAS,
    { [_h]: ["POST", "/audit/suppressions/list", 200] }, () => exports.ListAuditSuppressionsRequest$, () => exports.ListAuditSuppressionsResponse$
];
exports.ListAuditTasks$ = [9, n0, _LAT,
    { [_h]: ["GET", "/audit/tasks", 200] }, () => exports.ListAuditTasksRequest$, () => exports.ListAuditTasksResponse$
];
exports.ListAuthorizers$ = [9, n0, _LAi,
    { [_h]: ["GET", "/authorizers", 200] }, () => exports.ListAuthorizersRequest$, () => exports.ListAuthorizersResponse$
];
exports.ListBillingGroups$ = [9, n0, _LBG,
    { [_h]: ["GET", "/billing-groups", 200] }, () => exports.ListBillingGroupsRequest$, () => exports.ListBillingGroupsResponse$
];
exports.ListCACertificates$ = [9, n0, _LCAC,
    { [_h]: ["GET", "/cacertificates", 200] }, () => exports.ListCACertificatesRequest$, () => exports.ListCACertificatesResponse$
];
exports.ListCertificateProviders$ = [9, n0, _LCP,
    { [_h]: ["GET", "/certificate-providers", 200] }, () => exports.ListCertificateProvidersRequest$, () => exports.ListCertificateProvidersResponse$
];
exports.ListCertificates$ = [9, n0, _LC,
    { [_h]: ["GET", "/certificates", 200] }, () => exports.ListCertificatesRequest$, () => exports.ListCertificatesResponse$
];
exports.ListCertificatesByCA$ = [9, n0, _LCBCA,
    { [_h]: ["GET", "/certificates-by-ca/{caCertificateId}", 200] }, () => exports.ListCertificatesByCARequest$, () => exports.ListCertificatesByCAResponse$
];
exports.ListCommandExecutions$ = [9, n0, _LCE,
    { [_h]: ["POST", "/command-executions", 200] }, () => exports.ListCommandExecutionsRequest$, () => exports.ListCommandExecutionsResponse$
];
exports.ListCommands$ = [9, n0, _LCi,
    { [_h]: ["GET", "/commands", 200] }, () => exports.ListCommandsRequest$, () => exports.ListCommandsResponse$
];
exports.ListCustomMetrics$ = [9, n0, _LCM,
    { [_h]: ["GET", "/custom-metrics", 200] }, () => exports.ListCustomMetricsRequest$, () => exports.ListCustomMetricsResponse$
];
exports.ListDetectMitigationActionsExecutions$ = [9, n0, _LDMAE,
    { [_h]: ["GET", "/detect/mitigationactions/executions", 200] }, () => exports.ListDetectMitigationActionsExecutionsRequest$, () => exports.ListDetectMitigationActionsExecutionsResponse$
];
exports.ListDetectMitigationActionsTasks$ = [9, n0, _LDMAT,
    { [_h]: ["GET", "/detect/mitigationactions/tasks", 200] }, () => exports.ListDetectMitigationActionsTasksRequest$, () => exports.ListDetectMitigationActionsTasksResponse$
];
exports.ListDimensions$ = [9, n0, _LD,
    { [_h]: ["GET", "/dimensions", 200] }, () => exports.ListDimensionsRequest$, () => exports.ListDimensionsResponse$
];
exports.ListDomainConfigurations$ = [9, n0, _LDC,
    { [_h]: ["GET", "/domainConfigurations", 200] }, () => exports.ListDomainConfigurationsRequest$, () => exports.ListDomainConfigurationsResponse$
];
exports.ListFleetMetrics$ = [9, n0, _LFM,
    { [_h]: ["GET", "/fleet-metrics", 200] }, () => exports.ListFleetMetricsRequest$, () => exports.ListFleetMetricsResponse$
];
exports.ListIndices$ = [9, n0, _LI,
    { [_h]: ["GET", "/indices", 200] }, () => exports.ListIndicesRequest$, () => exports.ListIndicesResponse$
];
exports.ListJobExecutionsForJob$ = [9, n0, _LJEFJ,
    { [_h]: ["GET", "/jobs/{jobId}/things", 200] }, () => exports.ListJobExecutionsForJobRequest$, () => exports.ListJobExecutionsForJobResponse$
];
exports.ListJobExecutionsForThing$ = [9, n0, _LJEFT,
    { [_h]: ["GET", "/things/{thingName}/jobs", 200] }, () => exports.ListJobExecutionsForThingRequest$, () => exports.ListJobExecutionsForThingResponse$
];
exports.ListJobs$ = [9, n0, _LJ,
    { [_h]: ["GET", "/jobs", 200] }, () => exports.ListJobsRequest$, () => exports.ListJobsResponse$
];
exports.ListJobTemplates$ = [9, n0, _LJT,
    { [_h]: ["GET", "/job-templates", 200] }, () => exports.ListJobTemplatesRequest$, () => exports.ListJobTemplatesResponse$
];
exports.ListManagedJobTemplates$ = [9, n0, _LMJT,
    { [_h]: ["GET", "/managed-job-templates", 200] }, () => exports.ListManagedJobTemplatesRequest$, () => exports.ListManagedJobTemplatesResponse$
];
exports.ListMetricValues$ = [9, n0, _LMV,
    { [_h]: ["GET", "/metric-values", 200] }, () => exports.ListMetricValuesRequest$, () => exports.ListMetricValuesResponse$
];
exports.ListMitigationActions$ = [9, n0, _LMA,
    { [_h]: ["GET", "/mitigationactions/actions", 200] }, () => exports.ListMitigationActionsRequest$, () => exports.ListMitigationActionsResponse$
];
exports.ListOTAUpdates$ = [9, n0, _LOTAU,
    { [_h]: ["GET", "/otaUpdates", 200] }, () => exports.ListOTAUpdatesRequest$, () => exports.ListOTAUpdatesResponse$
];
exports.ListOutgoingCertificates$ = [9, n0, _LOC,
    { [_h]: ["GET", "/certificates-out-going", 200] }, () => exports.ListOutgoingCertificatesRequest$, () => exports.ListOutgoingCertificatesResponse$
];
exports.ListPackages$ = [9, n0, _LP,
    { [_h]: ["GET", "/packages", 200] }, () => exports.ListPackagesRequest$, () => exports.ListPackagesResponse$
];
exports.ListPackageVersions$ = [9, n0, _LPV,
    { [_h]: ["GET", "/packages/{packageName}/versions", 200] }, () => exports.ListPackageVersionsRequest$, () => exports.ListPackageVersionsResponse$
];
exports.ListPolicies$ = [9, n0, _LPi,
    { [_h]: ["GET", "/policies", 200] }, () => exports.ListPoliciesRequest$, () => exports.ListPoliciesResponse$
];
exports.ListPolicyPrincipals$ = [9, n0, _LPP,
    { [_h]: ["GET", "/policy-principals", 200] }, () => exports.ListPolicyPrincipalsRequest$, () => exports.ListPolicyPrincipalsResponse$
];
exports.ListPolicyVersions$ = [9, n0, _LPVi,
    { [_h]: ["GET", "/policies/{policyName}/version", 200] }, () => exports.ListPolicyVersionsRequest$, () => exports.ListPolicyVersionsResponse$
];
exports.ListPrincipalPolicies$ = [9, n0, _LPPi,
    { [_h]: ["GET", "/principal-policies", 200] }, () => exports.ListPrincipalPoliciesRequest$, () => exports.ListPrincipalPoliciesResponse$
];
exports.ListPrincipalThings$ = [9, n0, _LPT,
    { [_h]: ["GET", "/principals/things", 200] }, () => exports.ListPrincipalThingsRequest$, () => exports.ListPrincipalThingsResponse$
];
exports.ListPrincipalThingsV2$ = [9, n0, _LPTV,
    { [_h]: ["GET", "/principals/things-v2", 200] }, () => exports.ListPrincipalThingsV2Request$, () => exports.ListPrincipalThingsV2Response$
];
exports.ListProvisioningTemplates$ = [9, n0, _LPTi,
    { [_h]: ["GET", "/provisioning-templates", 200] }, () => exports.ListProvisioningTemplatesRequest$, () => exports.ListProvisioningTemplatesResponse$
];
exports.ListProvisioningTemplateVersions$ = [9, n0, _LPTVi,
    { [_h]: ["GET", "/provisioning-templates/{templateName}/versions", 200] }, () => exports.ListProvisioningTemplateVersionsRequest$, () => exports.ListProvisioningTemplateVersionsResponse$
];
exports.ListRelatedResourcesForAuditFinding$ = [9, n0, _LRRFAF,
    { [_h]: ["GET", "/audit/relatedResources", 200] }, () => exports.ListRelatedResourcesForAuditFindingRequest$, () => exports.ListRelatedResourcesForAuditFindingResponse$
];
exports.ListRoleAliases$ = [9, n0, _LRA,
    { [_h]: ["GET", "/role-aliases", 200] }, () => exports.ListRoleAliasesRequest$, () => exports.ListRoleAliasesResponse$
];
exports.ListSbomValidationResults$ = [9, n0, _LSVR,
    { [_h]: ["GET", "/packages/{packageName}/versions/{versionName}/sbom-validation-results", 200] }, () => exports.ListSbomValidationResultsRequest$, () => exports.ListSbomValidationResultsResponse$
];
exports.ListScheduledAudits$ = [9, n0, _LSA,
    { [_h]: ["GET", "/audit/scheduledaudits", 200] }, () => exports.ListScheduledAuditsRequest$, () => exports.ListScheduledAuditsResponse$
];
exports.ListSecurityProfiles$ = [9, n0, _LSP,
    { [_h]: ["GET", "/security-profiles", 200] }, () => exports.ListSecurityProfilesRequest$, () => exports.ListSecurityProfilesResponse$
];
exports.ListSecurityProfilesForTarget$ = [9, n0, _LSPFT,
    { [_h]: ["GET", "/security-profiles-for-target", 200] }, () => exports.ListSecurityProfilesForTargetRequest$, () => exports.ListSecurityProfilesForTargetResponse$
];
exports.ListStreams$ = [9, n0, _LS,
    { [_h]: ["GET", "/streams", 200] }, () => exports.ListStreamsRequest$, () => exports.ListStreamsResponse$
];
exports.ListTagsForResource$ = [9, n0, _LTFR,
    { [_h]: ["GET", "/tags", 200] }, () => exports.ListTagsForResourceRequest$, () => exports.ListTagsForResourceResponse$
];
exports.ListTargetsForPolicy$ = [9, n0, _LTFP,
    { [_h]: ["POST", "/policy-targets/{policyName}", 200] }, () => exports.ListTargetsForPolicyRequest$, () => exports.ListTargetsForPolicyResponse$
];
exports.ListTargetsForSecurityProfile$ = [9, n0, _LTFSP,
    { [_h]: ["GET", "/security-profiles/{securityProfileName}/targets", 200] }, () => exports.ListTargetsForSecurityProfileRequest$, () => exports.ListTargetsForSecurityProfileResponse$
];
exports.ListThingGroups$ = [9, n0, _LTG,
    { [_h]: ["GET", "/thing-groups", 200] }, () => exports.ListThingGroupsRequest$, () => exports.ListThingGroupsResponse$
];
exports.ListThingGroupsForThing$ = [9, n0, _LTGFT,
    { [_h]: ["GET", "/things/{thingName}/thing-groups", 200] }, () => exports.ListThingGroupsForThingRequest$, () => exports.ListThingGroupsForThingResponse$
];
exports.ListThingPrincipals$ = [9, n0, _LTP,
    { [_h]: ["GET", "/things/{thingName}/principals", 200] }, () => exports.ListThingPrincipalsRequest$, () => exports.ListThingPrincipalsResponse$
];
exports.ListThingPrincipalsV2$ = [9, n0, _LTPV,
    { [_h]: ["GET", "/things/{thingName}/principals-v2", 200] }, () => exports.ListThingPrincipalsV2Request$, () => exports.ListThingPrincipalsV2Response$
];
exports.ListThingRegistrationTaskReports$ = [9, n0, _LTRTRis,
    { [_h]: ["GET", "/thing-registration-tasks/{taskId}/reports", 200] }, () => exports.ListThingRegistrationTaskReportsRequest$, () => exports.ListThingRegistrationTaskReportsResponse$
];
exports.ListThingRegistrationTasks$ = [9, n0, _LTRT,
    { [_h]: ["GET", "/thing-registration-tasks", 200] }, () => exports.ListThingRegistrationTasksRequest$, () => exports.ListThingRegistrationTasksResponse$
];
exports.ListThings$ = [9, n0, _LTi,
    { [_h]: ["GET", "/things", 200] }, () => exports.ListThingsRequest$, () => exports.ListThingsResponse$
];
exports.ListThingsInBillingGroup$ = [9, n0, _LTIBG,
    { [_h]: ["GET", "/billing-groups/{billingGroupName}/things", 200] }, () => exports.ListThingsInBillingGroupRequest$, () => exports.ListThingsInBillingGroupResponse$
];
exports.ListThingsInThingGroup$ = [9, n0, _LTITG,
    { [_h]: ["GET", "/thing-groups/{thingGroupName}/things", 200] }, () => exports.ListThingsInThingGroupRequest$, () => exports.ListThingsInThingGroupResponse$
];
exports.ListThingTypes$ = [9, n0, _LTT,
    { [_h]: ["GET", "/thing-types", 200] }, () => exports.ListThingTypesRequest$, () => exports.ListThingTypesResponse$
];
exports.ListTopicRuleDestinations$ = [9, n0, _LTRD,
    { [_h]: ["GET", "/destinations", 200] }, () => exports.ListTopicRuleDestinationsRequest$, () => exports.ListTopicRuleDestinationsResponse$
];
exports.ListTopicRules$ = [9, n0, _LTRis,
    { [_h]: ["GET", "/rules", 200] }, () => exports.ListTopicRulesRequest$, () => exports.ListTopicRulesResponse$
];
exports.ListV2LoggingLevels$ = [9, n0, _LVLL,
    { [_h]: ["GET", "/v2LoggingLevel", 200] }, () => exports.ListV2LoggingLevelsRequest$, () => exports.ListV2LoggingLevelsResponse$
];
exports.ListViolationEvents$ = [9, n0, _LVE,
    { [_h]: ["GET", "/violation-events", 200] }, () => exports.ListViolationEventsRequest$, () => exports.ListViolationEventsResponse$
];
exports.PutVerificationStateOnViolation$ = [9, n0, _PVSOV,
    { [_h]: ["POST", "/violations/verification-state/{violationId}", 200] }, () => exports.PutVerificationStateOnViolationRequest$, () => exports.PutVerificationStateOnViolationResponse$
];
exports.RegisterCACertificate$ = [9, n0, _RCAC,
    { [_h]: ["POST", "/cacertificate", 200] }, () => exports.RegisterCACertificateRequest$, () => exports.RegisterCACertificateResponse$
];
exports.RegisterCertificate$ = [9, n0, _RCeg,
    { [_h]: ["POST", "/certificate/register", 200] }, () => exports.RegisterCertificateRequest$, () => exports.RegisterCertificateResponse$
];
exports.RegisterCertificateWithoutCA$ = [9, n0, _RCWCA,
    { [_h]: ["POST", "/certificate/register-no-ca", 200] }, () => exports.RegisterCertificateWithoutCARequest$, () => exports.RegisterCertificateWithoutCAResponse$
];
exports.RegisterThing$ = [9, n0, _RT,
    { [_h]: ["POST", "/things", 200] }, () => exports.RegisterThingRequest$, () => exports.RegisterThingResponse$
];
exports.RejectCertificateTransfer$ = [9, n0, _RCT,
    { [_h]: ["PATCH", "/reject-certificate-transfer/{certificateId}", 200] }, () => exports.RejectCertificateTransferRequest$, () => __Unit
];
exports.RemoveThingFromBillingGroup$ = [9, n0, _RTFBG,
    { [_h]: ["PUT", "/billing-groups/removeThingFromBillingGroup", 200] }, () => exports.RemoveThingFromBillingGroupRequest$, () => exports.RemoveThingFromBillingGroupResponse$
];
exports.RemoveThingFromThingGroup$ = [9, n0, _RTFTG,
    { [_h]: ["PUT", "/thing-groups/removeThingFromThingGroup", 200] }, () => exports.RemoveThingFromThingGroupRequest$, () => exports.RemoveThingFromThingGroupResponse$
];
exports.ReplaceTopicRule$ = [9, n0, _RTRep,
    { [_h]: ["PATCH", "/rules/{ruleName}", 200] }, () => exports.ReplaceTopicRuleRequest$, () => __Unit
];
exports.SearchIndex$ = [9, n0, _SIe,
    { [_h]: ["POST", "/indices/search", 200] }, () => exports.SearchIndexRequest$, () => exports.SearchIndexResponse$
];
exports.SetDefaultAuthorizer$ = [9, n0, _SDA,
    { [_h]: ["POST", "/default-authorizer", 200] }, () => exports.SetDefaultAuthorizerRequest$, () => exports.SetDefaultAuthorizerResponse$
];
exports.SetDefaultPolicyVersion$ = [9, n0, _SDPV,
    { [_h]: ["PATCH", "/policies/{policyName}/version/{policyVersionId}", 200] }, () => exports.SetDefaultPolicyVersionRequest$, () => __Unit
];
exports.SetLoggingOptions$ = [9, n0, _SLO,
    { [_h]: ["POST", "/loggingOptions", 200] }, () => exports.SetLoggingOptionsRequest$, () => __Unit
];
exports.SetV2LoggingLevel$ = [9, n0, _SVLL,
    { [_h]: ["POST", "/v2LoggingLevel", 200] }, () => exports.SetV2LoggingLevelRequest$, () => __Unit
];
exports.SetV2LoggingOptions$ = [9, n0, _SVLO,
    { [_h]: ["POST", "/v2LoggingOptions", 200] }, () => exports.SetV2LoggingOptionsRequest$, () => __Unit
];
exports.StartAuditMitigationActionsTask$ = [9, n0, _SAMAT,
    { [_h]: ["POST", "/audit/mitigationactions/tasks/{taskId}", 200] }, () => exports.StartAuditMitigationActionsTaskRequest$, () => exports.StartAuditMitigationActionsTaskResponse$
];
exports.StartDetectMitigationActionsTask$ = [9, n0, _SDMAT,
    { [_h]: ["PUT", "/detect/mitigationactions/tasks/{taskId}", 200] }, () => exports.StartDetectMitigationActionsTaskRequest$, () => exports.StartDetectMitigationActionsTaskResponse$
];
exports.StartOnDemandAuditTask$ = [9, n0, _SODAT,
    { [_h]: ["POST", "/audit/tasks", 200] }, () => exports.StartOnDemandAuditTaskRequest$, () => exports.StartOnDemandAuditTaskResponse$
];
exports.StartThingRegistrationTask$ = [9, n0, _STRT,
    { [_h]: ["POST", "/thing-registration-tasks", 200] }, () => exports.StartThingRegistrationTaskRequest$, () => exports.StartThingRegistrationTaskResponse$
];
exports.StopThingRegistrationTask$ = [9, n0, _STRTt,
    { [_h]: ["PUT", "/thing-registration-tasks/{taskId}/cancel", 200] }, () => exports.StopThingRegistrationTaskRequest$, () => exports.StopThingRegistrationTaskResponse$
];
exports.TagResource$ = [9, n0, _TRa,
    { [_h]: ["POST", "/tags", 200] }, () => exports.TagResourceRequest$, () => exports.TagResourceResponse$
];
exports.TestAuthorization$ = [9, n0, _TAe,
    { [_h]: ["POST", "/test-authorization", 200] }, () => exports.TestAuthorizationRequest$, () => exports.TestAuthorizationResponse$
];
exports.TestInvokeAuthorizer$ = [9, n0, _TIA,
    { [_h]: ["POST", "/authorizer/{authorizerName}/test", 200] }, () => exports.TestInvokeAuthorizerRequest$, () => exports.TestInvokeAuthorizerResponse$
];
exports.TransferCertificate$ = [9, n0, _TCr,
    { [_h]: ["PATCH", "/transfer-certificate/{certificateId}", 200] }, () => exports.TransferCertificateRequest$, () => exports.TransferCertificateResponse$
];
exports.UntagResource$ = [9, n0, _UR,
    { [_h]: ["POST", "/untag", 200] }, () => exports.UntagResourceRequest$, () => exports.UntagResourceResponse$
];
exports.UpdateAccountAuditConfiguration$ = [9, n0, _UAAC,
    { [_h]: ["PATCH", "/audit/configuration", 200] }, () => exports.UpdateAccountAuditConfigurationRequest$, () => exports.UpdateAccountAuditConfigurationResponse$
];
exports.UpdateAuditSuppression$ = [9, n0, _UAS,
    { [_h]: ["PATCH", "/audit/suppressions/update", 200] }, () => exports.UpdateAuditSuppressionRequest$, () => exports.UpdateAuditSuppressionResponse$
];
exports.UpdateAuthorizer$ = [9, n0, _UA,
    { [_h]: ["PUT", "/authorizer/{authorizerName}", 200] }, () => exports.UpdateAuthorizerRequest$, () => exports.UpdateAuthorizerResponse$
];
exports.UpdateBillingGroup$ = [9, n0, _UBG,
    { [_h]: ["PATCH", "/billing-groups/{billingGroupName}", 200] }, () => exports.UpdateBillingGroupRequest$, () => exports.UpdateBillingGroupResponse$
];
exports.UpdateCACertificate$ = [9, n0, _UCAC,
    { [_h]: ["PUT", "/cacertificate/{certificateId}", 200] }, () => exports.UpdateCACertificateRequest$, () => __Unit
];
exports.UpdateCertificate$ = [9, n0, _UC,
    { [_h]: ["PUT", "/certificates/{certificateId}", 200] }, () => exports.UpdateCertificateRequest$, () => __Unit
];
exports.UpdateCertificateProvider$ = [9, n0, _UCP,
    { [_h]: ["PUT", "/certificate-providers/{certificateProviderName}", 200] }, () => exports.UpdateCertificateProviderRequest$, () => exports.UpdateCertificateProviderResponse$
];
exports.UpdateCommand$ = [9, n0, _UCp,
    { [_h]: ["PATCH", "/commands/{commandId}", 200] }, () => exports.UpdateCommandRequest$, () => exports.UpdateCommandResponse$
];
exports.UpdateCustomMetric$ = [9, n0, _UCM,
    { [_h]: ["PATCH", "/custom-metric/{metricName}", 200] }, () => exports.UpdateCustomMetricRequest$, () => exports.UpdateCustomMetricResponse$
];
exports.UpdateDimension$ = [9, n0, _UD,
    { [_h]: ["PATCH", "/dimensions/{name}", 200] }, () => exports.UpdateDimensionRequest$, () => exports.UpdateDimensionResponse$
];
exports.UpdateDomainConfiguration$ = [9, n0, _UDC,
    { [_h]: ["PUT", "/domainConfigurations/{domainConfigurationName}", 200] }, () => exports.UpdateDomainConfigurationRequest$, () => exports.UpdateDomainConfigurationResponse$
];
exports.UpdateDynamicThingGroup$ = [9, n0, _UDTG,
    { [_h]: ["PATCH", "/dynamic-thing-groups/{thingGroupName}", 200] }, () => exports.UpdateDynamicThingGroupRequest$, () => exports.UpdateDynamicThingGroupResponse$
];
exports.UpdateEncryptionConfiguration$ = [9, n0, _UEC,
    { [_h]: ["PATCH", "/encryption-configuration", 200] }, () => exports.UpdateEncryptionConfigurationRequest$, () => exports.UpdateEncryptionConfigurationResponse$
];
exports.UpdateEventConfigurations$ = [9, n0, _UECp,
    { [_h]: ["PATCH", "/event-configurations", 200] }, () => exports.UpdateEventConfigurationsRequest$, () => exports.UpdateEventConfigurationsResponse$
];
exports.UpdateFleetMetric$ = [9, n0, _UFM,
    { [_h]: ["PATCH", "/fleet-metric/{metricName}", 200] }, () => exports.UpdateFleetMetricRequest$, () => __Unit
];
exports.UpdateIndexingConfiguration$ = [9, n0, _UIC,
    { [_h]: ["POST", "/indexing/config", 200] }, () => exports.UpdateIndexingConfigurationRequest$, () => exports.UpdateIndexingConfigurationResponse$
];
exports.UpdateJob$ = [9, n0, _UJ,
    { [_h]: ["PATCH", "/jobs/{jobId}", 200] }, () => exports.UpdateJobRequest$, () => __Unit
];
exports.UpdateMitigationAction$ = [9, n0, _UMA,
    { [_h]: ["PATCH", "/mitigationactions/actions/{actionName}", 200] }, () => exports.UpdateMitigationActionRequest$, () => exports.UpdateMitigationActionResponse$
];
exports.UpdatePackage$ = [9, n0, _UPp,
    { [_h]: ["PATCH", "/packages/{packageName}", 200] }, () => exports.UpdatePackageRequest$, () => exports.UpdatePackageResponse$
];
exports.UpdatePackageConfiguration$ = [9, n0, _UPC,
    { [_h]: ["PATCH", "/package-configuration", 200] }, () => exports.UpdatePackageConfigurationRequest$, () => exports.UpdatePackageConfigurationResponse$
];
exports.UpdatePackageVersion$ = [9, n0, _UPV,
    { [_h]: ["PATCH", "/packages/{packageName}/versions/{versionName}", 200] }, () => exports.UpdatePackageVersionRequest$, () => exports.UpdatePackageVersionResponse$
];
exports.UpdateProvisioningTemplate$ = [9, n0, _UPT,
    { [_h]: ["PATCH", "/provisioning-templates/{templateName}", 200] }, () => exports.UpdateProvisioningTemplateRequest$, () => exports.UpdateProvisioningTemplateResponse$
];
exports.UpdateRoleAlias$ = [9, n0, _URA,
    { [_h]: ["PUT", "/role-aliases/{roleAlias}", 200] }, () => exports.UpdateRoleAliasRequest$, () => exports.UpdateRoleAliasResponse$
];
exports.UpdateScheduledAudit$ = [9, n0, _USA,
    { [_h]: ["PATCH", "/audit/scheduledaudits/{scheduledAuditName}", 200] }, () => exports.UpdateScheduledAuditRequest$, () => exports.UpdateScheduledAuditResponse$
];
exports.UpdateSecurityProfile$ = [9, n0, _USP,
    { [_h]: ["PATCH", "/security-profiles/{securityProfileName}", 200] }, () => exports.UpdateSecurityProfileRequest$, () => exports.UpdateSecurityProfileResponse$
];
exports.UpdateStream$ = [9, n0, _US,
    { [_h]: ["PUT", "/streams/{streamId}", 200] }, () => exports.UpdateStreamRequest$, () => exports.UpdateStreamResponse$
];
exports.UpdateThing$ = [9, n0, _UT,
    { [_h]: ["PATCH", "/things/{thingName}", 200] }, () => exports.UpdateThingRequest$, () => exports.UpdateThingResponse$
];
exports.UpdateThingGroup$ = [9, n0, _UTG,
    { [_h]: ["PATCH", "/thing-groups/{thingGroupName}", 200] }, () => exports.UpdateThingGroupRequest$, () => exports.UpdateThingGroupResponse$
];
exports.UpdateThingGroupsForThing$ = [9, n0, _UTGFT,
    { [_h]: ["PUT", "/thing-groups/updateThingGroupsForThing", 200] }, () => exports.UpdateThingGroupsForThingRequest$, () => exports.UpdateThingGroupsForThingResponse$
];
exports.UpdateThingType$ = [9, n0, _UTT,
    { [_h]: ["PATCH", "/thing-types/{thingTypeName}", 200] }, () => exports.UpdateThingTypeRequest$, () => exports.UpdateThingTypeResponse$
];
exports.UpdateTopicRuleDestination$ = [9, n0, _UTRD,
    { [_h]: ["PATCH", "/destinations", 200] }, () => exports.UpdateTopicRuleDestinationRequest$, () => exports.UpdateTopicRuleDestinationResponse$
];
exports.ValidateSecurityProfileBehaviors$ = [9, n0, _VSPB,
    { [_h]: ["POST", "/security-profile-behaviors/validate", 200] }, () => exports.ValidateSecurityProfileBehaviorsRequest$, () => exports.ValidateSecurityProfileBehaviorsResponse$
];
